var map = {
	"./adult/16x9/actors/actorFrame/actorFrame.svg": [
		820,
		9,
		3
	],
	"./adult/16x9/actors/astronautfactory/astronaut-landing-page-1.svg": [
		821,
		9,
		4
	],
	"./adult/16x9/actors/astronautfactory/astronaut-landing-page.svg": [
		822,
		9,
		5
	],
	"./adult/16x9/actors/backgroundLayers/background-forrestAdult1.svg": [
		823,
		9,
		6
	],
	"./adult/16x9/actors/backgroundLayers/background-forrestAdult2.svg": [
		824,
		9,
		7
	],
	"./adult/16x9/actors/backgroundLayers/background-forrestAdult3.svg": [
		825,
		9,
		8
	],
	"./adult/16x9/actors/backgroundLayers/background-forrestAdult4.svg": [
		826,
		9,
		9
	],
	"./adult/16x9/actors/backgroundLayers/background-forrestAdult5.svg": [
		827,
		9,
		10
	],
	"./adult/16x9/actors/backgroundLayers/background-grassDailyStoryAdult1.svg": [
		828,
		9,
		11
	],
	"./adult/16x9/actors/backgroundLayers/background-grassDailyStoryAdult2.svg": [
		829,
		7,
		12
	],
	"./adult/16x9/actors/backgroundLayers/background-grassDailyStoryAdult3.svg": [
		830,
		9,
		13
	],
	"./adult/16x9/actors/backgroundLayers/background-grassDailyStoryAdult4.svg": [
		831,
		9,
		14
	],
	"./adult/16x9/actors/backgroundLayers/background-grassDailyStoryAdult5.svg": [
		832,
		9,
		15
	],
	"./adult/16x9/actors/backgroundLayers/background-grassDailyStoryAdult6.svg": [
		833,
		9,
		16
	],
	"./adult/16x9/actors/backgroundLayers/background-hillsAdult1.svg": [
		834,
		9,
		17
	],
	"./adult/16x9/actors/backgroundLayers/background-hillsAdult2.svg": [
		835,
		9,
		18
	],
	"./adult/16x9/actors/backgroundLayers/background-hillsAdult3.svg": [
		836,
		9,
		19
	],
	"./adult/16x9/actors/backgroundLayers/background-hillsAdult4.svg": [
		837,
		9,
		20
	],
	"./adult/16x9/actors/backgroundLayers/background-hillsAdult5.svg": [
		838,
		9,
		21
	],
	"./adult/16x9/actors/backgroundLayers/background-mountainAdult1.svg": [
		839,
		9,
		22
	],
	"./adult/16x9/actors/backgroundLayers/background-mountainAdult2.svg": [
		840,
		9,
		23
	],
	"./adult/16x9/actors/backgroundLayers/background-mountainAdult3.svg": [
		841,
		9,
		24
	],
	"./adult/16x9/actors/backgroundLayers/background-mountainAdult4.svg": [
		842,
		9,
		25
	],
	"./adult/16x9/actors/backgroundLayers/background-mountainAdult5.svg": [
		843,
		9,
		26
	],
	"./adult/16x9/actors/brand/brand-logo.svg": [
		844,
		9,
		27
	],
	"./adult/16x9/actors/calf/calf-blaarkop-black.svg": [
		845,
		9,
		28
	],
	"./adult/16x9/actors/calf/calf-blaarkop-brown.svg": [
		846,
		9,
		29
	],
	"./adult/16x9/actors/calf/calf-holstein-black.svg": [
		847,
		9,
		30
	],
	"./adult/16x9/actors/calf/calf-holstein-brown.svg": [
		848,
		9,
		31
	],
	"./adult/16x9/actors/calf/calf-holstein-rainbow.svg": [
		849,
		9,
		32
	],
	"./adult/16x9/actors/calf/calf-holstein-white.svg": [
		850,
		9,
		33
	],
	"./adult/16x9/actors/calf/calf-jersey-brown.svg": [
		851,
		9,
		34
	],
	"./adult/16x9/actors/calf/calf-jersey-white.svg": [
		852,
		9,
		35
	],
	"./adult/16x9/actors/calf/calf-lakenvelder-black.svg": [
		853,
		9,
		36
	],
	"./adult/16x9/actors/calf/calf-lakenvelder-brown.svg": [
		854,
		9,
		37
	],
	"./adult/16x9/actors/calf/calf-maas-rijn-brown.svg": [
		855,
		9,
		38
	],
	"./adult/16x9/actors/cat/cat_appearing.svg": [
		856,
		9,
		39
	],
	"./adult/16x9/actors/cat/cat_disappearing.svg": [
		857,
		9,
		40
	],
	"./adult/16x9/actors/cat/poof_sprite.svg": [
		858,
		9,
		41
	],
	"./adult/16x9/actors/cheesefactory/cheese-factory.svg": [
		859,
		9,
		42
	],
	"./adult/16x9/actors/cow/body/cow-friesian.svg": [
		860,
		9,
		43
	],
	"./adult/16x9/actors/cow/body/cow-holstein.svg": [
		861,
		9,
		44
	],
	"./adult/16x9/actors/cow/body/cow-jersey.svg": [
		862,
		9,
		45
	],
	"./adult/16x9/actors/cow/body/cow-pride.svg": [
		863,
		9,
		46
	],
	"./adult/16x9/actors/cow/body/cow-whiteBlack.svg": [
		864,
		9,
		47
	],
	"./adult/16x9/actors/cow/heads/cow-list-popup-head-1.svg": [
		865,
		9,
		48
	],
	"./adult/16x9/actors/cow/heads/cow-list-popup-head-10.svg": [
		866,
		9,
		49
	],
	"./adult/16x9/actors/cow/heads/cow-list-popup-head-11.svg": [
		867,
		9,
		50
	],
	"./adult/16x9/actors/cow/heads/cow-list-popup-head-2.svg": [
		868,
		9,
		51
	],
	"./adult/16x9/actors/cow/heads/cow-list-popup-head-3.svg": [
		869,
		9,
		52
	],
	"./adult/16x9/actors/cow/heads/cow-list-popup-head-4.svg": [
		870,
		9,
		53
	],
	"./adult/16x9/actors/cow/heads/cow-list-popup-head-5.svg": [
		871,
		9,
		54
	],
	"./adult/16x9/actors/cow/heads/cow-list-popup-head-6.svg": [
		872,
		9,
		55
	],
	"./adult/16x9/actors/cow/heads/cow-list-popup-head-7.svg": [
		873,
		9,
		56
	],
	"./adult/16x9/actors/cow/heads/cow-list-popup-head-8.svg": [
		874,
		9,
		57
	],
	"./adult/16x9/actors/cow/heads/cow-list-popup-head-9.svg": [
		875,
		9,
		58
	],
	"./adult/16x9/actors/cow/popup/heads/cow-list-popup-head-blaarkop-black.svg": [
		876,
		9,
		59
	],
	"./adult/16x9/actors/cow/popup/heads/cow-list-popup-head-blaarkop-brown.svg": [
		877,
		9,
		60
	],
	"./adult/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-black.svg": [
		878,
		9,
		61
	],
	"./adult/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-brown.svg": [
		879,
		9,
		62
	],
	"./adult/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-rainbow.svg": [
		880,
		9,
		63
	],
	"./adult/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-white.svg": [
		881,
		9,
		64
	],
	"./adult/16x9/actors/cow/popup/heads/cow-list-popup-head-jersey-brown.svg": [
		882,
		9,
		65
	],
	"./adult/16x9/actors/cow/popup/heads/cow-list-popup-head-jersey-white.svg": [
		883,
		9,
		66
	],
	"./adult/16x9/actors/cow/popup/heads/cow-list-popup-head-lakenvelder-black.svg": [
		884,
		9,
		67
	],
	"./adult/16x9/actors/cow/popup/heads/cow-list-popup-head-lakenvelder-brown.svg": [
		885,
		9,
		68
	],
	"./adult/16x9/actors/cow/popup/heads/cow-list-popup-head-maasRijn-brown.svg": [
		886,
		9,
		69
	],
	"./adult/16x9/actors/cow/virtualFarmAvatars/adultThemeCow.svg": [
		887,
		9,
		70
	],
	"./adult/16x9/actors/cow/virtualFarmAvatars/cow-maas-rijn.svg": [
		888,
		9,
		71
	],
	"./adult/16x9/actors/cow/virtualFarmAvatars/cowBlaarkop--one.svg": [
		889,
		9,
		72
	],
	"./adult/16x9/actors/cow/virtualFarmAvatars/cowBlaarkop--two.svg": [
		890,
		9,
		73
	],
	"./adult/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--one.svg": [
		891,
		9,
		74
	],
	"./adult/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--three.svg": [
		892,
		9,
		75
	],
	"./adult/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--two.svg": [
		893,
		9,
		76
	],
	"./adult/16x9/actors/cow/virtualFarmAvatars/cowJersey--one.svg": [
		894,
		9,
		77
	],
	"./adult/16x9/actors/cow/virtualFarmAvatars/cowJersey--two.svg": [
		895,
		9,
		78
	],
	"./adult/16x9/actors/cow/virtualFarmAvatars/cowLakenvelder--one.svg": [
		896,
		9,
		79
	],
	"./adult/16x9/actors/cow/virtualFarmAvatars/cowLakenvelder--two.svg": [
		897,
		9,
		80
	],
	"./adult/16x9/actors/cow/virtualFarmAvatars/cowMaasRijn--one.svg": [
		898,
		9,
		81
	],
	"./adult/16x9/actors/cow/virtualFarmAvatars/cowPride--one.svg": [
		899,
		9,
		82
	],
	"./adult/16x9/actors/dairyfactory/dairy-robot-factory.svg": [
		900,
		9,
		83
	],
	"./adult/16x9/actors/discovery/cow_excrement_brown.svg": [
		901,
		9,
		84
	],
	"./adult/16x9/actors/discovery/cow_excrement_rainbow.svg": [
		902,
		9,
		85
	],
	"./adult/16x9/actors/discovery/discoveryRobot.svg": [
		903,
		9,
		86
	],
	"./adult/16x9/actors/discovery/discoveryRobotSprite.svg": [
		904,
		9,
		87
	],
	"./adult/16x9/actors/discovery/discoveryRobotSw.svg": [
		905,
		9,
		88
	],
	"./adult/16x9/actors/discovery/discoveryRobot_adult_moveBottomEdge.svg": [
		906,
		9,
		89
	],
	"./adult/16x9/actors/discovery/discoveryRobot_adult_moveLeftEdge.svg": [
		907,
		9,
		90
	],
	"./adult/16x9/actors/discovery/discoveryRobot_adult_moveRightEdge.svg": [
		908,
		9,
		91
	],
	"./adult/16x9/actors/discovery/discoveryRobot_adult_moveTopEdge.svg": [
		909,
		9,
		92
	],
	"./adult/16x9/actors/discovery/discoveryRobot_moveBottomEdge.svg": [
		910,
		9,
		93
	],
	"./adult/16x9/actors/discovery/discoveryRobot_moveLeftEdge.svg": [
		911,
		9,
		94
	],
	"./adult/16x9/actors/discovery/discoveryRobot_moveRightEdge.svg": [
		912,
		9,
		95
	],
	"./adult/16x9/actors/discovery/discoveryRobot_moveTopEdge.svg": [
		913,
		9,
		96
	],
	"./adult/16x9/actors/discoveryssw90/discoveryRobot_moveBottomEdge.svg": [
		914,
		9,
		97
	],
	"./adult/16x9/actors/discoveryssw90/discoveryRobot_moveLeftEdge.svg": [
		915,
		9,
		98
	],
	"./adult/16x9/actors/discoveryssw90/discoveryRobot_moveRightEdge.svg": [
		916,
		9,
		99
	],
	"./adult/16x9/actors/discoveryssw90/discoveryRobot_moveTopEdge.svg": [
		917,
		9,
		100
	],
	"./adult/16x9/actors/farmer/farmer-female.svg": [
		918,
		9,
		101
	],
	"./adult/16x9/actors/farmer/farmer-male.svg": [
		919,
		9,
		102
	],
	"./adult/16x9/actors/grazeway/grazeway-door.svg": [
		920,
		9,
		103
	],
	"./adult/16x9/actors/grazeway/grazeway-feature.svg": [
		921,
		9,
		104
	],
	"./adult/16x9/actors/icecreamfactory/ice-cream-factory.svg": [
		922,
		9,
		105
	],
	"./adult/16x9/actors/juno/juno_back.svg": [
		923,
		9,
		106
	],
	"./adult/16x9/actors/juno/juno_front.svg": [
		924,
		9,
		107
	],
	"./adult/16x9/actors/luna/lunaRobot.svg": [
		925,
		9,
		108
	],
	"./adult/16x9/actors/mijnMelk/mijnMelk.svg": [
		926,
		9,
		109
	],
	"./adult/16x9/actors/milkbottle/milkBottle.svg": [
		927,
		9,
		110
	],
	"./adult/16x9/actors/milkbottle/waveMilk.svg": [
		928,
		9,
		111
	],
	"./adult/16x9/actors/milkfactory/milk-factory-new.svg": [
		929,
		9,
		112
	],
	"./adult/16x9/actors/milkfactory/milk-factory.svg": [
		930,
		9,
		113
	],
	"./adult/16x9/actors/milkfactory/orbiter_animation.svg": [
		931,
		9,
		114
	],
	"./adult/16x9/actors/pet/pet--adult--bigDog.svg": [
		932,
		9,
		115
	],
	"./adult/16x9/actors/pet/pet--adult--cat.svg": [
		933,
		9,
		116
	],
	"./adult/16x9/actors/pet/pet--adult--chicken.svg": [
		934,
		9,
		117
	],
	"./adult/16x9/actors/pet/pet--adult--mediumDog.svg": [
		935,
		9,
		118
	],
	"./adult/16x9/actors/pet/pet--adult--smallDog.svg": [
		936,
		9,
		119
	],
	"./adult/16x9/actors/pet/pet--alpaca.svg": [
		937,
		9,
		120
	],
	"./adult/16x9/actors/pet/pet--bigDog.svg": [
		938,
		9,
		121
	],
	"./adult/16x9/actors/pet/pet--cat.svg": [
		939,
		9,
		122
	],
	"./adult/16x9/actors/pet/pet--chicken.svg": [
		940,
		9,
		123
	],
	"./adult/16x9/actors/pet/pet--donkey.svg": [
		941,
		9,
		124
	],
	"./adult/16x9/actors/pet/pet--goat.svg": [
		942,
		9,
		125
	],
	"./adult/16x9/actors/pet/pet--horse.svg": [
		943,
		9,
		126
	],
	"./adult/16x9/actors/pet/pet--llama.svg": [
		944,
		9,
		127
	],
	"./adult/16x9/actors/pet/pet--mediumDog.svg": [
		945,
		9,
		128
	],
	"./adult/16x9/actors/pet/pet--pony.svg": [
		946,
		9,
		129
	],
	"./adult/16x9/actors/pet/pet--sheep.svg": [
		947,
		9,
		130
	],
	"./adult/16x9/actors/pet/pet--smallDog.svg": [
		948,
		9,
		131
	],
	"./adult/16x9/actors/shop/shop.svg": [
		949,
		9,
		132
	],
	"./adult/16x9/actors/shop/shop_adult.svg": [
		950,
		9,
		133
	],
	"./adult/16x9/actors/solarPanel/solarPanel.svg": [
		951,
		9,
		134
	],
	"./adult/16x9/actors/solarPanel/solarPanelPopupImage.svg": [
		952,
		9,
		135
	],
	"./adult/16x9/actors/sustainabilityFarm/sustainability.svg": [
		953,
		9,
		136
	],
	"./adult/16x9/actors/sustainabilityFarm/sustainabilityPopup.jpg": [
		954,
		7,
		137
	],
	"./adult/16x9/actors/sustainabilityFarm/sustainabilityPopupImage.jpg": [
		955,
		7,
		138
	],
	"./adult/16x9/actors/sustainabilityFarm/sustainabilityPopupImage.svg": [
		956,
		9,
		139
	],
	"./adult/16x9/actors/tractor/tractor.svg": [
		957,
		9,
		140
	],
	"./adult/16x9/actors/vector/vector.svg": [
		958,
		9,
		141
	],
	"./adult/16x9/actors/vector/vector_back.svg": [
		959,
		9,
		142
	],
	"./adult/16x9/adminpanel/cowBreed/cow-blaarkop-one.svg": [
		960,
		9,
		143
	],
	"./adult/16x9/adminpanel/cowBreed/cow-blaarkop-two.svg": [
		961,
		9,
		144
	],
	"./adult/16x9/adminpanel/cowBreed/cow-holstein-friesian-one.svg": [
		962,
		9,
		145
	],
	"./adult/16x9/adminpanel/cowBreed/cow-holstein-friesian-three.svg": [
		963,
		9,
		146
	],
	"./adult/16x9/adminpanel/cowBreed/cow-holstein-friesian-two.svg": [
		964,
		9,
		147
	],
	"./adult/16x9/adminpanel/cowBreed/cow-jersey-one.svg": [
		965,
		9,
		148
	],
	"./adult/16x9/adminpanel/cowBreed/cow-jersey-two.svg": [
		966,
		9,
		149
	],
	"./adult/16x9/adminpanel/cowBreed/cow-lakenvelder-one.svg": [
		967,
		9,
		150
	],
	"./adult/16x9/adminpanel/cowBreed/cow-lakenvelder-two.svg": [
		968,
		9,
		151
	],
	"./adult/16x9/adminpanel/cowBreed/cow-maas-rijn.svg": [
		969,
		9,
		152
	],
	"./adult/16x9/adminpanel/cowBreed/cow-pride-one.svg": [
		970,
		9,
		153
	],
	"./adult/16x9/adminpanel/cowPreview/cow-preview-black-stryped.svg": [
		971,
		9,
		154
	],
	"./adult/16x9/adminpanel/cowPreview/cow-preview-black-whiteBlack.svg": [
		972,
		9,
		155
	],
	"./adult/16x9/adminpanel/cowPreview/cow-preview-brown.svg": [
		973,
		9,
		156
	],
	"./adult/16x9/adminpanel/cowPreview/cow-preview-large-pride.svg": [
		974,
		9,
		157
	],
	"./adult/16x9/adminpanel/cowPreview/cow-preview-pride.svg": [
		975,
		9,
		158
	],
	"./adult/16x9/adminpanel/cowPreview/cow-preview-white.svg": [
		976,
		9,
		159
	],
	"./adult/16x9/adminpanel/dogSize/radio-large-dog.svg": [
		977,
		9,
		160
	],
	"./adult/16x9/adminpanel/dogSize/radio-medium-dog.svg": [
		978,
		9,
		161
	],
	"./adult/16x9/adminpanel/dogSize/radio-small-dog.svg": [
		979,
		9,
		162
	],
	"./adult/16x9/adminpanel/farmFeatureCheckbox/astronaut-checkbox-feature.svg": [
		980,
		9,
		163
	],
	"./adult/16x9/adminpanel/farmFeatureCheckbox/calm-checkbox-feature.svg": [
		981,
		9,
		164
	],
	"./adult/16x9/adminpanel/farmFeatureCheckbox/collector-checkbox-feature.svg": [
		982,
		9,
		165
	],
	"./adult/16x9/adminpanel/farmFeatureCheckbox/discovery-90.svg": [
		983,
		9,
		166
	],
	"./adult/16x9/adminpanel/farmFeatureCheckbox/discovery-mobile-feature.svg": [
		984,
		9,
		167
	],
	"./adult/16x9/adminpanel/farmFeatureCheckbox/grazeway-checkbox-feature.svg": [
		985,
		9,
		168
	],
	"./adult/16x9/adminpanel/farmFeatureCheckbox/luna-checkbox-feature.svg": [
		986,
		9,
		169
	],
	"./adult/16x9/adminpanel/farmFeatureCheckbox/luna-checkbox-mobile-feature.svg": [
		987,
		9,
		170
	],
	"./adult/16x9/adminpanel/farmFeatureCheckbox/orbiter-checkbox-feature.svg": [
		988,
		9,
		171
	],
	"./adult/16x9/adminpanel/farmFeatureCheckbox/vector-checkbox-feature.svg": [
		989,
		9,
		172
	],
	"./adult/16x9/adminpanel/farmFeatures/mobile-phone-admin-panel.svg": [
		990,
		9,
		173
	],
	"./adult/16x9/adminpanel/farmStyles/farmStyleOne.svg": [
		991,
		9,
		174
	],
	"./adult/16x9/adminpanel/farmStyles/farmStyleThree.svg": [
		992,
		9,
		175
	],
	"./adult/16x9/adminpanel/farmStyles/farmStyleTwo.svg": [
		993,
		9,
		176
	],
	"./adult/16x9/adminpanel/farmerStyle/radio-farmer-female.svg": [
		994,
		9,
		177
	],
	"./adult/16x9/adminpanel/farmerStyle/radio-farmer-male.svg": [
		995,
		9,
		178
	],
	"./adult/16x9/adminpanel/hide/hide-2.svg": [
		996,
		9,
		179
	],
	"./adult/16x9/adminpanel/hide/hide-3.svg": [
		997,
		9,
		180
	],
	"./adult/16x9/adminpanel/hide/hide-4.svg": [
		998,
		9,
		181
	],
	"./adult/16x9/adminpanel/hide/hide-5.svg": [
		999,
		9,
		182
	],
	"./adult/16x9/adminpanel/hide/hide-6.svg": [
		1000,
		9,
		183
	],
	"./adult/16x9/adminpanel/hide/hide-7.svg": [
		1001,
		9,
		184
	],
	"./adult/16x9/adminpanel/hide/hide-8.svg": [
		1002,
		9,
		185
	],
	"./adult/16x9/adminpanel/hide/hide-none.svg": [
		1003,
		9,
		186
	],
	"./adult/16x9/adminpanel/login/login-page-background.svg": [
		1004,
		9,
		187
	],
	"./adult/16x9/adminpanel/otherAnimal/radio-alpaca.svg": [
		1005,
		9,
		188
	],
	"./adult/16x9/adminpanel/otherAnimal/radio-cat.svg": [
		1006,
		9,
		189
	],
	"./adult/16x9/adminpanel/otherAnimal/radio-chicken.svg": [
		1007,
		9,
		190
	],
	"./adult/16x9/adminpanel/otherAnimal/radio-donkey.svg": [
		1008,
		9,
		191
	],
	"./adult/16x9/adminpanel/otherAnimal/radio-goat.svg": [
		1009,
		9,
		192
	],
	"./adult/16x9/adminpanel/otherAnimal/radio-horse.svg": [
		1010,
		9,
		193
	],
	"./adult/16x9/adminpanel/otherAnimal/radio-llama.svg": [
		1011,
		9,
		194
	],
	"./adult/16x9/adminpanel/otherAnimal/radio-pony.svg": [
		1012,
		9,
		195
	],
	"./adult/16x9/adminpanel/otherAnimal/radio-sheep.svg": [
		1013,
		9,
		196
	],
	"./adult/16x9/adminpanel/producingDevice/radio-cheese.svg": [
		1014,
		9,
		197
	],
	"./adult/16x9/adminpanel/producingDevice/radio-dairy.svg": [
		1015,
		9,
		198
	],
	"./adult/16x9/adminpanel/producingDevice/radio-dairy2.svg": [
		1016,
		9,
		199
	],
	"./adult/16x9/adminpanel/producingDevice/radio-icecream.svg": [
		1017,
		9,
		200
	],
	"./adult/16x9/adminpanel/producingDevice/radio-orbiter.svg": [
		1018,
		9,
		201
	],
	"./adult/16x9/adminpanel/story/sample_story_slide.svg": [
		1019,
		9,
		202
	],
	"./adult/16x9/popups/astronaut/cow--astronaut--robot.svg": [
		1020,
		9,
		203
	],
	"./adult/16x9/popups/calmrobot/calm-robot-popup.svg": [
		1021,
		9,
		204
	],
	"./adult/16x9/popups/calmrobot/calm-robot.svg": [
		1022,
		9,
		205
	],
	"./adult/16x9/popups/cheesefactory/cheese-factory-popup.svg": [
		1023,
		9,
		206
	],
	"./adult/16x9/popups/cow/cow-head-blaarkop-one.svg": [
		1024,
		9,
		207
	],
	"./adult/16x9/popups/cow/cow-head-blaarkop-two.svg": [
		1025,
		9,
		208
	],
	"./adult/16x9/popups/cow/cow-head-holstein-one.svg": [
		1026,
		9,
		209
	],
	"./adult/16x9/popups/cow/cow-head-holstein-three.svg": [
		1027,
		9,
		210
	],
	"./adult/16x9/popups/cow/cow-head-holstein-two.svg": [
		1028,
		9,
		211
	],
	"./adult/16x9/popups/cow/cow-head-jersey-one.svg": [
		1029,
		9,
		212
	],
	"./adult/16x9/popups/cow/cow-head-jersey-two.svg": [
		1030,
		9,
		213
	],
	"./adult/16x9/popups/cow/cow-head-lakenvelder-one.svg": [
		1031,
		9,
		214
	],
	"./adult/16x9/popups/cow/cow-head-lakenvelder-two.svg": [
		1032,
		9,
		215
	],
	"./adult/16x9/popups/cow/cow-head-pride.svg": [
		1033,
		9,
		216
	],
	"./adult/16x9/popups/cow/cow-head-rijn-one.svg": [
		1034,
		9,
		217
	],
	"./adult/16x9/popups/cow/cow-popup-head-2.svg": [
		1035,
		9,
		218
	],
	"./adult/16x9/popups/cow/cow-popup-head-3.svg": [
		1036,
		9,
		219
	],
	"./adult/16x9/popups/cow/cow-popup-intro.svg": [
		1037,
		9,
		220
	],
	"./adult/16x9/popups/cow/cow-popup.svg": [
		1038,
		9,
		221
	],
	"./adult/16x9/popups/cow/cowNameChosenParty.svg": [
		1039,
		9,
		222
	],
	"./adult/16x9/popups/cow/namePollBackground.svg": [
		1040,
		9,
		223
	],
	"./adult/16x9/popups/cow/namePollPartyFlute.svg": [
		1041,
		9,
		224
	],
	"./adult/16x9/popups/cow/namePollPartyHat.svg": [
		1042,
		9,
		225
	],
	"./adult/16x9/popups/cow/nameVotePopupBackground.png": [
		1043,
		7,
		226
	],
	"./adult/16x9/popups/cowlist/cow-list-popup-head-1.svg": [
		1044,
		9,
		227
	],
	"./adult/16x9/popups/cowlist/cow-list-popup-head-2.svg": [
		1045,
		9,
		228
	],
	"./adult/16x9/popups/cowlist/cow-list-popup-head-3.svg": [
		1046,
		9,
		229
	],
	"./adult/16x9/popups/cowlist/cow-list-popup-head-4.svg": [
		1047,
		9,
		230
	],
	"./adult/16x9/popups/dairy/dairy--popup--roboto.svg": [
		1048,
		9,
		231
	],
	"./adult/16x9/popups/discovery/discovery-popup-image.svg": [
		1049,
		9,
		232
	],
	"./adult/16x9/popups/discoverySW/discoverySW.svg": [
		1050,
		9,
		233
	],
	"./adult/16x9/popups/grazeway/grazeway--robot--popup.svg": [
		1051,
		9,
		234
	],
	"./adult/16x9/popups/icecreamfactory/icecream-factory-popup.svg": [
		1052,
		9,
		235
	],
	"./adult/16x9/popups/lelyBrand/lelyBrandLogo.svg": [
		1053,
		9,
		236
	],
	"./adult/16x9/popups/livedata/liveDataArrow.svg": [
		1054,
		9,
		237
	],
	"./adult/16x9/popups/livedata/liveDataPopupBackground.svg": [
		1055,
		9,
		238
	],
	"./adult/16x9/popups/livedata/liveIcon.svg": [
		1056,
		9,
		239
	],
	"./adult/16x9/popups/luna/luna.svg": [
		1057,
		9,
		240
	],
	"./adult/16x9/popups/orbiter/orbiter-popup-image.svg": [
		1058,
		9,
		241
	],
	"./adult/16x9/popups/pet/dog-Popup-image.svg": [
		1059,
		9,
		242
	],
	"./adult/16x9/popups/rumination/cow--rumination.svg": [
		1060,
		9,
		243
	],
	"./adult/16x9/popups/tour/arrow-popup-arrow-part.svg": [
		1061,
		9,
		244
	],
	"./adult/16x9/popups/tour/arrow-popup-background-part.svg": [
		1062,
		9,
		245
	],
	"./adult/16x9/popups/tour/arrow-right-button.svg": [
		1063,
		9,
		246
	],
	"./adult/16x9/popups/tour/full-farm.svg": [
		1064,
		9,
		247
	],
	"./adult/16x9/popups/vector/vector--robot--image.svg": [
		1065,
		9,
		248
	],
	"./adult/16x9/popups/vehicle/red-tractor.svg": [
		1066,
		9,
		249
	],
	"./adult/16x9/screens/ageSelection/age-selection-above-10.svg": [
		1067,
		9,
		250
	],
	"./adult/16x9/screens/ageSelection/age-selection-under-10.svg": [
		1068,
		9,
		251
	],
	"./adult/16x9/screens/ageSelection/background-screen-select-age.svg": [
		1069,
		9,
		252
	],
	"./adult/16x9/screens/cowBarn/barn.svg": [
		1070,
		9,
		253
	],
	"./adult/16x9/screens/cowBirth/cow-birth-first-slide.svg": [
		1071,
		9,
		254
	],
	"./adult/16x9/screens/cowBirthday/calm-slide-calf.svg": [
		1072,
		9,
		255
	],
	"./adult/16x9/screens/cowBirthday/cloud-temperature-logo.svg": [
		1073,
		9,
		256
	],
	"./adult/16x9/screens/cowBirthday/cloud.svg": [
		1074,
		9,
		257
	],
	"./adult/16x9/screens/cowBirthday/cow-birth-first-page.svg": [
		1075,
		9,
		258
	],
	"./adult/16x9/screens/cowBox/box.svg": [
		1076,
		9,
		259
	],
	"./adult/16x9/screens/cowCalmRobot/arrow-left-curve.svg": [
		1077,
		9,
		260
	],
	"./adult/16x9/screens/cowCalmRobot/calm-slide-calf.svg": [
		1078,
		9,
		261
	],
	"./adult/16x9/screens/cowCalmRobot/calmRobot.svg": [
		1079,
		9,
		262
	],
	"./adult/16x9/screens/cowCalmRobot/cow-calm-slide-button.svg": [
		1080,
		9,
		263
	],
	"./adult/16x9/screens/cowCalmRobot/cow-calm-slide.svg": [
		1081,
		9,
		264
	],
	"./adult/16x9/screens/cowFirstBirthday/cow-first-birthday-slide-whistle.svg": [
		1082,
		9,
		265
	],
	"./adult/16x9/screens/cowFirstBirthday/cow-first-birthday.svg": [
		1083,
		9,
		266
	],
	"./adult/16x9/screens/cowFirstMilking/cow-first-calf.svg": [
		1084,
		9,
		267
	],
	"./adult/16x9/screens/cowFirstMilking/cow-first-milking-button.svg": [
		1085,
		9,
		268
	],
	"./adult/16x9/screens/cowFirstMilking/cow-first-milking-slide.svg": [
		1086,
		9,
		269
	],
	"./adult/16x9/screens/cowFirstYear/calm-slide-calf.svg": [
		1087,
		9,
		270
	],
	"./adult/16x9/screens/cowFirstYear/cow-first-year-slide.svg": [
		1088,
		9,
		271
	],
	"./adult/16x9/screens/cowGaveBirth/cow-gave-birth-button.svg": [
		1089,
		9,
		272
	],
	"./adult/16x9/screens/cowGaveBirthFourthSlide/cow-gave-birth-fourth-slide.svg": [
		1090,
		9,
		273
	],
	"./adult/16x9/screens/cowGaveBirthFourthSlide/milk-bottles.svg": [
		1091,
		9,
		274
	],
	"./adult/16x9/screens/cowGaveBirthSecondSlide/cow-gave-birth.svg": [
		1092,
		9,
		275
	],
	"./adult/16x9/screens/cowIntro/cow-intro-page.svg": [
		1093,
		9,
		276
	],
	"./adult/16x9/screens/cowIntro/cow-intro-second-slide.svg": [
		1094,
		9,
		277
	],
	"./adult/16x9/screens/cowMilking/milking.svg": [
		1095,
		9,
		278
	],
	"./adult/16x9/screens/cowOutro/CowOutroBottomArrow.svg": [
		1096,
		9,
		279
	],
	"./adult/16x9/screens/cowOutro/CowOutroPageBackground.svg": [
		1097,
		9,
		280
	],
	"./adult/16x9/screens/cowOutro/CowOutroRightArrowText.svg": [
		1098,
		9,
		281
	],
	"./adult/16x9/screens/cowOutro/leftButtonCowOutroPage.svg": [
		1099,
		9,
		282
	],
	"./adult/16x9/screens/cowOutro/rightButtonCowOutroPage.svg": [
		1100,
		9,
		283
	],
	"./adult/16x9/screens/cowParent/arrow-down-to-the-parent.svg": [
		1101,
		9,
		284
	],
	"./adult/16x9/screens/cowParent/arrow-to-the-parent.svg": [
		1102,
		9,
		285
	],
	"./adult/16x9/screens/cowParent/cow-father-info.svg": [
		1103,
		9,
		286
	],
	"./adult/16x9/screens/cowParent/cow-mother-info.svg": [
		1104,
		9,
		287
	],
	"./adult/16x9/screens/cowParent/left-line-to-the-cow.svg": [
		1105,
		9,
		288
	],
	"./adult/16x9/screens/cowParent/line-to-the-parents.svg": [
		1106,
		9,
		289
	],
	"./adult/16x9/screens/virtualFarm/background.svg": [
		1107,
		9,
		290
	],
	"./adult/16x9/screens/virtualFarm/background_animal_fence.svg": [
		1108,
		9,
		291
	],
	"./adult/16x9/screens/virtualFarm/background_barn_left_part.svg": [
		1109,
		9,
		292
	],
	"./adult/16x9/screens/virtualFarm/background_barn_production.svg": [
		1110,
		9,
		293
	],
	"./adult/16x9/screens/virtualFarm/background_bus.svg": [
		1111,
		9,
		294
	],
	"./adult/16x9/screens/virtualFarm/background_farm_hill.svg": [
		1112,
		9,
		295
	],
	"./adult/16x9/screens/virtualFarm/background_farm_house.svg": [
		1113,
		9,
		296
	],
	"./adult/16x9/screens/virtualFarm/background_farm_house_style2.svg": [
		1114,
		9,
		297
	],
	"./adult/16x9/screens/virtualFarm/background_farm_house_style3.svg": [
		1115,
		9,
		298
	],
	"./adult/16x9/screens/virtualFarm/background_farm_overview_812x375.svg": [
		1116,
		9,
		299
	],
	"./adult/16x9/screens/virtualFarm/background_farm_right_street.svg": [
		1117,
		9,
		300
	],
	"./adult/16x9/screens/virtualFarm/background_farm_right_street2.svg": [
		1118,
		9,
		301
	],
	"./adult/16x9/screens/virtualFarm/background_new.svg": [
		1119,
		9,
		302
	],
	"./adult/16x9/screens/virtualFarm/fence.svg": [
		1120,
		9,
		303
	],
	"./adult/16x9/screens/welcomePage/background-welcome-page.svg": [
		1121,
		9,
		304
	],
	"./adult/16x9/screens/welcomePage/cow-head.svg": [
		1122,
		9,
		305
	],
	"./adult/16x9/stories/astronautLiveDataStory/arrow.svg": [
		1123,
		9,
		306
	],
	"./adult/16x9/stories/astronautLiveDataStory/arrowBetweenSlides.svg": [
		1124,
		9,
		307
	],
	"./adult/16x9/stories/astronautLiveDataStory/arrowConnectingText.svg": [
		1125,
		9,
		308
	],
	"./adult/16x9/stories/astronautLiveDataStory/astronautLiveDataBackgroundWithTree.svg": [
		1126,
		9,
		309
	],
	"./adult/16x9/stories/astronautLiveDataStory/astronautLiveDataBigCow.svg": [
		1127,
		9,
		310
	],
	"./adult/16x9/stories/astronautLiveDataStory/astronautLiveDataStoryBetweenMatrixCowAndTeetAnimation.svg": [
		1128,
		9,
		311
	],
	"./adult/16x9/stories/astronautLiveDataStory/astronautLiveDataStorySelectionTriangle.svg": [
		1129,
		9,
		312
	],
	"./adult/16x9/stories/astronautLiveDataStory/astronautLiveDataTeetAnimationSlideArrow.svg": [
		1130,
		9,
		313
	],
	"./adult/16x9/stories/astronautLiveDataStory/astronautLiveDataTimeMilkedBackground.svg": [
		1131,
		9,
		314
	],
	"./adult/16x9/stories/astronautLiveDataStory/astronautLiveDataTimeMilkedMixedBackground.svg": [
		1132,
		9,
		315
	],
	"./adult/16x9/stories/astronautLiveDataStory/backgroundAstronautLiveData.svg": [
		1133,
		9,
		316
	],
	"./adult/16x9/stories/astronautLiveDataStory/backgroundMixBetweenMilkAndMatrix.svg": [
		1134,
		9,
		317
	],
	"./adult/16x9/stories/astronautLiveDataStory/connectionArrows.svg": [
		1135,
		9,
		318
	],
	"./adult/16x9/stories/astronautLiveDataStory/matrixConnectionBetweenTextBoxes.svg": [
		1136,
		9,
		319
	],
	"./adult/16x9/stories/astronautLiveDataStory/matrixCows.svg": [
		1137,
		9,
		320
	],
	"./adult/16x9/stories/astronautLiveDataStory/matrixMilkBottle.svg": [
		1138,
		9,
		321
	],
	"./adult/16x9/stories/astronautLiveDataStory/matrixMilkBottles.svg": [
		1139,
		9,
		322
	],
	"./adult/16x9/stories/astronautLiveDataStory/smallMilkBottle.svg": [
		1140,
		9,
		323
	],
	"./adult/16x9/stories/astronautLiveDataStory/smallMilkBottles.svg": [
		1141,
		9,
		324
	],
	"./adult/16x9/stories/astronautLiveDataStory/transitionTree.svg": [
		1142,
		9,
		325
	],
	"./adult/16x9/stories/astronautLiveDataStory/udder.svg": [
		1143,
		9,
		326
	],
	"./adult/16x9/stories/astronautLiveDataStory/udder_line_1.svg": [
		1144,
		9,
		327
	],
	"./adult/16x9/stories/astronautLiveDataStory/udder_line_2.svg": [
		1145,
		9,
		328
	],
	"./adult/16x9/stories/astronautLiveDataStory/udder_line_3.svg": [
		1146,
		9,
		329
	],
	"./adult/16x9/stories/astronautLiveDataStory/udder_line_4.svg": [
		1147,
		9,
		330
	],
	"./adult/16x9/stories/astronautstory/astronaut.jpg": [
		1148,
		7,
		331
	],
	"./adult/16x9/stories/astronautstory/astronautfifth.jpg": [
		1149,
		7,
		332
	],
	"./adult/16x9/stories/astronautstory/astronautsecond.jpg": [
		1150,
		7,
		333
	],
	"./adult/16x9/stories/astronautstory/astronautthird.jpg": [
		1151,
		7,
		334
	],
	"./adult/16x9/stories/astronautstory/firstmilkingslide.svg": [
		1152,
		9,
		335
	],
	"./adult/16x9/stories/cowdaily/background-layers/background-trees/trees1.svg": [
		1153,
		9,
		336
	],
	"./adult/16x9/stories/cowdaily/background-layers/background-trees/trees2.svg": [
		1154,
		9,
		337
	],
	"./adult/16x9/stories/cowdaily/background-layers/background-trees/trees3.svg": [
		1155,
		9,
		338
	],
	"./adult/16x9/stories/cowdaily/background-layers/background-trees/trees4.svg": [
		1156,
		7,
		339
	],
	"./adult/16x9/stories/cowdaily/background-layers/background-trees/trees5.svg": [
		1157,
		9,
		340
	],
	"./adult/16x9/stories/cowdaily/background-layers/background-trees/trees6.svg": [
		1158,
		9,
		341
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/adult_cloud_1.svg": [
		1159,
		9,
		342
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/adult_cloud_10.svg": [
		1160,
		9,
		343
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/adult_cloud_11.svg": [
		1161,
		9,
		344
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/adult_cloud_12.svg": [
		1162,
		9,
		345
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/adult_cloud_13.svg": [
		1163,
		9,
		346
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/adult_cloud_14.svg": [
		1164,
		9,
		347
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/adult_cloud_15.svg": [
		1165,
		9,
		348
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/adult_cloud_16.svg": [
		1166,
		9,
		349
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/adult_cloud_17.svg": [
		1167,
		9,
		350
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/adult_cloud_18.svg": [
		1168,
		9,
		351
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/adult_cloud_19.svg": [
		1169,
		9,
		352
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/adult_cloud_2 copy.svg": [
		1170,
		9,
		353
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/adult_cloud_2.svg": [
		1171,
		9,
		354
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/adult_cloud_3.svg": [
		1172,
		9,
		355
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/adult_cloud_4.svg": [
		1173,
		9,
		356
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/adult_cloud_5.svg": [
		1174,
		9,
		357
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/adult_cloud_6.svg": [
		1175,
		9,
		358
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/adult_cloud_7.svg": [
		1176,
		9,
		359
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/adult_cloud_8.svg": [
		1177,
		9,
		360
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/adult_cloud_9.svg": [
		1178,
		9,
		361
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_01.svg": [
		1179,
		9,
		362
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_01_gray.svg": [
		1180,
		9,
		363
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_02.svg": [
		1181,
		9,
		364
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_02_gray.svg": [
		1182,
		9,
		365
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_03.svg": [
		1183,
		9,
		366
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_03_gray.svg": [
		1184,
		9,
		367
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_04.svg": [
		1185,
		9,
		368
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_04_gray.svg": [
		1186,
		9,
		369
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_05.svg": [
		1187,
		9,
		370
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_05_gray.svg": [
		1188,
		9,
		371
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_06.svg": [
		1189,
		9,
		372
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_06_gray.svg": [
		1190,
		9,
		373
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_07.svg": [
		1191,
		9,
		374
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_07_gray.svg": [
		1192,
		9,
		375
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_08.svg": [
		1193,
		9,
		376
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_08_gray.svg": [
		1194,
		9,
		377
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_09.svg": [
		1195,
		9,
		378
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_09_gray.svg": [
		1196,
		9,
		379
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_10.svg": [
		1197,
		9,
		380
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_10_gray.svg": [
		1198,
		9,
		381
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_11.svg": [
		1199,
		9,
		382
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_11_gray.svg": [
		1200,
		9,
		383
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_12.svg": [
		1201,
		9,
		384
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_12_gray.svg": [
		1202,
		9,
		385
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_13.svg": [
		1203,
		9,
		386
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_13_gray.svg": [
		1204,
		9,
		387
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_14.svg": [
		1205,
		9,
		388
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_14_gray.svg": [
		1206,
		9,
		389
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_15.svg": [
		1207,
		9,
		390
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_15_gray.svg": [
		1208,
		9,
		391
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_16.svg": [
		1209,
		9,
		392
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_16_gray.svg": [
		1210,
		9,
		393
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_17.svg": [
		1211,
		9,
		394
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_17_gray.svg": [
		1212,
		9,
		395
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_18.svg": [
		1213,
		9,
		396
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_18_gray.svg": [
		1214,
		9,
		397
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_19.svg": [
		1215,
		9,
		398
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_19_gray.svg": [
		1216,
		9,
		399
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/clouds1.svg": [
		1217,
		9,
		400
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/clouds2.svg": [
		1218,
		9,
		401
	],
	"./adult/16x9/stories/cowdaily/background-layers/clouds/clouds3.svg": [
		1219,
		9,
		402
	],
	"./adult/16x9/stories/cowdaily/background-layers/cow-eating-back/cowdailyeating1.svg": [
		1220,
		9,
		403
	],
	"./adult/16x9/stories/cowdaily/background-layers/cow-eating-back/coweatingback.svg": [
		1221,
		9,
		404
	],
	"./adult/16x9/stories/cowdaily/background-layers/cow-eating-back/coweatingback2.svg": [
		1222,
		9,
		405
	],
	"./adult/16x9/stories/cowdaily/background-layers/cow-eating-back/coweatingback3.svg": [
		1223,
		9,
		406
	],
	"./adult/16x9/stories/cowdaily/background-layers/cow-eating-back/coweatingback4.svg": [
		1224,
		9,
		407
	],
	"./adult/16x9/stories/cowdaily/background-layers/cow-eating-back/coweatingback5.svg": [
		1225,
		9,
		408
	],
	"./adult/16x9/stories/cowdaily/background-layers/cow-eating-back/coweatingback6.svg": [
		1226,
		9,
		409
	],
	"./adult/16x9/stories/cowdaily/background-layers/cow-eating-back/cowmilking1.svg": [
		1227,
		9,
		410
	],
	"./adult/16x9/stories/cowdaily/background-layers/cow-eating-back/cowmilking2.svg": [
		1228,
		9,
		411
	],
	"./adult/16x9/stories/cowdaily/background-layers/cow-eating-back/cowrumination1.svg": [
		1229,
		9,
		412
	],
	"./adult/16x9/stories/cowdaily/background-layers/eating-improved/eating1.svg": [
		1235,
		9,
		413
	],
	"./adult/16x9/stories/cowdaily/background-layers/eating-improved/eating_last.svg": [
		1236,
		9,
		414
	],
	"./adult/16x9/stories/cowdaily/background-layers/eating-improved/eating_left.svg": [
		1237,
		9,
		415
	],
	"./adult/16x9/stories/cowdaily/background-layers/eating-improved/grass_initial.svg": [
		1238,
		7,
		416
	],
	"./adult/16x9/stories/cowdaily/background-layers/eating-improved/grass_last.svg": [
		1239,
		7,
		417
	],
	"./adult/16x9/stories/cowdaily/background-layers/eating-improved/grass_new.svg": [
		1240,
		7,
		418
	],
	"./adult/16x9/stories/cowdaily/background-layers/eating-improved/grass_without_tree.svg": [
		1241,
		7,
		419
	],
	"./adult/16x9/stories/cowdaily/background-layers/eating/eating1.svg": [
		1230,
		9,
		420
	],
	"./adult/16x9/stories/cowdaily/background-layers/eating/eating2.svg": [
		1231,
		9,
		421
	],
	"./adult/16x9/stories/cowdaily/background-layers/eating/eating3.svg": [
		1232,
		9,
		422
	],
	"./adult/16x9/stories/cowdaily/background-layers/eating/eating4.svg": [
		1233,
		9,
		423
	],
	"./adult/16x9/stories/cowdaily/background-layers/eating/eating5.svg": [
		1234,
		9,
		424
	],
	"./adult/16x9/stories/cowdaily/background-layers/forefront-tree/forefronttree1.svg": [
		1242,
		9,
		425
	],
	"./adult/16x9/stories/cowdaily/background-layers/forefront-tree/forefronttree2.svg": [
		1243,
		9,
		426
	],
	"./adult/16x9/stories/cowdaily/background-layers/grass/grass1.svg": [
		1244,
		9,
		427
	],
	"./adult/16x9/stories/cowdaily/background-layers/grass/grass2.svg": [
		1245,
		9,
		428
	],
	"./adult/16x9/stories/cowdaily/background-layers/grass/grass3.svg": [
		1246,
		9,
		429
	],
	"./adult/16x9/stories/cowdaily/background-layers/grass/grass4.svg": [
		1247,
		9,
		430
	],
	"./adult/16x9/stories/cowdaily/background-layers/grass/grass5.svg": [
		1248,
		9,
		431
	],
	"./adult/16x9/stories/cowdaily/background-layers/grass/grass6.svg": [
		1249,
		9,
		432
	],
	"./adult/16x9/stories/cowdaily/background-layers/grass/grass_initial.svg": [
		1250,
		7,
		433
	],
	"./adult/16x9/stories/cowdaily/background-layers/grass/grass_last_slide.svg": [
		1251,
		7,
		434
	],
	"./adult/16x9/stories/cowdaily/background-layers/grass/grasslastslide.svg": [
		1252,
		9,
		435
	],
	"./adult/16x9/stories/cowdaily/background-layers/hills/background_hills_snowy_01.svg": [
		1253,
		9,
		436
	],
	"./adult/16x9/stories/cowdaily/background-layers/hills/background_hills_snowy_02.svg": [
		1254,
		9,
		437
	],
	"./adult/16x9/stories/cowdaily/background-layers/hills/background_hills_snowy_03.svg": [
		1255,
		9,
		438
	],
	"./adult/16x9/stories/cowdaily/background-layers/hills/background_hills_snowy_04.svg": [
		1256,
		9,
		439
	],
	"./adult/16x9/stories/cowdaily/background-layers/hills/background_hills_snowy_05.svg": [
		1257,
		9,
		440
	],
	"./adult/16x9/stories/cowdaily/background-layers/milking/milking2.svg": [
		1258,
		9,
		441
	],
	"./adult/16x9/stories/cowdaily/background-layers/milking/milking_last.svg": [
		1259,
		9,
		442
	],
	"./adult/16x9/stories/cowdaily/background-layers/milking/milking_left.svg": [
		1260,
		9,
		443
	],
	"./adult/16x9/stories/cowdaily/background-layers/mist/adult_mist_1.svg": [
		1261,
		9,
		444
	],
	"./adult/16x9/stories/cowdaily/background-layers/mist/adult_mist_2.svg": [
		1262,
		9,
		445
	],
	"./adult/16x9/stories/cowdaily/background-layers/mist/adult_mist_3.svg": [
		1263,
		9,
		446
	],
	"./adult/16x9/stories/cowdaily/background-layers/mist/adult_mist_4.svg": [
		1264,
		9,
		447
	],
	"./adult/16x9/stories/cowdaily/background-layers/mist/adult_mist_5.svg": [
		1265,
		9,
		448
	],
	"./adult/16x9/stories/cowdaily/background-layers/mist/adult_mist_6.svg": [
		1266,
		9,
		449
	],
	"./adult/16x9/stories/cowdaily/background-layers/mist/adult_mist_7.svg": [
		1267,
		9,
		450
	],
	"./adult/16x9/stories/cowdaily/background-layers/mist/background_weather_mist_01.svg": [
		1268,
		9,
		451
	],
	"./adult/16x9/stories/cowdaily/background-layers/mist/background_weather_mist_02.svg": [
		1269,
		9,
		452
	],
	"./adult/16x9/stories/cowdaily/background-layers/mist/background_weather_mist_03.svg": [
		1270,
		9,
		453
	],
	"./adult/16x9/stories/cowdaily/background-layers/mist/background_weather_mist_04.svg": [
		1271,
		9,
		454
	],
	"./adult/16x9/stories/cowdaily/background-layers/mist/background_weather_mist_05.svg": [
		1272,
		9,
		455
	],
	"./adult/16x9/stories/cowdaily/background-layers/mist/background_weather_mist_06.svg": [
		1273,
		9,
		456
	],
	"./adult/16x9/stories/cowdaily/background-layers/mist/background_weather_mist_07.svg": [
		1274,
		9,
		457
	],
	"./adult/16x9/stories/cowdaily/background-layers/resting/cowdailyresting1.svg": [
		1275,
		9,
		458
	],
	"./adult/16x9/stories/cowdaily/background-layers/resting/resting1.svg": [
		1276,
		9,
		459
	],
	"./adult/16x9/stories/cowdaily/background-layers/resting/resting2.svg": [
		1277,
		9,
		460
	],
	"./adult/16x9/stories/cowdaily/background-layers/resting/resting3.svg": [
		1278,
		9,
		461
	],
	"./adult/16x9/stories/cowdaily/background-layers/resting/resting5.svg": [
		1279,
		9,
		462
	],
	"./adult/16x9/stories/cowdaily/background-layers/resting/resting_last.svg": [
		1280,
		9,
		463
	],
	"./adult/16x9/stories/cowdaily/background-layers/resting/resting_left.svg": [
		1281,
		9,
		464
	],
	"./adult/16x9/stories/cowdaily/background-layers/rumination/rumination_1.svg": [
		1282,
		9,
		465
	],
	"./adult/16x9/stories/cowdaily/background-layers/rumination/rumination_last_full_tree.svg": [
		1283,
		9,
		466
	],
	"./adult/16x9/stories/cowdaily/background-layers/sky/adult_moon.svg": [
		1284,
		9,
		467
	],
	"./adult/16x9/stories/cowdaily/background-layers/sky/adult_sun.svg": [
		1285,
		9,
		468
	],
	"./adult/16x9/stories/cowdaily/background-layers/sky/birds.svg": [
		1286,
		9,
		469
	],
	"./adult/16x9/stories/cowdaily/background-layers/sky/moon.svg": [
		1287,
		9,
		470
	],
	"./adult/16x9/stories/cowdaily/background-layers/sky/sun.svg": [
		1288,
		9,
		471
	],
	"./adult/16x9/stories/cowdaily/background-layers/stars/starry_sky.svg": [
		1289,
		9,
		472
	],
	"./adult/16x9/stories/cowdaily/background-layers/weather/droplet.svg": [
		1290,
		9,
		473
	],
	"./adult/16x9/stories/cowdaily/background-layers/weather/lightnings/background_weather_lightning_01.svg": [
		1291,
		9,
		474
	],
	"./adult/16x9/stories/cowdaily/background-layers/weather/lightnings/background_weather_lightning_02.svg": [
		1292,
		9,
		475
	],
	"./adult/16x9/stories/cowdaily/background-layers/weather/lightnings/background_weather_lightning_03.svg": [
		1293,
		9,
		476
	],
	"./adult/16x9/stories/cowdaily/background-layers/weather/lightnings/background_weather_lightning_04.svg": [
		1294,
		9,
		477
	],
	"./adult/16x9/stories/cowdaily/background-layers/weather/lightnings/background_weather_lightning_05.svg": [
		1295,
		9,
		478
	],
	"./adult/16x9/stories/cowdaily/background-layers/weather/lightnings/background_weather_lightning_06.svg": [
		1296,
		9,
		479
	],
	"./adult/16x9/stories/cowdaily/background-layers/weather/rains/background_weather_rain_01.svg": [
		1297,
		9,
		480
	],
	"./adult/16x9/stories/cowdaily/background-layers/weather/rains/background_weather_rain_02.svg": [
		1298,
		9,
		481
	],
	"./adult/16x9/stories/cowdaily/background-layers/weather/rains/background_weather_rain_drizzle_01.svg": [
		1299,
		9,
		482
	],
	"./adult/16x9/stories/cowdaily/background-layers/weather/rains/background_weather_rain_drizzle_02.svg": [
		1300,
		9,
		483
	],
	"./adult/16x9/stories/cowdaily/background-layers/weather/rains/background_weather_rain_drizzle_03.svg": [
		1301,
		9,
		484
	],
	"./adult/16x9/stories/cowdaily/background-layers/weather/rains/background_weather_rain_drizzle_04.svg": [
		1302,
		9,
		485
	],
	"./adult/16x9/stories/cowdaily/background-layers/weather/rains/background_weather_rain_heavy_01.svg": [
		1303,
		9,
		486
	],
	"./adult/16x9/stories/cowdaily/background-layers/weather/rains/background_weather_rain_heavy_02.svg": [
		1304,
		9,
		487
	],
	"./adult/16x9/stories/cowdaily/graphics/astronaut.svg": [
		1305,
		9,
		488
	],
	"./adult/16x9/stories/cowdaily/graphics/cow_resting.svg": [
		1306,
		9,
		489
	],
	"./adult/16x9/stories/cowdaily/graphics/endingSlidePole.svg": [
		1307,
		9,
		490
	],
	"./adult/16x9/stories/cowdaily/graphics/milk_bottle.svg": [
		1308,
		9,
		491
	],
	"./adult/16x9/stories/cowdaily/graphics/pole.svg": [
		1309,
		9,
		492
	],
	"./adult/16x9/stories/cowdaily/graphics/vector.svg": [
		1310,
		9,
		493
	],
	"./adult/16x9/stories/cowhistory/background-layers/elements/fenceOutroSlide.svg": [
		1311,
		9,
		494
	],
	"./adult/16x9/stories/cowhistory/background-layers/elements/house.svg": [
		1312,
		9,
		495
	],
	"./adult/16x9/stories/cowhistory/background-layers/elements/houseStyle2.svg": [
		1313,
		9,
		496
	],
	"./adult/16x9/stories/cowhistory/background-layers/elements/houseStyle3.svg": [
		1314,
		9,
		497
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/barnFirstSlide.svg": [
		1315,
		9,
		498
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/barnSecondSlide.svg": [
		1316,
		9,
		499
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/bigPartyFlag.svg": [
		1317,
		9,
		500
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/bigPresentBox.svg": [
		1318,
		9,
		501
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/bigTree.svg": [
		1319,
		9,
		502
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/birthdayCake.svg": [
		1320,
		9,
		503
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/birthdaySlide.svg": [
		1321,
		9,
		504
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/cake.svg": [
		1322,
		9,
		505
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/calendar.svg": [
		1323,
		9,
		506
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/calmRobot.svg": [
		1324,
		9,
		507
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/candle.svg": [
		1325,
		9,
		508
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/cowOutroSlideFence.svg": [
		1326,
		9,
		509
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/firstCalfSecondSlide.svg": [
		1327,
		9,
		510
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/firstCalfSlide.svg": [
		1328,
		9,
		511
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/firstCalfThirdSlide.svg": [
		1329,
		9,
		512
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/partyFlutes/partyFlute_1.svg": [
		1330,
		9,
		513
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/partyFlutes/partyFlute_2.svg": [
		1331,
		9,
		514
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/partyFlutes/partyFlute_3.svg": [
		1332,
		9,
		515
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/partyHats/partyHat_1.svg": [
		1333,
		9,
		516
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/partyHats/partyHat_2.svg": [
		1334,
		9,
		517
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/partyHats/partyHat_3.svg": [
		1335,
		9,
		518
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/pole.svg": [
		1336,
		9,
		519
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/presentBox.svg": [
		1337,
		9,
		520
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/rightPartOfTheTree.svg": [
		1338,
		9,
		521
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/secondSlideCalm.svg": [
		1339,
		9,
		522
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/secondSlideCalmVersion.svg": [
		1340,
		9,
		523
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/smallPartyFlag.svg": [
		1341,
		9,
		524
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/stork.svg": [
		1342,
		9,
		525
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/thermometer.svg": [
		1343,
		9,
		526
	],
	"./adult/16x9/stories/cowhistory/background-layers/firstYear/trees-1.svg": [
		1344,
		9,
		527
	],
	"./adult/16x9/stories/cowhistory/background-layers/forrest/forrest1.svg": [
		1345,
		9,
		528
	],
	"./adult/16x9/stories/cowhistory/background-layers/forrest/forrest2.svg": [
		1346,
		9,
		529
	],
	"./adult/16x9/stories/cowhistory/background-layers/forrest/forrest3.svg": [
		1347,
		9,
		530
	],
	"./adult/16x9/stories/cowhistory/background-layers/forrest/forrest4.svg": [
		1348,
		9,
		531
	],
	"./adult/16x9/stories/cowhistory/background-layers/forrest/forrest5.svg": [
		1349,
		9,
		532
	],
	"./adult/16x9/stories/cowhistory/background-layers/forrest2/forrest1.svg": [
		1350,
		9,
		533
	],
	"./adult/16x9/stories/cowhistory/background-layers/forrest2/forrest2.svg": [
		1351,
		9,
		534
	],
	"./adult/16x9/stories/cowhistory/background-layers/forrest2/forrest3.svg": [
		1352,
		9,
		535
	],
	"./adult/16x9/stories/cowhistory/background-layers/forrest2/forrest4.svg": [
		1353,
		9,
		536
	],
	"./adult/16x9/stories/cowhistory/background-layers/forrest2/forrest5.svg": [
		1354,
		9,
		537
	],
	"./adult/16x9/stories/cowhistory/background-layers/grass/grass1.svg": [
		1355,
		9,
		538
	],
	"./adult/16x9/stories/cowhistory/background-layers/grass/grass2.svg": [
		1356,
		7,
		539
	],
	"./adult/16x9/stories/cowhistory/background-layers/grass/grass3.svg": [
		1357,
		9,
		540
	],
	"./adult/16x9/stories/cowhistory/background-layers/grass/grass4.svg": [
		1358,
		9,
		541
	],
	"./adult/16x9/stories/cowhistory/background-layers/grass/grass5.svg": [
		1359,
		9,
		542
	],
	"./adult/16x9/stories/cowhistory/background-layers/grass/grass6.svg": [
		1360,
		9,
		543
	],
	"./adult/16x9/stories/cowhistory/background-layers/hills1/hills11.svg": [
		1361,
		9,
		544
	],
	"./adult/16x9/stories/cowhistory/background-layers/hills1/hills12.svg": [
		1362,
		9,
		545
	],
	"./adult/16x9/stories/cowhistory/background-layers/hills1/hills13.svg": [
		1363,
		9,
		546
	],
	"./adult/16x9/stories/cowhistory/background-layers/hills1/hills14.svg": [
		1364,
		9,
		547
	],
	"./adult/16x9/stories/cowhistory/background-layers/hills1/hills15.svg": [
		1365,
		9,
		548
	],
	"./adult/16x9/stories/cowhistory/background-layers/hills2/hills21.svg": [
		1366,
		9,
		549
	],
	"./adult/16x9/stories/cowhistory/background-layers/hills2/hills22.svg": [
		1367,
		9,
		550
	],
	"./adult/16x9/stories/cowhistory/background-layers/hills2/hills23.svg": [
		1368,
		9,
		551
	],
	"./adult/16x9/stories/cowhistory/background-layers/hills2/hills24.svg": [
		1369,
		9,
		552
	],
	"./adult/16x9/stories/cowhistory/background-layers/hills2/hills25.svg": [
		1370,
		9,
		553
	],
	"./adult/16x9/stories/cowhistory/background-layers/mountains/mountain1.svg": [
		1371,
		9,
		554
	],
	"./adult/16x9/stories/cowhistory/background-layers/mountains/mountain2.svg": [
		1372,
		9,
		555
	],
	"./adult/16x9/stories/cowhistory/background-layers/mountains/mountain3.svg": [
		1373,
		9,
		556
	],
	"./adult/16x9/stories/cowhistory/background-layers/mountains/mountain4.svg": [
		1374,
		9,
		557
	],
	"./adult/16x9/stories/cowhistory/background-layers/mountains/mountain5.svg": [
		1375,
		9,
		558
	],
	"./adult/16x9/stories/discoverySw/discoverySw.svg": [
		1376,
		9,
		559
	],
	"./adult/16x9/stories/discoverystory/about.png": [
		1377,
		7,
		560
	],
	"./adult/16x9/stories/discoverystory/discoverySw90.jpg": [
		1378,
		7,
		561
	],
	"./adult/16x9/stories/discoverystory/health.png": [
		1379,
		7,
		562
	],
	"./adult/16x9/stories/discoverystory/robot.svg": [
		1380,
		9,
		563
	],
	"./adult/16x9/stories/discoverystory/thirdSlide.png": [
		1381,
		7,
		564
	],
	"./adult/16x9/stories/farmer/ending-point-background.svg": [
		1382,
		9,
		565
	],
	"./adult/16x9/stories/farmer/ending-point-button-revert.svg": [
		1383,
		9,
		566
	],
	"./adult/16x9/stories/farmer/ending-point-button.svg": [
		1384,
		9,
		567
	],
	"./adult/16x9/stories/farmer/starting-point-background.svg": [
		1385,
		9,
		568
	],
	"./adult/16x9/stories/lelystory/building.svg": [
		1386,
		9,
		569
	],
	"./adult/16x9/stories/lelystory/lelyFarmThirdSlideStory.jpg": [
		1387,
		7,
		570
	],
	"./adult/16x9/stories/lelystory/lelyFifthSlideCowjpg.jpg": [
		1388,
		7,
		571
	],
	"./adult/16x9/stories/lelystory/lelyFourthSlide.jpg": [
		1389,
		7,
		572
	],
	"./adult/16x9/stories/lelystory/lelyHistory.jpg": [
		1390,
		7,
		573
	],
	"./adult/16x9/stories/lelystory/lelyRedirectionButton.svg": [
		1391,
		9,
		574
	],
	"./adult/16x9/stories/lelystory/robotToys.jpg": [
		1392,
		7,
		575
	],
	"./adult/16x9/stories/lelystory/trees.svg": [
		1393,
		9,
		576
	],
	"./adult/16x9/stories/lunarobot/lunaSecondSlide.png": [
		1394,
		7,
		577
	],
	"./adult/16x9/stories/lunarobot/lunaThirdSlide.png": [
		1395,
		7,
		578
	],
	"./adult/16x9/stories/lunarobot/lunarobot.svg": [
		1396,
		9,
		579
	],
	"./adult/16x9/stories/lunarobot/lunarobotsecondslide.svg": [
		1397,
		9,
		580
	],
	"./adult/16x9/stories/milk/Poison.png": [
		1398,
		7,
		581
	],
	"./adult/16x9/stories/milk/americanBarn.svg": [
		1399,
		9,
		582
	],
	"./adult/16x9/stories/milk/arrow.svg": [
		1400,
		9,
		583
	],
	"./adult/16x9/stories/milk/background.svg": [
		1401,
		9,
		584
	],
	"./adult/16x9/stories/milk/batchNumber.svg": [
		1402,
		9,
		585
	],
	"./adult/16x9/stories/milk/batchNumberPlate.svg": [
		1403,
		9,
		586
	],
	"./adult/16x9/stories/milk/bigBush.svg": [
		1404,
		9,
		587
	],
	"./adult/16x9/stories/milk/bigGrass.svg": [
		1405,
		9,
		588
	],
	"./adult/16x9/stories/milk/boerKees.svg": [
		1406,
		9,
		589
	],
	"./adult/16x9/stories/milk/border.svg": [
		1407,
		9,
		590
	],
	"./adult/16x9/stories/milk/bottle.svg": [
		1408,
		9,
		591
	],
	"./adult/16x9/stories/milk/bush.svg": [
		1409,
		9,
		592
	],
	"./adult/16x9/stories/milk/calendar.svg": [
		1410,
		9,
		593
	],
	"./adult/16x9/stories/milk/christmas_hat.svg": [
		1411,
		9,
		594
	],
	"./adult/16x9/stories/milk/christmas_whistle.svg": [
		1412,
		9,
		595
	],
	"./adult/16x9/stories/milk/deDobbelhoeve.svg": [
		1413,
		9,
		596
	],
	"./adult/16x9/stories/milk/discoverTheFarm.svg": [
		1414,
		9,
		597
	],
	"./adult/16x9/stories/milk/dutchBarn.svg": [
		1415,
		9,
		598
	],
	"./adult/16x9/stories/milk/dutchBarnSecondType.svg": [
		1416,
		9,
		599
	],
	"./adult/16x9/stories/milk/farmPlate.svg": [
		1417,
		9,
		600
	],
	"./adult/16x9/stories/milk/grassUnderThePole.svg": [
		1418,
		9,
		601
	],
	"./adult/16x9/stories/milk/grass_1.svg": [
		1419,
		9,
		602
	],
	"./adult/16x9/stories/milk/house.svg": [
		1420,
		9,
		603
	],
	"./adult/16x9/stories/milk/liquidMilk.svg": [
		1421,
		9,
		604
	],
	"./adult/16x9/stories/milk/map.svg": [
		1422,
		9,
		605
	],
	"./adult/16x9/stories/milk/map_pin.svg": [
		1423,
		9,
		606
	],
	"./adult/16x9/stories/milk/mijnMelkBottle2.svg": [
		1424,
		9,
		607
	],
	"./adult/16x9/stories/milk/mijnMelkBottleOnboarding.svg": [
		1425,
		9,
		608
	],
	"./adult/16x9/stories/milk/mijnMelkPlate.svg": [
		1426,
		9,
		609
	],
	"./adult/16x9/stories/milk/milkStorybottle.svg": [
		1427,
		9,
		610
	],
	"./adult/16x9/stories/milk/milkingBottleInfo.svg": [
		1428,
		9,
		611
	],
	"./adult/16x9/stories/milk/oostdamImage.svg": [
		1429,
		9,
		612
	],
	"./adult/16x9/stories/milk/planet.svg": [
		1430,
		9,
		613
	],
	"./adult/16x9/stories/milk/planet2.svg": [
		1431,
		9,
		614
	],
	"./adult/16x9/stories/milk/poleFirstSlide.svg": [
		1432,
		9,
		615
	],
	"./adult/16x9/stories/milk/rotgans.svg": [
		1433,
		9,
		616
	],
	"./adult/16x9/stories/milk/secondSlideFamilyTree.svg": [
		1434,
		9,
		617
	],
	"./adult/16x9/stories/milk/sign.svg": [
		1435,
		9,
		618
	],
	"./adult/16x9/stories/milk/slide1RoadSign.svg": [
		1436,
		9,
		619
	],
	"./adult/16x9/stories/milk/smallCow.svg": [
		1437,
		9,
		620
	],
	"./adult/16x9/stories/milk/small_cow.svg": [
		1438,
		9,
		621
	],
	"./adult/16x9/stories/milk/sunburst.svg": [
		1439,
		9,
		622
	],
	"./adult/16x9/stories/milk/swipe_symbol.svg": [
		1440,
		9,
		623
	],
	"./adult/16x9/stories/milk/swipingGesture.svg": [
		1441,
		9,
		624
	],
	"./adult/16x9/stories/milk/test.svg": [
		1442,
		9,
		625
	],
	"./adult/16x9/stories/milk/topThreeCowsPlate.svg": [
		1443,
		9,
		626
	],
	"./adult/16x9/stories/orbiterstory/cowlastslide.svg": [
		1444,
		9,
		627
	],
	"./adult/16x9/stories/orbiterstory/milkBottles.svg": [
		1445,
		9,
		628
	],
	"./adult/16x9/stories/orbiterstory/milkbottle_empty.svg": [
		1446,
		9,
		629
	],
	"./adult/16x9/stories/orbiterstory/orbiterFifthSlidePipe.svg": [
		1447,
		9,
		630
	],
	"./adult/16x9/stories/orbiterstory/orbiterFourthSlideRobot.svg": [
		1448,
		9,
		631
	],
	"./adult/16x9/stories/orbiterstory/orbiterMiddlePipe.svg": [
		1449,
		9,
		632
	],
	"./adult/16x9/stories/orbiterstory/orbiterMilking.svg": [
		1450,
		9,
		633
	],
	"./adult/16x9/stories/orbiterstory/orbiterRobotFifthSlide.svg": [
		1451,
		9,
		634
	],
	"./adult/16x9/stories/orbiterstory/orbiterSixthSlidePipe.svg": [
		1452,
		9,
		635
	],
	"./adult/16x9/stories/orbiterstory/orbiterTableFIfthSlide.svg": [
		1453,
		9,
		636
	],
	"./adult/16x9/stories/orbiterstory/orbiterTableSecondPart.svg": [
		1454,
		9,
		637
	],
	"./adult/16x9/stories/orbiterstory/orbiterTableSixthSlide.svg": [
		1455,
		9,
		638
	],
	"./adult/16x9/stories/orbiterstory/orbiterTemperature.svg": [
		1456,
		9,
		639
	],
	"./adult/16x9/stories/orbiterstory/orbiterarrow.svg": [
		1457,
		9,
		640
	],
	"./adult/16x9/stories/orbiterstory/orbiterbus.svg": [
		1458,
		9,
		641
	],
	"./adult/16x9/stories/orbiterstory/orbitercoolingsystem.svg": [
		1459,
		9,
		642
	],
	"./adult/16x9/stories/orbiterstory/orbitermainbackground.svg": [
		1460,
		9,
		643
	],
	"./adult/16x9/stories/orbiterstory/orbitermilkywaypipe.svg": [
		1461,
		9,
		644
	],
	"./adult/16x9/stories/orbiterstory/orbiterrightpipe.svg": [
		1462,
		9,
		645
	],
	"./adult/16x9/stories/orbiterstory/orbitersixthslide.svg": [
		1463,
		9,
		646
	],
	"./adult/16x9/stories/orbiterstory/orbitertreeleft.svg": [
		1464,
		9,
		647
	],
	"./adult/16x9/stories/orbiterstory/pipe.svg": [
		1465,
		9,
		648
	],
	"./adult/16x9/stories/orbiterstory/pipeThirdSlide.svg": [
		1466,
		9,
		649
	],
	"./adult/16x9/stories/orbiterstory/pipefourthslide.svg": [
		1467,
		9,
		650
	],
	"./adult/16x9/stories/orbiterstory/pipefourthslideright.svg": [
		1468,
		9,
		651
	],
	"./adult/16x9/stories/orbiterstory/sharingPole.svg": [
		1469,
		9,
		652
	],
	"./adult/16x9/stories/orbiterstory/temperatureafterorbiter.svg": [
		1470,
		9,
		653
	],
	"./adult/16x9/stories/orbiterstory/temperaturebeforeorbiter.svg": [
		1471,
		9,
		654
	],
	"./adult/16x9/stories/sustainabilityStory/sustainability-silo.svg": [
		1472,
		9,
		655
	],
	"./adult/16x9/stories/sustainabilityStory/sustainability_plate.svg": [
		1473,
		9,
		656
	],
	"./adult/16x9/stories/sustainabilityStory/sustainability_plate_child.svg": [
		1474,
		9,
		657
	],
	"./adult/16x9/stories/sustainabilityStory/sustainability_silo_child.svg": [
		1475,
		9,
		658
	],
	"./adult/16x9/stories/sustainabilityStory/sustainability_small_bush.svg": [
		1476,
		9,
		659
	],
	"./adult/16x9/stories/vectorstory/01_Vector_history.jpg": [
		1477,
		7,
		660
	],
	"./adult/16x9/stories/vectorstory/02_vector_story.jpg": [
		1478,
		7,
		661
	],
	"./adult/16x9/stories/vectorstory/03_vector_cows.jpg": [
		1479,
		7,
		662
	],
	"./adult/16x9/stories/vectorstory/americanBarnEndingImage.svg": [
		1480,
		9,
		663
	],
	"./adult/16x9/stories/vectorstory/dutchBarnEndingImage.svg": [
		1481,
		9,
		664
	],
	"./adult/16x9/stories/vectorstory/dutchBarnSecondTypeEndingImage.svg": [
		1482,
		9,
		665
	],
	"./adult/16x9/stories/vectorstory/facebookPlate.svg": [
		1483,
		9,
		666
	],
	"./adult/16x9/stories/vectorstory/linkedinPlate.svg": [
		1484,
		9,
		667
	],
	"./adult/16x9/stories/vectorstory/moreInfoPlate.svg": [
		1485,
		9,
		668
	],
	"./adult/16x9/stories/vectorstory/robotstoryarrow.svg": [
		1486,
		9,
		669
	],
	"./adult/16x9/stories/vectorstory/sharePlateImage.svg": [
		1487,
		9,
		670
	],
	"./adult/16x9/stories/vectorstory/sharePoleImage.svg": [
		1488,
		9,
		671
	],
	"./adult/16x9/stories/vectorstory/twitterPlate.svg": [
		1489,
		9,
		672
	],
	"./adult/16x9/stories/vectorstory/vectorRobotAdultVersion1.svg": [
		1490,
		9,
		673
	],
	"./adult/16x9/stories/vectorstory/vectorimagefourthslide.svg": [
		1491,
		9,
		674
	],
	"./adult/16x9/stories/vectorstory/vectorimagethirdslide.svg": [
		1492,
		9,
		675
	],
	"./adult/16x9/stories/vectorstory/vectorlastslidesign.svg": [
		1493,
		9,
		676
	],
	"./adult/16x9/ui/actor-pointer/actor-pointer-arrow.svg": [
		1494,
		9,
		677
	],
	"./adult/16x9/ui/arrows/arrow-curve-down.svg": [
		1495,
		9,
		678
	],
	"./adult/16x9/ui/arrows/arrow-left-curve-down-black.svg": [
		1496,
		9,
		679
	],
	"./adult/16x9/ui/arrows/arrow-left-curve-down.svg": [
		1497,
		9,
		680
	],
	"./adult/16x9/ui/arrows/arrow-left-curve.svg": [
		1498,
		9,
		681
	],
	"./adult/16x9/ui/arrows/arrow-right-curve-down.svg": [
		1499,
		9,
		682
	],
	"./adult/16x9/ui/arrows/arrow-up-curve.svg": [
		1500,
		9,
		683
	],
	"./adult/16x9/ui/arrows/arrow-up.svg": [
		1501,
		9,
		684
	],
	"./adult/16x9/ui/arrows/arrow-upward-left.svg": [
		1502,
		9,
		685
	],
	"./adult/16x9/ui/buttons/batchCowListButton.svg": [
		1503,
		9,
		686
	],
	"./adult/16x9/ui/buttons/button-with-arrow-down.svg": [
		1504,
		9,
		687
	],
	"./adult/16x9/ui/buttons/button-with-arrow-up.svg": [
		1505,
		9,
		688
	],
	"./adult/16x9/ui/buttons/cow-calm-slide-button.svg": [
		1506,
		9,
		689
	],
	"./adult/16x9/ui/buttons/cow-gave-birth-button.svg": [
		1507,
		9,
		690
	],
	"./adult/16x9/ui/buttons/red-button-popup-farmer.svg": [
		1508,
		9,
		691
	],
	"./adult/16x9/ui/buttons/red-button.svg": [
		1509,
		9,
		692
	],
	"./adult/16x9/ui/buttons/sign-button-left-background.svg": [
		1510,
		9,
		693
	],
	"./adult/16x9/ui/buttons/sign-button-right-background.svg": [
		1511,
		9,
		694
	],
	"./adult/16x9/ui/buttons/virtualFarmTourCloseButton.svg": [
		1512,
		9,
		695
	],
	"./adult/16x9/ui/cookies/arrow_right.svg": [
		1513,
		9,
		696
	],
	"./adult/16x9/ui/cookies/close_button.svg": [
		1514,
		9,
		697
	],
	"./adult/16x9/ui/cookies/close_button_with_arrows.svg": [
		1515,
		9,
		698
	],
	"./adult/16x9/ui/cookies/popup_close_button.svg": [
		1516,
		9,
		699
	],
	"./adult/16x9/ui/cookies/popup_image.svg": [
		1517,
		9,
		700
	],
	"./adult/16x9/ui/cookies/popup_image_children.svg": [
		1518,
		9,
		701
	],
	"./adult/16x9/ui/disclaimer/close_button.svg": [
		1519,
		9,
		702
	],
	"./adult/16x9/ui/elements/astronaut.svg": [
		1520,
		9,
		703
	],
	"./adult/16x9/ui/elements/cloud.svg": [
		1521,
		9,
		704
	],
	"./adult/16x9/ui/elements/cow_resting.svg": [
		1522,
		9,
		705
	],
	"./adult/16x9/ui/elements/grazeway.svg": [
		1523,
		9,
		706
	],
	"./adult/16x9/ui/elements/milk_bottle.svg": [
		1524,
		9,
		707
	],
	"./adult/16x9/ui/hud/bottle_icon.svg": [
		1525,
		9,
		708
	],
	"./adult/16x9/ui/hud/bottomCowLine.svg": [
		1526,
		9,
		709
	],
	"./adult/16x9/ui/hud/cow_avatar.svg": [
		1527,
		9,
		710
	],
	"./adult/16x9/ui/hud/cow_head_icon.svg": [
		1528,
		9,
		711
	],
	"./adult/16x9/ui/hud/hexagon.svg": [
		1529,
		9,
		712
	],
	"./adult/16x9/ui/hud/humidity_icon.svg": [
		1530,
		9,
		713
	],
	"./adult/16x9/ui/hud/location.svg": [
		1531,
		9,
		714
	],
	"./adult/16x9/ui/hud/robot_icon.svg": [
		1532,
		9,
		715
	],
	"./adult/16x9/ui/hud/sun.svg": [
		1533,
		9,
		716
	],
	"./adult/16x9/ui/hud/temperature_icon.svg": [
		1534,
		9,
		717
	],
	"./adult/16x9/ui/icons/auto-rotate-icon.svg": [
		1535,
		9,
		718
	],
	"./adult/16x9/ui/icons/calendar-icon.svg": [
		1536,
		9,
		719
	],
	"./adult/16x9/ui/icons/card-icon.svg": [
		1537,
		9,
		720
	],
	"./adult/16x9/ui/icons/cash-icon.svg": [
		1538,
		9,
		721
	],
	"./adult/16x9/ui/icons/click-cursor.svg": [
		1539,
		9,
		722
	],
	"./adult/16x9/ui/icons/close-icon.svg": [
		1540,
		9,
		723
	],
	"./adult/16x9/ui/icons/info-icon.svg": [
		1541,
		9,
		724
	],
	"./adult/16x9/ui/icons/login-page-lely-logo.svg": [
		1542,
		9,
		725
	],
	"./adult/16x9/ui/icons/mailbox-icon.svg": [
		1543,
		9,
		726
	],
	"./adult/16x9/ui/icons/route-icon.svg": [
		1544,
		9,
		727
	],
	"./adult/16x9/ui/icons/swipe.svg": [
		1545,
		9,
		728
	],
	"./adult/16x9/ui/icons/webshop-icon.svg": [
		1546,
		9,
		729
	],
	"./adult/16x9/ui/icons/zoom-in-icon.svg": [
		1547,
		9,
		730
	],
	"./adult/16x9/ui/icons/zoom-out-icon.svg": [
		1548,
		9,
		731
	],
	"./adult/16x9/ui/live-data-indicator/background.svg": [
		1549,
		9,
		732
	],
	"./adult/16x9/ui/popup/close-popup-button.svg": [
		1550,
		9,
		733
	],
	"./adult/16x9/ui/ribbon/ribbon.svg": [
		1551,
		9,
		734
	],
	"./adult/16x9/ui/sidemenu/close-menu-button.svg": [
		1552,
		9,
		735
	],
	"./adult/16x9/ui/sidemenu/facebook-icon.svg": [
		1553,
		9,
		736
	],
	"./adult/16x9/ui/sidemenu/instagram-icon.svg": [
		1554,
		9,
		737
	],
	"./adult/16x9/ui/sidemenu/menu-icon.svg": [
		1555,
		9,
		738
	],
	"./adult/16x9/ui/sidemenu/twitter-icon.svg": [
		1556,
		9,
		739
	],
	"./adult/16x9/ui/virtual-farm-footer/grass-aligned-center.png": [
		1557,
		7,
		740
	],
	"./adult/16x9/ui/virtual-farm-footer/grass-aligned-left.png": [
		1558,
		7,
		741
	],
	"./adult/16x9/ui/virtual-farm-footer/grass-aligned-right.png": [
		1559,
		7,
		742
	],
	"./adult/16x9/ui/virtual-farm-footer/grassLeft.svg": [
		1560,
		9,
		743
	],
	"./adult/16x9/ui/windmill/windmill-body.svg": [
		1561,
		9,
		744
	],
	"./adult/16x9/ui/windmill/windmill-fin.svg": [
		1562,
		9,
		745
	],
	"./kaasfarm/16x9/actors/astronautfactory/astronaut-landing-page.svg": [
		1563,
		9,
		746
	],
	"./kaasfarm/16x9/actors/cheesefactory/cheese-factory.svg": [
		1564,
		9,
		747
	],
	"./kaasfarm/16x9/actors/cow/heads/cow-list-popup-head-1.svg": [
		1565,
		9,
		748
	],
	"./kaasfarm/16x9/actors/cow/heads/cow-list-popup-head-10.svg": [
		1566,
		9,
		749
	],
	"./kaasfarm/16x9/actors/cow/heads/cow-list-popup-head-11.svg": [
		1567,
		9,
		750
	],
	"./kaasfarm/16x9/actors/cow/heads/cow-list-popup-head-2.svg": [
		1568,
		9,
		751
	],
	"./kaasfarm/16x9/actors/cow/heads/cow-list-popup-head-3.svg": [
		1569,
		9,
		752
	],
	"./kaasfarm/16x9/actors/cow/heads/cow-list-popup-head-4.svg": [
		1570,
		9,
		753
	],
	"./kaasfarm/16x9/actors/cow/heads/cow-list-popup-head-5.svg": [
		1571,
		9,
		754
	],
	"./kaasfarm/16x9/actors/cow/heads/cow-list-popup-head-6.svg": [
		1572,
		9,
		755
	],
	"./kaasfarm/16x9/actors/cow/heads/cow-list-popup-head-7.svg": [
		1573,
		9,
		756
	],
	"./kaasfarm/16x9/actors/cow/heads/cow-list-popup-head-8.svg": [
		1574,
		9,
		757
	],
	"./kaasfarm/16x9/actors/cow/heads/cow-list-popup-head-9.svg": [
		1575,
		9,
		758
	],
	"./kaasfarm/16x9/actors/cow/popup/heads/cow-list-popup-head-blaarkop-black.svg": [
		1576,
		9,
		759
	],
	"./kaasfarm/16x9/actors/cow/popup/heads/cow-list-popup-head-blaarkop-brown.svg": [
		1577,
		9,
		760
	],
	"./kaasfarm/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-black.svg": [
		1578,
		9,
		761
	],
	"./kaasfarm/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-brown.svg": [
		1579,
		9,
		762
	],
	"./kaasfarm/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-rainbow.svg": [
		1580,
		9,
		763
	],
	"./kaasfarm/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-white.svg": [
		1581,
		9,
		764
	],
	"./kaasfarm/16x9/actors/cow/popup/heads/cow-list-popup-head-jersey-brown.svg": [
		1582,
		9,
		765
	],
	"./kaasfarm/16x9/actors/cow/popup/heads/cow-list-popup-head-jersey-white.svg": [
		1583,
		9,
		766
	],
	"./kaasfarm/16x9/actors/cow/popup/heads/cow-list-popup-head-lakenvelder-black.svg": [
		1584,
		9,
		767
	],
	"./kaasfarm/16x9/actors/cow/popup/heads/cow-list-popup-head-lakenvelder-brown.svg": [
		1585,
		9,
		768
	],
	"./kaasfarm/16x9/actors/cow/popup/heads/cow-list-popup-head-maasRijn-brown.svg": [
		1586,
		9,
		769
	],
	"./kaasfarm/16x9/actors/cow/virtualFarmAvatars/cow-maas-rijn.svg": [
		1587,
		9,
		770
	],
	"./kaasfarm/16x9/actors/cow/virtualFarmAvatars/cowBlaarKop--one.svg": [
		1588,
		9,
		771
	],
	"./kaasfarm/16x9/actors/cow/virtualFarmAvatars/cowBlaarKop--two.svg": [
		1589,
		9,
		772
	],
	"./kaasfarm/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--one.svg": [
		1590,
		9,
		773
	],
	"./kaasfarm/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--three.svg": [
		1591,
		9,
		774
	],
	"./kaasfarm/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--two.svg": [
		1592,
		9,
		775
	],
	"./kaasfarm/16x9/actors/cow/virtualFarmAvatars/cowJersey--one.svg": [
		1593,
		9,
		776
	],
	"./kaasfarm/16x9/actors/cow/virtualFarmAvatars/cowJersey--two.svg": [
		1594,
		9,
		777
	],
	"./kaasfarm/16x9/actors/cow/virtualFarmAvatars/cowLakenvelder--one.svg": [
		1595,
		9,
		778
	],
	"./kaasfarm/16x9/actors/cow/virtualFarmAvatars/cowLakenvelder--two.svg": [
		1596,
		9,
		779
	],
	"./kaasfarm/16x9/actors/cow/virtualFarmAvatars/cowMaasRijn--one.svg": [
		1597,
		9,
		780
	],
	"./kaasfarm/16x9/actors/cow/virtualFarmAvatars/cowPride--one.svg": [
		1598,
		9,
		781
	],
	"./kaasfarm/16x9/actors/dairyfactory/dairy-robot-factory.svg": [
		1599,
		9,
		782
	],
	"./kaasfarm/16x9/actors/discovery/discoveryRobot.svg": [
		1600,
		9,
		783
	],
	"./kaasfarm/16x9/actors/farmer/farmer-female.svg": [
		1601,
		9,
		784
	],
	"./kaasfarm/16x9/actors/farmer/farmer-male.svg": [
		1602,
		9,
		785
	],
	"./kaasfarm/16x9/actors/grazeway/grazeway-door.svg": [
		1603,
		9,
		786
	],
	"./kaasfarm/16x9/actors/grazeway/grazeway-feature.svg": [
		1604,
		9,
		787
	],
	"./kaasfarm/16x9/actors/icecreamfactory/ice-cream-factory.svg": [
		1605,
		9,
		788
	],
	"./kaasfarm/16x9/actors/milkfactory/milk-factory-new.svg": [
		1606,
		9,
		789
	],
	"./kaasfarm/16x9/actors/milkfactory/milk-factory.svg": [
		1607,
		9,
		790
	],
	"./kaasfarm/16x9/onboarding/welcomeScreenKaas/cheese-image.svg": [
		1608,
		9,
		791
	],
	"./kaasfarm/16x9/onboarding/welcomeScreenKaas/cutted-cheese-image.svg": [
		1609,
		9,
		792
	],
	"./kaasfarm/16x9/onboarding/welcomeScreenKaas/farmer-image.svg": [
		1610,
		9,
		793
	],
	"./kaasfarm/16x9/onboarding/welcomeScreenKaas/ribbon-title.svg": [
		1611,
		9,
		794
	],
	"./lely/16x9/actors/actorFrame/actorFrame.svg": [
		1612,
		9,
		795
	],
	"./lely/16x9/actors/actorFrame/actorFrameAdult.svg": [
		1613,
		9,
		796
	],
	"./lely/16x9/actors/astronautfactory/astronaut--popup--image.svg": [
		1614,
		9,
		797
	],
	"./lely/16x9/actors/astronautfactory/astronaut-landing-page.svg": [
		1615,
		9,
		798
	],
	"./lely/16x9/actors/backgroundLayers/mountain1.svg": [
		1616,
		9,
		799
	],
	"./lely/16x9/actors/backgroundLayers/mountain2.svg": [
		1617,
		9,
		800
	],
	"./lely/16x9/actors/backgroundLayers/mountain3.svg": [
		1618,
		9,
		801
	],
	"./lely/16x9/actors/backgroundLayers/mountain4.svg": [
		1619,
		9,
		802
	],
	"./lely/16x9/actors/backgroundLayers/mountain5.svg": [
		1620,
		9,
		803
	],
	"./lely/16x9/actors/brand/brand-logo.svg": [
		1621,
		9,
		804
	],
	"./lely/16x9/actors/calf/calf-blaarkop-black.svg": [
		1622,
		9,
		805
	],
	"./lely/16x9/actors/calf/calf-blaarkop-brown.svg": [
		1623,
		9,
		806
	],
	"./lely/16x9/actors/calf/calf-holstein-black.svg": [
		1624,
		9,
		807
	],
	"./lely/16x9/actors/calf/calf-holstein-brown.svg": [
		1625,
		9,
		808
	],
	"./lely/16x9/actors/calf/calf-holstein-rainbow.svg": [
		1626,
		9,
		809
	],
	"./lely/16x9/actors/calf/calf-holstein-white.svg": [
		1627,
		9,
		810
	],
	"./lely/16x9/actors/calf/calf-jersey-brown.svg": [
		1628,
		9,
		811
	],
	"./lely/16x9/actors/calf/calf-jersey-white.svg": [
		1629,
		9,
		812
	],
	"./lely/16x9/actors/calf/calf-lakenvelder-black.svg": [
		1630,
		9,
		813
	],
	"./lely/16x9/actors/calf/calf-lakenvelder-brown.svg": [
		1631,
		9,
		814
	],
	"./lely/16x9/actors/calf/calf-maas-rijn-brown.svg": [
		1632,
		9,
		815
	],
	"./lely/16x9/actors/cat/cat_appearing.svg": [
		1633,
		9,
		816
	],
	"./lely/16x9/actors/cat/cat_disappearing.svg": [
		1634,
		9,
		817
	],
	"./lely/16x9/actors/cat/poof_sprite.svg": [
		1635,
		9,
		818
	],
	"./lely/16x9/actors/cheesefactory/cheese-factory.svg": [
		1636,
		9,
		819
	],
	"./lely/16x9/actors/cow/body/cow-friesian.svg": [
		1637,
		9,
		820
	],
	"./lely/16x9/actors/cow/body/cow-holstein.svg": [
		1638,
		9,
		821
	],
	"./lely/16x9/actors/cow/body/cow-jersey.svg": [
		1639,
		9,
		822
	],
	"./lely/16x9/actors/cow/body/cow-pride.svg": [
		1640,
		9,
		823
	],
	"./lely/16x9/actors/cow/body/cow-whiteBlack.svg": [
		1641,
		9,
		824
	],
	"./lely/16x9/actors/cow/heads/cow-list-popup-head-1.svg": [
		1642,
		9,
		825
	],
	"./lely/16x9/actors/cow/heads/cow-list-popup-head-10.svg": [
		1643,
		9,
		826
	],
	"./lely/16x9/actors/cow/heads/cow-list-popup-head-11.svg": [
		1644,
		9,
		827
	],
	"./lely/16x9/actors/cow/heads/cow-list-popup-head-2.svg": [
		1645,
		9,
		828
	],
	"./lely/16x9/actors/cow/heads/cow-list-popup-head-3.svg": [
		1646,
		9,
		829
	],
	"./lely/16x9/actors/cow/heads/cow-list-popup-head-4.svg": [
		1647,
		9,
		830
	],
	"./lely/16x9/actors/cow/heads/cow-list-popup-head-5.svg": [
		1648,
		9,
		831
	],
	"./lely/16x9/actors/cow/heads/cow-list-popup-head-6.svg": [
		1649,
		9,
		832
	],
	"./lely/16x9/actors/cow/heads/cow-list-popup-head-7.svg": [
		1650,
		9,
		833
	],
	"./lely/16x9/actors/cow/heads/cow-list-popup-head-8.svg": [
		1651,
		9,
		834
	],
	"./lely/16x9/actors/cow/heads/cow-list-popup-head-9.svg": [
		1652,
		9,
		835
	],
	"./lely/16x9/actors/cow/popup/cow-list-popup-head-adults.svg": [
		1653,
		9,
		836
	],
	"./lely/16x9/actors/cow/popup/heads/cow-list-popup-head-blaarkop-black.svg": [
		1654,
		9,
		837
	],
	"./lely/16x9/actors/cow/popup/heads/cow-list-popup-head-blaarkop-brown.svg": [
		1655,
		9,
		838
	],
	"./lely/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-black.svg": [
		1656,
		9,
		839
	],
	"./lely/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-brown.svg": [
		1657,
		9,
		840
	],
	"./lely/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-rainbow.svg": [
		1658,
		9,
		841
	],
	"./lely/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-white.svg": [
		1659,
		9,
		842
	],
	"./lely/16x9/actors/cow/popup/heads/cow-list-popup-head-jersey-brown.svg": [
		1660,
		9,
		843
	],
	"./lely/16x9/actors/cow/popup/heads/cow-list-popup-head-jersey-white.svg": [
		1661,
		9,
		844
	],
	"./lely/16x9/actors/cow/popup/heads/cow-list-popup-head-lakenvelder-black.svg": [
		1662,
		9,
		845
	],
	"./lely/16x9/actors/cow/popup/heads/cow-list-popup-head-lakenvelder-brown.svg": [
		1663,
		9,
		846
	],
	"./lely/16x9/actors/cow/popup/heads/cow-list-popup-head-maasRijn-brown.svg": [
		1664,
		9,
		847
	],
	"./lely/16x9/actors/cow/virtualFarmAvatars/cow-maas-rijn.svg": [
		1665,
		9,
		848
	],
	"./lely/16x9/actors/cow/virtualFarmAvatars/cowBlaarKop--one.svg": [
		1666,
		9,
		849
	],
	"./lely/16x9/actors/cow/virtualFarmAvatars/cowBlaarKop--two.svg": [
		1667,
		9,
		850
	],
	"./lely/16x9/actors/cow/virtualFarmAvatars/cowBlaarkop--one.svg": [
		1668,
		9,
		851
	],
	"./lely/16x9/actors/cow/virtualFarmAvatars/cowBlaarkop--two.svg": [
		1669,
		9,
		852
	],
	"./lely/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--one.svg": [
		1670,
		9,
		853
	],
	"./lely/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--three.svg": [
		1671,
		9,
		854
	],
	"./lely/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--two.svg": [
		1672,
		9,
		855
	],
	"./lely/16x9/actors/cow/virtualFarmAvatars/cowJersey--one.svg": [
		1673,
		9,
		856
	],
	"./lely/16x9/actors/cow/virtualFarmAvatars/cowJersey--two.svg": [
		1674,
		9,
		857
	],
	"./lely/16x9/actors/cow/virtualFarmAvatars/cowLakenvelder--one.svg": [
		1675,
		9,
		858
	],
	"./lely/16x9/actors/cow/virtualFarmAvatars/cowLakenvelder--two.svg": [
		1676,
		9,
		859
	],
	"./lely/16x9/actors/cow/virtualFarmAvatars/cowMaasRijn--one.svg": [
		1677,
		9,
		860
	],
	"./lely/16x9/actors/cow/virtualFarmAvatars/cowPride--one.svg": [
		1678,
		9,
		861
	],
	"./lely/16x9/actors/dairyfactory/dairy-robot-factory.svg": [
		1679,
		9,
		862
	],
	"./lely/16x9/actors/discovery/cow_excrement_brown.svg": [
		1680,
		9,
		863
	],
	"./lely/16x9/actors/discovery/cow_excrement_rainbow.svg": [
		1681,
		9,
		864
	],
	"./lely/16x9/actors/discovery/discoveryRobot.svg": [
		1682,
		9,
		865
	],
	"./lely/16x9/actors/discovery/discoveryRobotSprite.svg": [
		1683,
		9,
		866
	],
	"./lely/16x9/actors/discovery/discoveryRobot_moveBottomEdge.svg": [
		1684,
		9,
		867
	],
	"./lely/16x9/actors/discovery/discoveryRobot_moveLeftEdge.svg": [
		1685,
		9,
		868
	],
	"./lely/16x9/actors/discovery/discoveryRobot_moveRightEdge.svg": [
		1686,
		9,
		869
	],
	"./lely/16x9/actors/discovery/discoveryRobot_moveTopEdge.svg": [
		1687,
		9,
		870
	],
	"./lely/16x9/actors/discoveryssw90/discoveryRobotSw.svg": [
		1688,
		9,
		871
	],
	"./lely/16x9/actors/discoveryssw90/discoveryRobot_moveBottomEdge.svg": [
		1689,
		9,
		872
	],
	"./lely/16x9/actors/discoveryssw90/discoveryRobot_moveLeftEdge.svg": [
		1690,
		9,
		873
	],
	"./lely/16x9/actors/discoveryssw90/discoveryRobot_moveRightEdge.svg": [
		1691,
		9,
		874
	],
	"./lely/16x9/actors/discoveryssw90/discoveryRobot_moveTopEdge.svg": [
		1692,
		9,
		875
	],
	"./lely/16x9/actors/farmer/farmer-female.svg": [
		1693,
		9,
		876
	],
	"./lely/16x9/actors/farmer/farmer-male.svg": [
		1694,
		9,
		877
	],
	"./lely/16x9/actors/grazeway/grazeway-door.svg": [
		1695,
		9,
		878
	],
	"./lely/16x9/actors/grazeway/grazeway-feature.svg": [
		1696,
		9,
		879
	],
	"./lely/16x9/actors/icecreamfactory/ice-cream-factory.svg": [
		1697,
		9,
		880
	],
	"./lely/16x9/actors/luna/lunaRobot.svg": [
		1698,
		9,
		881
	],
	"./lely/16x9/actors/milkbottle/milkBottle.svg": [
		1699,
		9,
		882
	],
	"./lely/16x9/actors/milkbottle/waveMilk.svg": [
		1700,
		9,
		883
	],
	"./lely/16x9/actors/milkfactory/milk-factory-new.svg": [
		1701,
		9,
		884
	],
	"./lely/16x9/actors/milkfactory/milk-factory.svg": [
		1702,
		9,
		885
	],
	"./lely/16x9/actors/milkfactory/milkFactoryAdult.svg": [
		1703,
		9,
		886
	],
	"./lely/16x9/actors/milkfactory/orbiter_animation.svg": [
		1704,
		9,
		887
	],
	"./lely/16x9/actors/pet/pet--alpaca.svg": [
		1705,
		9,
		888
	],
	"./lely/16x9/actors/pet/pet--bigDog.svg": [
		1706,
		9,
		889
	],
	"./lely/16x9/actors/pet/pet--cat.svg": [
		1707,
		9,
		890
	],
	"./lely/16x9/actors/pet/pet--chicken.svg": [
		1708,
		9,
		891
	],
	"./lely/16x9/actors/pet/pet--donkey.svg": [
		1709,
		9,
		892
	],
	"./lely/16x9/actors/pet/pet--goat.svg": [
		1710,
		9,
		893
	],
	"./lely/16x9/actors/pet/pet--horse.svg": [
		1711,
		9,
		894
	],
	"./lely/16x9/actors/pet/pet--llama.svg": [
		1712,
		9,
		895
	],
	"./lely/16x9/actors/pet/pet--mediumDog.svg": [
		1713,
		9,
		896
	],
	"./lely/16x9/actors/pet/pet--pony.svg": [
		1714,
		9,
		897
	],
	"./lely/16x9/actors/pet/pet--sheep.svg": [
		1715,
		9,
		898
	],
	"./lely/16x9/actors/pet/pet--smallDog.svg": [
		1716,
		9,
		899
	],
	"./lely/16x9/actors/shop/shop.svg": [
		1717,
		9,
		900
	],
	"./lely/16x9/actors/solarPanel/solarPanel.svg": [
		1718,
		9,
		901
	],
	"./lely/16x9/actors/solarPanel/solarPanelPopupImage.svg": [
		1719,
		9,
		902
	],
	"./lely/16x9/actors/sustainabilityFarm/0af8c747325d34de62f7ab45dbf4a58a.png": [
		1720,
		7,
		903
	],
	"./lely/16x9/actors/sustainabilityFarm/sustModal.png": [
		1721,
		7,
		904
	],
	"./lely/16x9/actors/sustainabilityFarm/sustainability.svg": [
		1722,
		9,
		905
	],
	"./lely/16x9/actors/sustainabilityFarm/sustainabilityPopup.jpg": [
		1723,
		7,
		906
	],
	"./lely/16x9/actors/sustainabilityFarm/sustainabilityPopupImage.jpg": [
		1724,
		7,
		907
	],
	"./lely/16x9/actors/sustainabilityFarm/sustainabilityPopupImage.svg": [
		1725,
		9,
		908
	],
	"./lely/16x9/actors/sustainabilityFarm/sustainabilityPopupImageDefault.jpg": [
		1726,
		7,
		909
	],
	"./lely/16x9/actors/tractor/tractor.svg": [
		1727,
		9,
		910
	],
	"./lely/16x9/actors/vector/juno_back.svg": [
		1728,
		9,
		911
	],
	"./lely/16x9/actors/vector/juno_front.svg": [
		1729,
		9,
		912
	],
	"./lely/16x9/actors/vector/juno_front_story.svg": [
		1730,
		9,
		913
	],
	"./lely/16x9/actors/vector/juno_front_story_adult.svg": [
		1731,
		9,
		914
	],
	"./lely/16x9/actors/vector/vector.svg": [
		1732,
		9,
		915
	],
	"./lely/16x9/actors/vector/vector_back.svg": [
		1733,
		9,
		916
	],
	"./lely/16x9/actors/vector/vector_front.png": [
		1734,
		7,
		917
	],
	"./lely/16x9/adminpanel/appSideBarIcons/about_you_icon.svg": [
		1735,
		9,
		918
	],
	"./lely/16x9/adminpanel/appSideBarIcons/animals_icon.svg": [
		1736,
		9,
		919
	],
	"./lely/16x9/adminpanel/appSideBarIcons/farm_icon.svg": [
		1737,
		9,
		920
	],
	"./lely/16x9/adminpanel/appSideBarIcons/pets_icon.svg": [
		1738,
		9,
		921
	],
	"./lely/16x9/adminpanel/appSideBarIcons/robot_icon.svg": [
		1739,
		9,
		922
	],
	"./lely/16x9/adminpanel/cowBreed/cow-blaarkop-one.svg": [
		1740,
		9,
		923
	],
	"./lely/16x9/adminpanel/cowBreed/cow-blaarkop-two.svg": [
		1741,
		9,
		924
	],
	"./lely/16x9/adminpanel/cowBreed/cow-holstein-friesian-one.svg": [
		1742,
		9,
		925
	],
	"./lely/16x9/adminpanel/cowBreed/cow-holstein-friesian-three.svg": [
		1743,
		9,
		926
	],
	"./lely/16x9/adminpanel/cowBreed/cow-holstein-friesian-two.svg": [
		1744,
		9,
		927
	],
	"./lely/16x9/adminpanel/cowBreed/cow-jersey-one.svg": [
		1745,
		9,
		928
	],
	"./lely/16x9/adminpanel/cowBreed/cow-jersey-two.svg": [
		1746,
		9,
		929
	],
	"./lely/16x9/adminpanel/cowBreed/cow-lakenvelder-one.svg": [
		1747,
		9,
		930
	],
	"./lely/16x9/adminpanel/cowBreed/cow-lakenvelder-two.svg": [
		1748,
		9,
		931
	],
	"./lely/16x9/adminpanel/cowBreed/cow-maas-rijn.svg": [
		1749,
		9,
		932
	],
	"./lely/16x9/adminpanel/cowBreed/cow-pride-one.svg": [
		1750,
		9,
		933
	],
	"./lely/16x9/adminpanel/cowPreview/cow-preview-black-stryped.svg": [
		1751,
		9,
		934
	],
	"./lely/16x9/adminpanel/cowPreview/cow-preview-black-whiteBlack.svg": [
		1752,
		9,
		935
	],
	"./lely/16x9/adminpanel/cowPreview/cow-preview-brown.svg": [
		1753,
		9,
		936
	],
	"./lely/16x9/adminpanel/cowPreview/cow-preview-large-pride.svg": [
		1754,
		9,
		937
	],
	"./lely/16x9/adminpanel/cowPreview/cow-preview-pride.svg": [
		1755,
		9,
		938
	],
	"./lely/16x9/adminpanel/cowPreview/cow-preview-white.svg": [
		1756,
		9,
		939
	],
	"./lely/16x9/adminpanel/dogSize/radio-large-dog.svg": [
		1757,
		9,
		940
	],
	"./lely/16x9/adminpanel/dogSize/radio-medium-dog.svg": [
		1758,
		9,
		941
	],
	"./lely/16x9/adminpanel/dogSize/radio-small-dog.svg": [
		1759,
		9,
		942
	],
	"./lely/16x9/adminpanel/farmFeatureCheckbox/astronaut-checkbox-feature.svg": [
		1760,
		9,
		943
	],
	"./lely/16x9/adminpanel/farmFeatureCheckbox/calm-checkbox-feature.svg": [
		1761,
		9,
		944
	],
	"./lely/16x9/adminpanel/farmFeatureCheckbox/collector-checkbox-feature.svg": [
		1762,
		9,
		945
	],
	"./lely/16x9/adminpanel/farmFeatureCheckbox/discovery-90.svg": [
		1763,
		9,
		946
	],
	"./lely/16x9/adminpanel/farmFeatureCheckbox/discovery-mobile-feature.svg": [
		1764,
		9,
		947
	],
	"./lely/16x9/adminpanel/farmFeatureCheckbox/grazeway-checkbox-feature.svg": [
		1765,
		9,
		948
	],
	"./lely/16x9/adminpanel/farmFeatureCheckbox/juno-radio-button.svg": [
		1766,
		9,
		949
	],
	"./lely/16x9/adminpanel/farmFeatureCheckbox/luna-checkbox-feature.svg": [
		1767,
		9,
		950
	],
	"./lely/16x9/adminpanel/farmFeatureCheckbox/luna-checkbox-mobile-feature.svg": [
		1768,
		9,
		951
	],
	"./lely/16x9/adminpanel/farmFeatureCheckbox/no-robot-feature.svg": [
		1769,
		9,
		952
	],
	"./lely/16x9/adminpanel/farmFeatureCheckbox/orbiter-checkbox-feature.svg": [
		1770,
		9,
		953
	],
	"./lely/16x9/adminpanel/farmFeatureCheckbox/vector-checkbox-feature.svg": [
		1771,
		9,
		954
	],
	"./lely/16x9/adminpanel/farmFeatureCheckbox/vector-radio-button.svg": [
		1772,
		9,
		955
	],
	"./lely/16x9/adminpanel/farmFeatures/mobile-phone-admin-panel.svg": [
		1773,
		9,
		956
	],
	"./lely/16x9/adminpanel/farmStyles/farmStyleOne.svg": [
		1774,
		9,
		957
	],
	"./lely/16x9/adminpanel/farmStyles/farmStyleThree.svg": [
		1775,
		9,
		958
	],
	"./lely/16x9/adminpanel/farmStyles/farmStyleTwo.svg": [
		1776,
		9,
		959
	],
	"./lely/16x9/adminpanel/farmerStyle/radio-farmer-female.svg": [
		1777,
		9,
		960
	],
	"./lely/16x9/adminpanel/farmerStyle/radio-farmer-male.svg": [
		1778,
		9,
		961
	],
	"./lely/16x9/adminpanel/hide/hide-2.svg": [
		1779,
		9,
		962
	],
	"./lely/16x9/adminpanel/hide/hide-3.svg": [
		1780,
		9,
		963
	],
	"./lely/16x9/adminpanel/hide/hide-4.svg": [
		1781,
		9,
		964
	],
	"./lely/16x9/adminpanel/hide/hide-5.svg": [
		1782,
		9,
		965
	],
	"./lely/16x9/adminpanel/hide/hide-6.svg": [
		1783,
		9,
		966
	],
	"./lely/16x9/adminpanel/hide/hide-7.svg": [
		1784,
		9,
		967
	],
	"./lely/16x9/adminpanel/hide/hide-8.svg": [
		1785,
		9,
		968
	],
	"./lely/16x9/adminpanel/hide/hide-none.svg": [
		1786,
		9,
		969
	],
	"./lely/16x9/adminpanel/imageDropZone/imageFrameNoImage.svg": [
		1787,
		9,
		970
	],
	"./lely/16x9/adminpanel/imageDropZone/imageFrameOnly.svg": [
		1788,
		9,
		971
	],
	"./lely/16x9/adminpanel/imageDropZone/image_icon.svg": [
		1789,
		9,
		972
	],
	"./lely/16x9/adminpanel/imageDropZone/uploadIcon.svg": [
		1790,
		9,
		973
	],
	"./lely/16x9/adminpanel/login/login-page-background.svg": [
		1791,
		9,
		974
	],
	"./lely/16x9/adminpanel/otherAnimal/radio-alpaca.svg": [
		1792,
		9,
		975
	],
	"./lely/16x9/adminpanel/otherAnimal/radio-cat.svg": [
		1793,
		9,
		976
	],
	"./lely/16x9/adminpanel/otherAnimal/radio-chicken.svg": [
		1794,
		9,
		977
	],
	"./lely/16x9/adminpanel/otherAnimal/radio-donkey.svg": [
		1795,
		9,
		978
	],
	"./lely/16x9/adminpanel/otherAnimal/radio-goat.svg": [
		1796,
		9,
		979
	],
	"./lely/16x9/adminpanel/otherAnimal/radio-horse.svg": [
		1797,
		9,
		980
	],
	"./lely/16x9/adminpanel/otherAnimal/radio-llama.svg": [
		1798,
		9,
		981
	],
	"./lely/16x9/adminpanel/otherAnimal/radio-pony.svg": [
		1799,
		9,
		982
	],
	"./lely/16x9/adminpanel/otherAnimal/radio-sheep.svg": [
		1800,
		9,
		983
	],
	"./lely/16x9/adminpanel/producingDevice/radio-cheese.svg": [
		1801,
		9,
		984
	],
	"./lely/16x9/adminpanel/producingDevice/radio-dairy.svg": [
		1802,
		9,
		985
	],
	"./lely/16x9/adminpanel/producingDevice/radio-dairy2.svg": [
		1803,
		9,
		986
	],
	"./lely/16x9/adminpanel/producingDevice/radio-icecream.svg": [
		1804,
		9,
		987
	],
	"./lely/16x9/adminpanel/producingDevice/radio-orbiter.svg": [
		1805,
		9,
		988
	],
	"./lely/16x9/adminpanel/story/sample_story_slide.svg": [
		1806,
		9,
		989
	],
	"./lely/16x9/popups/astronaut/astronaut--popup--image.svg": [
		1807,
		9,
		990
	],
	"./lely/16x9/popups/astronaut/cow--astronaut--robot.svg": [
		1808,
		9,
		991
	],
	"./lely/16x9/popups/batchList/milkBottle.svg": [
		1809,
		9,
		992
	],
	"./lely/16x9/popups/batchList/milkBottleAdult.svg": [
		1810,
		9,
		993
	],
	"./lely/16x9/popups/calmrobot/calm--popup--image.svg": [
		1811,
		9,
		994
	],
	"./lely/16x9/popups/calmrobot/calm-robot-popup.svg": [
		1812,
		9,
		995
	],
	"./lely/16x9/popups/calmrobot/calm-robot.svg": [
		1813,
		9,
		996
	],
	"./lely/16x9/popups/cheesefactory/cheese-factory-popup.svg": [
		1814,
		9,
		997
	],
	"./lely/16x9/popups/cow/cow-head-blaarkop-one.svg": [
		1815,
		9,
		998
	],
	"./lely/16x9/popups/cow/cow-head-blaarkop-two.svg": [
		1816,
		9,
		999
	],
	"./lely/16x9/popups/cow/cow-head-holstein-one.svg": [
		1817,
		9,
		1000
	],
	"./lely/16x9/popups/cow/cow-head-holstein-three.svg": [
		1818,
		9,
		1001
	],
	"./lely/16x9/popups/cow/cow-head-holstein-two.svg": [
		1819,
		9,
		1002
	],
	"./lely/16x9/popups/cow/cow-head-jersey-one.svg": [
		1820,
		9,
		1003
	],
	"./lely/16x9/popups/cow/cow-head-jersey-two.svg": [
		1821,
		9,
		1004
	],
	"./lely/16x9/popups/cow/cow-head-lakenvelder-one.svg": [
		1822,
		9,
		1005
	],
	"./lely/16x9/popups/cow/cow-head-lakenvelder-two.svg": [
		1823,
		9,
		1006
	],
	"./lely/16x9/popups/cow/cow-head-pride.svg": [
		1824,
		9,
		1007
	],
	"./lely/16x9/popups/cow/cow-head-rijn-one.svg": [
		1825,
		9,
		1008
	],
	"./lely/16x9/popups/cow/cow-popup-head-2.svg": [
		1826,
		9,
		1009
	],
	"./lely/16x9/popups/cow/cow-popup-head-3.svg": [
		1827,
		9,
		1010
	],
	"./lely/16x9/popups/cow/cow-popup-intro.svg": [
		1828,
		9,
		1011
	],
	"./lely/16x9/popups/cow/cow-popup.svg": [
		1829,
		9,
		1012
	],
	"./lely/16x9/popups/cow/cowNameChosenParty.svg": [
		1830,
		9,
		1013
	],
	"./lely/16x9/popups/cow/namePollBackground.svg": [
		1831,
		9,
		1014
	],
	"./lely/16x9/popups/cow/namePollPartyFlute.svg": [
		1832,
		9,
		1015
	],
	"./lely/16x9/popups/cow/namePollPartyHat-2.svg": [
		1833,
		9,
		1016
	],
	"./lely/16x9/popups/cow/namePollPartyHat-adults.svg": [
		1834,
		9,
		1017
	],
	"./lely/16x9/popups/cow/namePollPartyHat.svg": [
		1835,
		9,
		1018
	],
	"./lely/16x9/popups/cow/nameVotePopupBackground.png": [
		1836,
		7,
		1019
	],
	"./lely/16x9/popups/cowlist/cow-list-popup-head-1.svg": [
		1837,
		9,
		1020
	],
	"./lely/16x9/popups/cowlist/cow-list-popup-head-2.svg": [
		1838,
		9,
		1021
	],
	"./lely/16x9/popups/cowlist/cow-list-popup-head-3.svg": [
		1839,
		9,
		1022
	],
	"./lely/16x9/popups/cowlist/cow-list-popup-head-4.svg": [
		1840,
		9,
		1023
	],
	"./lely/16x9/popups/dairy/dairy--popup--roboto.svg": [
		1841,
		9,
		1024
	],
	"./lely/16x9/popups/default/defaultAlpaca.svg": [
		1842,
		9,
		1025
	],
	"./lely/16x9/popups/default/defaultBigDog.svg": [
		1843,
		9,
		1026
	],
	"./lely/16x9/popups/default/defaultCat.svg": [
		1844,
		9,
		1027
	],
	"./lely/16x9/popups/default/defaultChicken.svg": [
		1845,
		9,
		1028
	],
	"./lely/16x9/popups/default/defaultDonkey.svg": [
		1846,
		9,
		1029
	],
	"./lely/16x9/popups/default/defaultGoat.svg": [
		1847,
		9,
		1030
	],
	"./lely/16x9/popups/default/defaultHorse.svg": [
		1848,
		9,
		1031
	],
	"./lely/16x9/popups/default/defaultHouse.svg": [
		1849,
		9,
		1032
	],
	"./lely/16x9/popups/default/defaultLama.svg": [
		1850,
		9,
		1033
	],
	"./lely/16x9/popups/default/defaultMediumDog.svg": [
		1851,
		9,
		1034
	],
	"./lely/16x9/popups/default/defaultPony.svg": [
		1852,
		9,
		1035
	],
	"./lely/16x9/popups/default/defaultSheep.svg": [
		1853,
		9,
		1036
	],
	"./lely/16x9/popups/default/defaultShop.svg": [
		1854,
		9,
		1037
	],
	"./lely/16x9/popups/default/defaultSmallDog.svg": [
		1855,
		9,
		1038
	],
	"./lely/16x9/popups/default/defaultTractor.svg": [
		1856,
		9,
		1039
	],
	"./lely/16x9/popups/default/femaleFarmer.svg": [
		1857,
		9,
		1040
	],
	"./lely/16x9/popups/default/maleFarmer.svg": [
		1858,
		9,
		1041
	],
	"./lely/16x9/popups/discovery/collector--popup--image.svg": [
		1859,
		9,
		1042
	],
	"./lely/16x9/popups/discovery/discovery-popup-image.svg": [
		1860,
		9,
		1043
	],
	"./lely/16x9/popups/discoverySW/discovery90--popup--image.svg": [
		1861,
		9,
		1044
	],
	"./lely/16x9/popups/discoverySW/discoverySW.svg": [
		1862,
		9,
		1045
	],
	"./lely/16x9/popups/grazeway/grazeway--robot--popup.svg": [
		1863,
		9,
		1046
	],
	"./lely/16x9/popups/grazeway/grazeweay--popup--image.svg": [
		1864,
		9,
		1047
	],
	"./lely/16x9/popups/icecreamfactory/icecream-factory-popup.svg": [
		1865,
		9,
		1048
	],
	"./lely/16x9/popups/juno/junoPopup.svg": [
		1866,
		9,
		1049
	],
	"./lely/16x9/popups/juno/junoPopupAdult.svg": [
		1867,
		9,
		1050
	],
	"./lely/16x9/popups/lelyBrand/brand--popup--image.svg": [
		1868,
		9,
		1051
	],
	"./lely/16x9/popups/lelyBrand/lelyBrandLogo.svg": [
		1869,
		9,
		1052
	],
	"./lely/16x9/popups/livedata/liveDataArrow.svg": [
		1870,
		9,
		1053
	],
	"./lely/16x9/popups/livedata/liveDataArrowAdults.svg": [
		1871,
		9,
		1054
	],
	"./lely/16x9/popups/livedata/liveDataPopupBackground.svg": [
		1872,
		9,
		1055
	],
	"./lely/16x9/popups/livedata/liveIcon.svg": [
		1873,
		9,
		1056
	],
	"./lely/16x9/popups/livedata/liveIconAdults.svg": [
		1874,
		9,
		1057
	],
	"./lely/16x9/popups/luna/luna--popup--image.svg": [
		1875,
		9,
		1058
	],
	"./lely/16x9/popups/luna/luna.svg": [
		1876,
		9,
		1059
	],
	"./lely/16x9/popups/luna/lunaAdult.svg": [
		1877,
		9,
		1060
	],
	"./lely/16x9/popups/orbiter/orbiter--popup--image.svg": [
		1878,
		9,
		1061
	],
	"./lely/16x9/popups/orbiter/orbiter-popup-image.svg": [
		1879,
		9,
		1062
	],
	"./lely/16x9/popups/pet/dog-Popup-image.svg": [
		1880,
		9,
		1063
	],
	"./lely/16x9/popups/rumination/cow--rumination.svg": [
		1881,
		9,
		1064
	],
	"./lely/16x9/popups/rumination/rumination--popup--image.svg": [
		1882,
		9,
		1065
	],
	"./lely/16x9/popups/tour/arrow-popup-arrow-part.svg": [
		1883,
		9,
		1066
	],
	"./lely/16x9/popups/tour/arrow-popup-background-part.svg": [
		1884,
		9,
		1067
	],
	"./lely/16x9/popups/tour/arrow-right-button.svg": [
		1885,
		9,
		1068
	],
	"./lely/16x9/popups/tour/full-farm.svg": [
		1886,
		9,
		1069
	],
	"./lely/16x9/popups/vector/vector--popup-image.svg": [
		1887,
		9,
		1070
	],
	"./lely/16x9/popups/vector/vector--robot--image.svg": [
		1888,
		9,
		1071
	],
	"./lely/16x9/popups/vector/vectorButtonAdult.svg": [
		1889,
		9,
		1072
	],
	"./lely/16x9/popups/vehicle/red-tractor.svg": [
		1890,
		9,
		1073
	],
	"./lely/16x9/screens/ageSelection/age-selection-above-10-horizon.svg": [
		1891,
		9,
		1074
	],
	"./lely/16x9/screens/ageSelection/age-selection-above-10.svg": [
		1892,
		9,
		1075
	],
	"./lely/16x9/screens/ageSelection/age-selection-under-10.svg": [
		1893,
		9,
		1076
	],
	"./lely/16x9/screens/ageSelection/background-screen-select-age-horizon.svg": [
		1894,
		9,
		1077
	],
	"./lely/16x9/screens/ageSelection/background-screen-select-age.svg": [
		1895,
		9,
		1078
	],
	"./lely/16x9/screens/cowBarn/barn.svg": [
		1896,
		9,
		1079
	],
	"./lely/16x9/screens/cowBirth/cow-birth-first-slide.svg": [
		1897,
		9,
		1080
	],
	"./lely/16x9/screens/cowBirthday/calm-slide-calf.svg": [
		1898,
		9,
		1081
	],
	"./lely/16x9/screens/cowBirthday/cloud-temperature-logo.svg": [
		1899,
		9,
		1082
	],
	"./lely/16x9/screens/cowBirthday/cloud.svg": [
		1900,
		9,
		1083
	],
	"./lely/16x9/screens/cowBirthday/cow-birth-first-page.svg": [
		1901,
		9,
		1084
	],
	"./lely/16x9/screens/cowBox/box.svg": [
		1902,
		9,
		1085
	],
	"./lely/16x9/screens/cowCalmRobot/arrow-left-curve.svg": [
		1903,
		9,
		1086
	],
	"./lely/16x9/screens/cowCalmRobot/calm-slide-calf.svg": [
		1904,
		9,
		1087
	],
	"./lely/16x9/screens/cowCalmRobot/calmRobot.svg": [
		1905,
		9,
		1088
	],
	"./lely/16x9/screens/cowCalmRobot/cow-calm-slide-button.svg": [
		1906,
		9,
		1089
	],
	"./lely/16x9/screens/cowCalmRobot/cow-calm-slide.svg": [
		1907,
		9,
		1090
	],
	"./lely/16x9/screens/cowFirstBirthday/cow-first-birthday-slide-whistle.svg": [
		1908,
		9,
		1091
	],
	"./lely/16x9/screens/cowFirstBirthday/cow-first-birthday.svg": [
		1909,
		9,
		1092
	],
	"./lely/16x9/screens/cowFirstMilking/cow-first-calf.svg": [
		1910,
		9,
		1093
	],
	"./lely/16x9/screens/cowFirstMilking/cow-first-milking-button.svg": [
		1911,
		9,
		1094
	],
	"./lely/16x9/screens/cowFirstMilking/cow-first-milking-slide.svg": [
		1912,
		9,
		1095
	],
	"./lely/16x9/screens/cowFirstYear/calm-slide-calf.svg": [
		1913,
		9,
		1096
	],
	"./lely/16x9/screens/cowFirstYear/cow-first-year-slide.svg": [
		1914,
		9,
		1097
	],
	"./lely/16x9/screens/cowGaveBirth/cow-gave-birth-button.svg": [
		1915,
		9,
		1098
	],
	"./lely/16x9/screens/cowGaveBirthFourthSlide/cow-gave-birth-fourth-slide.svg": [
		1916,
		9,
		1099
	],
	"./lely/16x9/screens/cowGaveBirthFourthSlide/milk-bottles.svg": [
		1917,
		9,
		1100
	],
	"./lely/16x9/screens/cowGaveBirthSecondSlide/cow-gave-birth.svg": [
		1918,
		9,
		1101
	],
	"./lely/16x9/screens/cowIntro/cow-intro-page.svg": [
		1919,
		9,
		1102
	],
	"./lely/16x9/screens/cowIntro/cow-intro-second-slide.svg": [
		1920,
		9,
		1103
	],
	"./lely/16x9/screens/cowMilking/milking.svg": [
		1921,
		9,
		1104
	],
	"./lely/16x9/screens/cowOutro/CowOutroBottomArrow.svg": [
		1922,
		9,
		1105
	],
	"./lely/16x9/screens/cowOutro/CowOutroPageBackground.svg": [
		1923,
		9,
		1106
	],
	"./lely/16x9/screens/cowOutro/CowOutroRightArrowText.svg": [
		1924,
		9,
		1107
	],
	"./lely/16x9/screens/cowOutro/leftButtonCowOutroPage.svg": [
		1925,
		9,
		1108
	],
	"./lely/16x9/screens/cowOutro/rightButtonCowOutroPage.svg": [
		1926,
		9,
		1109
	],
	"./lely/16x9/screens/cowParent/arrow-down-to-the-parent.svg": [
		1927,
		9,
		1110
	],
	"./lely/16x9/screens/cowParent/arrow-to-the-parent.svg": [
		1928,
		9,
		1111
	],
	"./lely/16x9/screens/cowParent/cow-father-info.svg": [
		1929,
		9,
		1112
	],
	"./lely/16x9/screens/cowParent/cow-mother-info.svg": [
		1930,
		9,
		1113
	],
	"./lely/16x9/screens/cowParent/left-line-to-the-cow.svg": [
		1931,
		9,
		1114
	],
	"./lely/16x9/screens/cowParent/line-to-the-parents.svg": [
		1932,
		9,
		1115
	],
	"./lely/16x9/screens/unavailablePage/unavailable-page-background.svg": [
		1933,
		9,
		1116
	],
	"./lely/16x9/screens/virtualFarm/background.svg": [
		1934,
		9,
		1117
	],
	"./lely/16x9/screens/virtualFarm/background_new.svg": [
		1935,
		9,
		1118
	],
	"./lely/16x9/screens/virtualFarm/fence.svg": [
		1936,
		9,
		1119
	],
	"./lely/16x9/screens/welcomePage/background-welcome-page.svg": [
		1937,
		9,
		1120
	],
	"./lely/16x9/screens/welcomePage/cow-head.svg": [
		1938,
		9,
		1121
	],
	"./lely/16x9/stories/animalWelfareStory/cowAndCalfSlide.svg": [
		1939,
		9,
		1122
	],
	"./lely/16x9/stories/astronautLiveDataStory/arrow.svg": [
		1940,
		9,
		1123
	],
	"./lely/16x9/stories/astronautLiveDataStory/arrowBetweenSlides.svg": [
		1941,
		9,
		1124
	],
	"./lely/16x9/stories/astronautLiveDataStory/arrowConnectingText.svg": [
		1942,
		9,
		1125
	],
	"./lely/16x9/stories/astronautLiveDataStory/astronautLiveDataBackgroundWithTree.svg": [
		1943,
		9,
		1126
	],
	"./lely/16x9/stories/astronautLiveDataStory/astronautLiveDataBigCow.svg": [
		1944,
		9,
		1127
	],
	"./lely/16x9/stories/astronautLiveDataStory/astronautLiveDataStoryAdultArrow.svg": [
		1945,
		9,
		1128
	],
	"./lely/16x9/stories/astronautLiveDataStory/astronautLiveDataStoryBetweenMatrixCowAndTeetAnimation.svg": [
		1946,
		9,
		1129
	],
	"./lely/16x9/stories/astronautLiveDataStory/astronautLiveDataStorySelectionTriangle.svg": [
		1947,
		9,
		1130
	],
	"./lely/16x9/stories/astronautLiveDataStory/astronautLiveDataTeetAnimationSlideArrow.svg": [
		1948,
		9,
		1131
	],
	"./lely/16x9/stories/astronautLiveDataStory/astronautLiveDataTimeMilkedBackground.svg": [
		1949,
		9,
		1132
	],
	"./lely/16x9/stories/astronautLiveDataStory/astronautLiveDataTimeMilkedMixedBackground.svg": [
		1950,
		9,
		1133
	],
	"./lely/16x9/stories/astronautLiveDataStory/astronautSecondSlideAdultVersion.svg": [
		1951,
		9,
		1134
	],
	"./lely/16x9/stories/astronautLiveDataStory/backgroundAstronautLiveData.svg": [
		1952,
		9,
		1135
	],
	"./lely/16x9/stories/astronautLiveDataStory/backgroundMixBetweenMilkAndMatrix.svg": [
		1953,
		9,
		1136
	],
	"./lely/16x9/stories/astronautLiveDataStory/connectionArrows.svg": [
		1954,
		9,
		1137
	],
	"./lely/16x9/stories/astronautLiveDataStory/matrixConnectionBetweenTextBoxes.svg": [
		1955,
		9,
		1138
	],
	"./lely/16x9/stories/astronautLiveDataStory/matrixCows.svg": [
		1956,
		9,
		1139
	],
	"./lely/16x9/stories/astronautLiveDataStory/matrixMilkBottle.svg": [
		1957,
		9,
		1140
	],
	"./lely/16x9/stories/astronautLiveDataStory/matrixMilkBottles.svg": [
		1958,
		9,
		1141
	],
	"./lely/16x9/stories/astronautLiveDataStory/smallMilkBottle.svg": [
		1959,
		9,
		1142
	],
	"./lely/16x9/stories/astronautLiveDataStory/smallMilkBottles.svg": [
		1960,
		9,
		1143
	],
	"./lely/16x9/stories/astronautLiveDataStory/transitionTree.svg": [
		1961,
		9,
		1144
	],
	"./lely/16x9/stories/astronautLiveDataStory/udder.svg": [
		1962,
		9,
		1145
	],
	"./lely/16x9/stories/astronautLiveDataStory/udder_line_1.svg": [
		1963,
		9,
		1146
	],
	"./lely/16x9/stories/astronautLiveDataStory/udder_line_2.svg": [
		1964,
		9,
		1147
	],
	"./lely/16x9/stories/astronautLiveDataStory/udder_line_3.svg": [
		1965,
		9,
		1148
	],
	"./lely/16x9/stories/astronautLiveDataStory/udder_line_4.svg": [
		1966,
		9,
		1149
	],
	"./lely/16x9/stories/astronautstory/astronaut.jpg": [
		1967,
		7,
		1150
	],
	"./lely/16x9/stories/astronautstory/astronautStoryFirstSlideAdult.svg": [
		1968,
		9,
		1151
	],
	"./lely/16x9/stories/astronautstory/astronautStorySecondSlideAdult.svg": [
		1969,
		9,
		1152
	],
	"./lely/16x9/stories/astronautstory/astronautfifth.jpg": [
		1970,
		7,
		1153
	],
	"./lely/16x9/stories/astronautstory/astronautsecond.jpg": [
		1971,
		7,
		1154
	],
	"./lely/16x9/stories/astronautstory/astronautthird.jpg": [
		1972,
		7,
		1155
	],
	"./lely/16x9/stories/astronautstory/firstmilkingslide.svg": [
		1973,
		9,
		1156
	],
	"./lely/16x9/stories/astronautstory/milkingRobotStory.svg": [
		1974,
		9,
		1157
	],
	"./lely/16x9/stories/astronautstory/milkingRobotStoryFifthSlide.svg": [
		1975,
		9,
		1158
	],
	"./lely/16x9/stories/astronautstory/milkingRobotStorySecondSlide.svg": [
		1976,
		9,
		1159
	],
	"./lely/16x9/stories/astronautstory/milkingRobotStoryThirdSlide.svg": [
		1977,
		9,
		1160
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/elements/fenceOutroSlide.svg": [
		1978,
		9,
		1161
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/elements/house.svg": [
		1979,
		9,
		1162
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/elements/houseStyle2.svg": [
		1980,
		9,
		1163
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/elements/houseStyle3.svg": [
		1981,
		9,
		1164
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/elements/smallCowAndBush.svg": [
		1982,
		9,
		1165
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/elements/treeAndBushSecondSlide.svg": [
		1983,
		9,
		1166
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/barnFirstSlide.svg": [
		1984,
		9,
		1167
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/barnSecondSlideAdult.svg": [
		1985,
		9,
		1168
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/bigPartyFlag.svg": [
		1986,
		9,
		1169
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/bigPresentBox.svg": [
		1987,
		9,
		1170
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/bigTree.svg": [
		1988,
		9,
		1171
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/birthdayCake.svg": [
		1989,
		9,
		1172
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/birthdaySlide.svg": [
		1990,
		9,
		1173
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/cake.svg": [
		1991,
		9,
		1174
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/calendar.svg": [
		1992,
		9,
		1175
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/calfing_pen_transition_back.svg": [
		1993,
		9,
		1176
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/calmRobot.svg": [
		1994,
		9,
		1177
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/candle.svg": [
		1995,
		9,
		1178
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/cowOutroSlideFence.svg": [
		1996,
		9,
		1179
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/firstCalfAdultFirstSlide.svg": [
		1997,
		9,
		1180
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/firstCalfSecondSlide.svg": [
		1998,
		9,
		1181
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/firstCalfSecondSlideAdult.svg": [
		1999,
		9,
		1182
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/firstCalfSlide.svg": [
		2000,
		9,
		1183
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/firstCalfThirdSlide.svg": [
		2001,
		9,
		1184
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/firstCalfThirdSlideAdult.svg": [
		2002,
		9,
		1185
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/partyFlutes/partyFlute_1.svg": [
		2003,
		9,
		1186
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/partyFlutes/partyFlute_2.svg": [
		2004,
		9,
		1187
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/partyFlutes/partyFlute_3.svg": [
		2005,
		9,
		1188
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/partyHats/partyHat_1.svg": [
		2006,
		9,
		1189
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/partyHats/partyHat_2.svg": [
		2007,
		9,
		1190
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/partyHats/partyHat_3.svg": [
		2008,
		9,
		1191
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/pole.svg": [
		2009,
		9,
		1192
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/presentBox.svg": [
		2010,
		9,
		1193
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/rightPartOfTheTree.svg": [
		2011,
		9,
		1194
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/secondSlideCalm.svg": [
		2012,
		9,
		1195
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/secondSlideCalmVersion.svg": [
		2013,
		9,
		1196
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/smallPartyFlag.svg": [
		2014,
		9,
		1197
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/stork.svg": [
		2015,
		9,
		1198
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/thermometer.svg": [
		2016,
		9,
		1199
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/transitionSlideCalm.svg": [
		2017,
		9,
		1200
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/firstYear/trees-1.svg": [
		2018,
		9,
		1201
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/forestLeafage/background_forrest_leafage_01.svg": [
		2019,
		9,
		1202
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/forestLeafage/background_forrest_leafage_02.svg": [
		2020,
		9,
		1203
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/forestLeafage/background_forrest_leafage_03.svg": [
		2021,
		9,
		1204
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/forestLeafage/background_forrest_leafage_04.svg": [
		2022,
		9,
		1205
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/forestLeafage/background_forrest_leafage_05.svg": [
		2023,
		9,
		1206
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/forrest/forrest1.svg": [
		2024,
		9,
		1207
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/forrest/forrest2.svg": [
		2025,
		9,
		1208
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/forrest/forrest3.svg": [
		2026,
		9,
		1209
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/forrest/forrest4.svg": [
		2027,
		9,
		1210
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/forrest/forrest5.svg": [
		2028,
		9,
		1211
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/forrest2/forrest1.svg": [
		2029,
		9,
		1212
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/forrest2/forrest2.svg": [
		2030,
		9,
		1213
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/forrest2/forrest3.svg": [
		2031,
		9,
		1214
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/forrest2/forrest4.svg": [
		2032,
		9,
		1215
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/forrest2/forrest5.svg": [
		2033,
		9,
		1216
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/grass/grass1.svg": [
		2034,
		9,
		1217
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/grass/grass2.svg": [
		2035,
		7,
		1218
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/grass/grass3.svg": [
		2036,
		9,
		1219
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/grass/grass4.svg": [
		2037,
		9,
		1220
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/grass/grass5.svg": [
		2038,
		9,
		1221
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/grass/grass6.svg": [
		2039,
		9,
		1222
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/hills1/hills11.svg": [
		2040,
		9,
		1223
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/hills1/hills12.svg": [
		2041,
		9,
		1224
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/hills1/hills13.svg": [
		2042,
		9,
		1225
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/hills1/hills14.svg": [
		2043,
		9,
		1226
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/hills1/hills15.svg": [
		2044,
		9,
		1227
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/hills2/hills21.svg": [
		2045,
		9,
		1228
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/hills2/hills22.svg": [
		2046,
		9,
		1229
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/hills2/hills23.svg": [
		2047,
		9,
		1230
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/hills2/hills24.svg": [
		2048,
		9,
		1231
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/hills2/hills25.svg": [
		2049,
		9,
		1232
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/hills3/background_hills_01.svg": [
		2050,
		9,
		1233
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/hills3/background_hills_02.svg": [
		2051,
		9,
		1234
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/hills3/background_hills_03.svg": [
		2052,
		9,
		1235
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/hills3/background_hills_04.svg": [
		2053,
		9,
		1236
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/hills3/background_hills_05.svg": [
		2054,
		9,
		1237
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/mountains/mountain1.svg": [
		2055,
		9,
		1238
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/mountains/mountain2.svg": [
		2056,
		9,
		1239
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/mountains/mountain3.svg": [
		2057,
		9,
		1240
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/mountains/mountain4.svg": [
		2058,
		9,
		1241
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/mountains/mountain5.svg": [
		2059,
		9,
		1242
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/trees/background-pcd-treesAdult.svg": [
		2060,
		9,
		1243
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/trees/background_tree_01.svg": [
		2061,
		9,
		1244
	],
	"./lely/16x9/stories/cowDailyForAdult/background-layers/trees/rightHalfOfTheTree.svg": [
		2062,
		9,
		1245
	],
	"./lely/16x9/stories/cowDailyForAdult/backgrounds/background--intro--secondSlide.svg": [
		2063,
		9,
		1246
	],
	"./lely/16x9/stories/cowDailyForAdult/backgrounds/background--intro--slide.svg": [
		2064,
		9,
		1247
	],
	"./lely/16x9/stories/cowDailyForAdult/backgrounds/background--intro--transition-tree.svg": [
		2065,
		9,
		1248
	],
	"./lely/16x9/stories/cowDailyForAdult/backgrounds/background--siblingSlide.svg": [
		2066,
		9,
		1249
	],
	"./lely/16x9/stories/cowDailyForAdult/backgrounds/background-pcd-firstYear.svg": [
		2067,
		9,
		1250
	],
	"./lely/16x9/stories/cowDailyForAdult/backgrounds/background-pcd-firstYearSecondSlide.svg": [
		2068,
		9,
		1251
	],
	"./lely/16x9/stories/cowDailyForAdult/backgrounds/eating/background-pcd-eatingAdult1.svg": [
		2069,
		9,
		1252
	],
	"./lely/16x9/stories/cowDailyForAdult/backgrounds/eating/background-pcd-eatingAdult2.svg": [
		2070,
		9,
		1253
	],
	"./lely/16x9/stories/cowDailyForAdult/backgrounds/eating/background-pcd-eatingAdultVector3.svg": [
		2071,
		9,
		1254
	],
	"./lely/16x9/stories/cowDailyForAdult/backgrounds/eating/full_tree.png": [
		2072,
		7,
		1255
	],
	"./lely/16x9/stories/cowDailyForAdult/backgrounds/milking/background-pcd-milkingAdult1.svg": [
		2073,
		9,
		1256
	],
	"./lely/16x9/stories/cowDailyForAdult/backgrounds/milking/background-pcd-milkingAdult2.svg": [
		2074,
		9,
		1257
	],
	"./lely/16x9/stories/cowDailyForAdult/backgrounds/outro/background-pcd-outro-slide.svg": [
		2075,
		9,
		1258
	],
	"./lely/16x9/stories/cowDailyForAdult/backgrounds/resting/background-pcd-restingAdult1.svg": [
		2076,
		9,
		1259
	],
	"./lely/16x9/stories/cowDailyForAdult/backgrounds/resting/background-pcd-restingAdult2.svg": [
		2077,
		9,
		1260
	],
	"./lely/16x9/stories/cowDailyForAdult/backgrounds/resting/background-pcd-restingAdult3.svg": [
		2078,
		9,
		1261
	],
	"./lely/16x9/stories/cowDailyForAdult/backgrounds/resting/background-pcd-restingAdult4.svg": [
		2079,
		9,
		1262
	],
	"./lely/16x9/stories/cowDailyForAdult/backgrounds/resting/background-pcd-restingAdult5.svg": [
		2080,
		9,
		1263
	],
	"./lely/16x9/stories/cowDailyForAdult/backgrounds/resting/background-pcd-restingAdult7.svg": [
		2081,
		9,
		1264
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/astronautAdult.svg": [
		2082,
		9,
		1265
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/bigPartyFlag.svg": [
		2083,
		9,
		1266
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/birthdayPartyBigBox.svg": [
		2084,
		9,
		1267
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/birthdayPartyCake.svg": [
		2085,
		9,
		1268
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/birthdayPartyFlute.svg": [
		2086,
		9,
		1269
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/birthdayPartyHat.svg": [
		2087,
		9,
		1270
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/buttonGrazeway.svg": [
		2088,
		9,
		1271
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/calendar.svg": [
		2089,
		9,
		1272
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/calf.svg": [
		2090,
		9,
		1273
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/calmRobot.svg": [
		2091,
		9,
		1274
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/calmRobotSideButton.svg": [
		2092,
		9,
		1275
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/cow.svg": [
		2093,
		9,
		1276
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/familyMemberAvatar.svg": [
		2094,
		9,
		1277
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/familyTreeAllBranchesForAdult.svg": [
		2095,
		9,
		1278
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/familyTreeBaseBranchesForAdult.svg": [
		2096,
		7,
		1279
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/farmHouseStyle1Front.svg": [
		2097,
		9,
		1280
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/farmHouseStyle2Front.svg": [
		2098,
		9,
		1281
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/farmHouseStyle3Front.svg": [
		2099,
		9,
		1282
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/finalSlideFirstPole.svg": [
		2100,
		9,
		1283
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/finalSlideSharingPole.svg": [
		2101,
		9,
		1284
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/grazewayAdult.svg": [
		2102,
		9,
		1285
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/moreInfoPlate.svg": [
		2103,
		9,
		1286
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/paper_texture.jpg": [
		2104,
		7,
		1287
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/presentBox.svg": [
		2105,
		9,
		1288
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/ruminationCowAdult.svg": [
		2106,
		9,
		1289
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/sharingFacebook.svg": [
		2107,
		9,
		1290
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/sharingLinkedIn.svg": [
		2108,
		9,
		1291
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/sharingShare.svg": [
		2109,
		9,
		1292
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/sharingTwitter.svg": [
		2110,
		9,
		1293
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/smallPartyFlag.svg": [
		2111,
		9,
		1294
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/storyEndHouseStyle1.svg": [
		2112,
		9,
		1295
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/storyEndHouseStyle2.svg": [
		2113,
		9,
		1296
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/storyEndHouseStyle3.svg": [
		2114,
		9,
		1297
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/termometer.svg": [
		2115,
		9,
		1298
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/toMijnMelkWebSiteButton.svg": [
		2116,
		9,
		1299
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/treesIntroPage.svg": [
		2117,
		9,
		1300
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/vectorAdult.svg": [
		2118,
		9,
		1301
	],
	"./lely/16x9/stories/cowDailyForAdult/elements/vectorLastSlideSign.svg": [
		2119,
		9,
		1302
	],
	"./lely/16x9/stories/cowDailyForAdult/weather/averageRainAdult.svg": [
		2120,
		9,
		1303
	],
	"./lely/16x9/stories/cowDailyForAdult/weather/drizzleAdult.svg": [
		2121,
		9,
		1304
	],
	"./lely/16x9/stories/cowDailyForAdult/weather/heavyRain.svg": [
		2122,
		9,
		1305
	],
	"./lely/16x9/stories/cowDailyForAdult/weather/heavyRain2.svg": [
		2123,
		9,
		1306
	],
	"./lely/16x9/stories/cowDailyForAdult/weather/thunder/thunderAdult1.svg": [
		2124,
		9,
		1307
	],
	"./lely/16x9/stories/cowDailyForAdult/weather/thunder/thunderAdult2.svg": [
		2125,
		9,
		1308
	],
	"./lely/16x9/stories/cowDailyForAdult/weather/thunder/thunderAdult3.svg": [
		2126,
		9,
		1309
	],
	"./lely/16x9/stories/cowDailyForAdult/weather/thunder/thunderAdult4.svg": [
		2127,
		9,
		1310
	],
	"./lely/16x9/stories/cowDailyForAdult/weather/thunder/thunderAdult5.svg": [
		2128,
		9,
		1311
	],
	"./lely/16x9/stories/cowDailyForAdult/weather/thunder/thunderAdult6.svg": [
		2129,
		9,
		1312
	],
	"./lely/16x9/stories/cowdaily/background-layers/background-trees/trees1.svg": [
		2130,
		9,
		1313
	],
	"./lely/16x9/stories/cowdaily/background-layers/background-trees/trees2.svg": [
		2131,
		9,
		1314
	],
	"./lely/16x9/stories/cowdaily/background-layers/background-trees/trees3.svg": [
		2132,
		9,
		1315
	],
	"./lely/16x9/stories/cowdaily/background-layers/background-trees/trees4.svg": [
		2133,
		7,
		1316
	],
	"./lely/16x9/stories/cowdaily/background-layers/background-trees/trees5.svg": [
		2134,
		9,
		1317
	],
	"./lely/16x9/stories/cowdaily/background-layers/background-trees/trees6.svg": [
		2135,
		9,
		1318
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_01.svg": [
		2136,
		9,
		1319
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_01_gray.svg": [
		2137,
		9,
		1320
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_02.svg": [
		2138,
		9,
		1321
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_02_gray.svg": [
		2139,
		9,
		1322
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_03.svg": [
		2140,
		9,
		1323
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_03_gray.svg": [
		2141,
		9,
		1324
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_04.svg": [
		2142,
		9,
		1325
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_04_gray.svg": [
		2143,
		9,
		1326
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_05.svg": [
		2144,
		9,
		1327
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_05_gray.svg": [
		2145,
		9,
		1328
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_06.svg": [
		2146,
		9,
		1329
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_06_gray.svg": [
		2147,
		9,
		1330
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_07.svg": [
		2148,
		9,
		1331
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_07_gray.svg": [
		2149,
		9,
		1332
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_08.svg": [
		2150,
		9,
		1333
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_08_gray.svg": [
		2151,
		9,
		1334
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_09.svg": [
		2152,
		9,
		1335
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_09_gray.svg": [
		2153,
		9,
		1336
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_10.svg": [
		2154,
		9,
		1337
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_10_gray.svg": [
		2155,
		9,
		1338
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_11.svg": [
		2156,
		9,
		1339
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_11_gray.svg": [
		2157,
		9,
		1340
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_12.svg": [
		2158,
		9,
		1341
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_12_gray.svg": [
		2159,
		9,
		1342
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_13.svg": [
		2160,
		9,
		1343
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_13_gray.svg": [
		2161,
		9,
		1344
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_14.svg": [
		2162,
		9,
		1345
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_14_gray.svg": [
		2163,
		9,
		1346
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_15.svg": [
		2164,
		9,
		1347
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_15_gray.svg": [
		2165,
		9,
		1348
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_16.svg": [
		2166,
		9,
		1349
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_16_gray.svg": [
		2167,
		9,
		1350
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_17.svg": [
		2168,
		9,
		1351
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_17_gray.svg": [
		2169,
		9,
		1352
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_18.svg": [
		2170,
		9,
		1353
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_18_gray.svg": [
		2171,
		9,
		1354
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_19.svg": [
		2172,
		9,
		1355
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/background_weather_cloud_19_gray.svg": [
		2173,
		9,
		1356
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/clouds1.svg": [
		2174,
		9,
		1357
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/clouds2.svg": [
		2175,
		9,
		1358
	],
	"./lely/16x9/stories/cowdaily/background-layers/clouds/clouds3.svg": [
		2176,
		9,
		1359
	],
	"./lely/16x9/stories/cowdaily/background-layers/cow-eating-back/cowdailyeating1.svg": [
		2177,
		9,
		1360
	],
	"./lely/16x9/stories/cowdaily/background-layers/cow-eating-back/coweatingback.svg": [
		2178,
		9,
		1361
	],
	"./lely/16x9/stories/cowdaily/background-layers/cow-eating-back/coweatingback2.svg": [
		2179,
		9,
		1362
	],
	"./lely/16x9/stories/cowdaily/background-layers/cow-eating-back/coweatingback3.svg": [
		2180,
		9,
		1363
	],
	"./lely/16x9/stories/cowdaily/background-layers/cow-eating-back/coweatingback4.svg": [
		2181,
		9,
		1364
	],
	"./lely/16x9/stories/cowdaily/background-layers/cow-eating-back/coweatingback5.svg": [
		2182,
		9,
		1365
	],
	"./lely/16x9/stories/cowdaily/background-layers/cow-eating-back/coweatingback6.svg": [
		2183,
		9,
		1366
	],
	"./lely/16x9/stories/cowdaily/background-layers/cow-eating-back/cowmilking1.svg": [
		2184,
		9,
		1367
	],
	"./lely/16x9/stories/cowdaily/background-layers/cow-eating-back/cowmilking2.svg": [
		2185,
		9,
		1368
	],
	"./lely/16x9/stories/cowdaily/background-layers/cow-eating-back/cowrumination1.svg": [
		2186,
		9,
		1369
	],
	"./lely/16x9/stories/cowdaily/background-layers/eating-improved/eating1.svg": [
		2192,
		9,
		1370
	],
	"./lely/16x9/stories/cowdaily/background-layers/eating-improved/eating_last.svg": [
		2193,
		9,
		1371
	],
	"./lely/16x9/stories/cowdaily/background-layers/eating-improved/eating_left.svg": [
		2194,
		9,
		1372
	],
	"./lely/16x9/stories/cowdaily/background-layers/eating-improved/grass_initial.svg": [
		2195,
		7,
		1373
	],
	"./lely/16x9/stories/cowdaily/background-layers/eating-improved/grass_last.svg": [
		2196,
		7,
		1374
	],
	"./lely/16x9/stories/cowdaily/background-layers/eating-improved/grass_new.svg": [
		2197,
		7,
		1375
	],
	"./lely/16x9/stories/cowdaily/background-layers/eating-improved/grass_without_tree.svg": [
		2198,
		7,
		1376
	],
	"./lely/16x9/stories/cowdaily/background-layers/eating/eating1.svg": [
		2187,
		9,
		1377
	],
	"./lely/16x9/stories/cowdaily/background-layers/eating/eating2.svg": [
		2188,
		9,
		1378
	],
	"./lely/16x9/stories/cowdaily/background-layers/eating/eating3.svg": [
		2189,
		9,
		1379
	],
	"./lely/16x9/stories/cowdaily/background-layers/eating/eating4.svg": [
		2190,
		9,
		1380
	],
	"./lely/16x9/stories/cowdaily/background-layers/eating/eating5.svg": [
		2191,
		9,
		1381
	],
	"./lely/16x9/stories/cowdaily/background-layers/forefront-tree/forefronttree1.svg": [
		2199,
		9,
		1382
	],
	"./lely/16x9/stories/cowdaily/background-layers/forefront-tree/forefronttree2.svg": [
		2200,
		9,
		1383
	],
	"./lely/16x9/stories/cowdaily/background-layers/grass/grass1.svg": [
		2201,
		9,
		1384
	],
	"./lely/16x9/stories/cowdaily/background-layers/grass/grass2.svg": [
		2202,
		9,
		1385
	],
	"./lely/16x9/stories/cowdaily/background-layers/grass/grass3.svg": [
		2203,
		9,
		1386
	],
	"./lely/16x9/stories/cowdaily/background-layers/grass/grass4.svg": [
		2204,
		9,
		1387
	],
	"./lely/16x9/stories/cowdaily/background-layers/grass/grass5.svg": [
		2205,
		9,
		1388
	],
	"./lely/16x9/stories/cowdaily/background-layers/grass/grass6.svg": [
		2206,
		9,
		1389
	],
	"./lely/16x9/stories/cowdaily/background-layers/grass/grass_initial.svg": [
		2207,
		7,
		1390
	],
	"./lely/16x9/stories/cowdaily/background-layers/grass/grass_last_slide.svg": [
		2208,
		7,
		1391
	],
	"./lely/16x9/stories/cowdaily/background-layers/grass/grasslastslide.svg": [
		2209,
		9,
		1392
	],
	"./lely/16x9/stories/cowdaily/background-layers/hills/background_hills_snowy_01.svg": [
		2210,
		9,
		1393
	],
	"./lely/16x9/stories/cowdaily/background-layers/hills/background_hills_snowy_02.svg": [
		2211,
		9,
		1394
	],
	"./lely/16x9/stories/cowdaily/background-layers/hills/background_hills_snowy_03.svg": [
		2212,
		9,
		1395
	],
	"./lely/16x9/stories/cowdaily/background-layers/hills/background_hills_snowy_04.svg": [
		2213,
		9,
		1396
	],
	"./lely/16x9/stories/cowdaily/background-layers/hills/background_hills_snowy_05.svg": [
		2214,
		9,
		1397
	],
	"./lely/16x9/stories/cowdaily/background-layers/milking/milking2.svg": [
		2215,
		9,
		1398
	],
	"./lely/16x9/stories/cowdaily/background-layers/milking/milking_last.svg": [
		2216,
		9,
		1399
	],
	"./lely/16x9/stories/cowdaily/background-layers/milking/milking_left.svg": [
		2217,
		9,
		1400
	],
	"./lely/16x9/stories/cowdaily/background-layers/mist/background_weather_mist_01.svg": [
		2218,
		9,
		1401
	],
	"./lely/16x9/stories/cowdaily/background-layers/mist/background_weather_mist_02.svg": [
		2219,
		9,
		1402
	],
	"./lely/16x9/stories/cowdaily/background-layers/mist/background_weather_mist_03.svg": [
		2220,
		9,
		1403
	],
	"./lely/16x9/stories/cowdaily/background-layers/mist/background_weather_mist_04.svg": [
		2221,
		9,
		1404
	],
	"./lely/16x9/stories/cowdaily/background-layers/mist/background_weather_mist_05.svg": [
		2222,
		9,
		1405
	],
	"./lely/16x9/stories/cowdaily/background-layers/mist/background_weather_mist_06.svg": [
		2223,
		9,
		1406
	],
	"./lely/16x9/stories/cowdaily/background-layers/mist/background_weather_mist_07.svg": [
		2224,
		9,
		1407
	],
	"./lely/16x9/stories/cowdaily/background-layers/resting/cowdailyresting1.svg": [
		2225,
		9,
		1408
	],
	"./lely/16x9/stories/cowdaily/background-layers/resting/resting1.svg": [
		2226,
		9,
		1409
	],
	"./lely/16x9/stories/cowdaily/background-layers/resting/resting2.svg": [
		2227,
		9,
		1410
	],
	"./lely/16x9/stories/cowdaily/background-layers/resting/resting3.svg": [
		2228,
		9,
		1411
	],
	"./lely/16x9/stories/cowdaily/background-layers/resting/resting5.svg": [
		2229,
		9,
		1412
	],
	"./lely/16x9/stories/cowdaily/background-layers/resting/resting_last.svg": [
		2230,
		9,
		1413
	],
	"./lely/16x9/stories/cowdaily/background-layers/resting/resting_left.svg": [
		2231,
		9,
		1414
	],
	"./lely/16x9/stories/cowdaily/background-layers/rumination/rumination_1.svg": [
		2232,
		9,
		1415
	],
	"./lely/16x9/stories/cowdaily/background-layers/rumination/rumination_last_full_tree.svg": [
		2233,
		9,
		1416
	],
	"./lely/16x9/stories/cowdaily/background-layers/sky/birds.svg": [
		2234,
		9,
		1417
	],
	"./lely/16x9/stories/cowdaily/background-layers/sky/moon.svg": [
		2235,
		9,
		1418
	],
	"./lely/16x9/stories/cowdaily/background-layers/sky/sun.svg": [
		2236,
		9,
		1419
	],
	"./lely/16x9/stories/cowdaily/background-layers/stars/starry_sky.svg": [
		2237,
		9,
		1420
	],
	"./lely/16x9/stories/cowdaily/background-layers/weather/droplet.svg": [
		2238,
		9,
		1421
	],
	"./lely/16x9/stories/cowdaily/background-layers/weather/lightnings/background_weather_lightning_01.svg": [
		2239,
		9,
		1422
	],
	"./lely/16x9/stories/cowdaily/background-layers/weather/lightnings/background_weather_lightning_02.svg": [
		2240,
		9,
		1423
	],
	"./lely/16x9/stories/cowdaily/background-layers/weather/lightnings/background_weather_lightning_03.svg": [
		2241,
		9,
		1424
	],
	"./lely/16x9/stories/cowdaily/background-layers/weather/lightnings/background_weather_lightning_04.svg": [
		2242,
		9,
		1425
	],
	"./lely/16x9/stories/cowdaily/background-layers/weather/lightnings/background_weather_lightning_05.svg": [
		2243,
		9,
		1426
	],
	"./lely/16x9/stories/cowdaily/background-layers/weather/lightnings/background_weather_lightning_06.svg": [
		2244,
		9,
		1427
	],
	"./lely/16x9/stories/cowdaily/background-layers/weather/rains/background_weather_rain_01.svg": [
		2245,
		9,
		1428
	],
	"./lely/16x9/stories/cowdaily/background-layers/weather/rains/background_weather_rain_02.svg": [
		2246,
		9,
		1429
	],
	"./lely/16x9/stories/cowdaily/background-layers/weather/rains/background_weather_rain_drizzle_01.svg": [
		2247,
		9,
		1430
	],
	"./lely/16x9/stories/cowdaily/background-layers/weather/rains/background_weather_rain_drizzle_02.svg": [
		2248,
		9,
		1431
	],
	"./lely/16x9/stories/cowdaily/background-layers/weather/rains/background_weather_rain_drizzle_03.svg": [
		2249,
		9,
		1432
	],
	"./lely/16x9/stories/cowdaily/background-layers/weather/rains/background_weather_rain_drizzle_04.svg": [
		2250,
		9,
		1433
	],
	"./lely/16x9/stories/cowdaily/background-layers/weather/rains/background_weather_rain_heavy_01.svg": [
		2251,
		9,
		1434
	],
	"./lely/16x9/stories/cowdaily/background-layers/weather/rains/background_weather_rain_heavy_02.svg": [
		2252,
		9,
		1435
	],
	"./lely/16x9/stories/cowdaily/graphics/arrowAdultVersion.svg": [
		2253,
		9,
		1436
	],
	"./lely/16x9/stories/cowdaily/graphics/astronaut.svg": [
		2254,
		9,
		1437
	],
	"./lely/16x9/stories/cowdaily/graphics/cow_resting.svg": [
		2255,
		9,
		1438
	],
	"./lely/16x9/stories/cowdaily/graphics/endingSlidePole.svg": [
		2256,
		9,
		1439
	],
	"./lely/16x9/stories/cowdaily/graphics/milk_bottle.svg": [
		2257,
		9,
		1440
	],
	"./lely/16x9/stories/cowdaily/graphics/milk_bottleAdult.svg": [
		2258,
		9,
		1441
	],
	"./lely/16x9/stories/cowdaily/graphics/pole.svg": [
		2259,
		9,
		1442
	],
	"./lely/16x9/stories/cowdaily/graphics/vector.svg": [
		2260,
		9,
		1443
	],
	"./lely/16x9/stories/cowhistory/background-layers/elements/fenceOutroSlide.svg": [
		2261,
		9,
		1444
	],
	"./lely/16x9/stories/cowhistory/background-layers/elements/house.svg": [
		2262,
		9,
		1445
	],
	"./lely/16x9/stories/cowhistory/background-layers/elements/houseStyle2.svg": [
		2263,
		9,
		1446
	],
	"./lely/16x9/stories/cowhistory/background-layers/elements/houseStyle3.svg": [
		2264,
		9,
		1447
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/barnFirstSlide.svg": [
		2265,
		9,
		1448
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/barnSecondSlide.svg": [
		2266,
		9,
		1449
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/bigPartyFlag.svg": [
		2267,
		9,
		1450
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/bigPresentBox.svg": [
		2268,
		9,
		1451
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/bigTree.svg": [
		2269,
		9,
		1452
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/birthdayCake.svg": [
		2270,
		9,
		1453
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/birthdaySlide.svg": [
		2271,
		9,
		1454
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/cake.svg": [
		2272,
		9,
		1455
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/calendar.svg": [
		2273,
		9,
		1456
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/calmRobot.svg": [
		2274,
		9,
		1457
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/candle.svg": [
		2275,
		9,
		1458
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/cowOutroSlideFence.svg": [
		2276,
		9,
		1459
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/firstCalfSecondSlide.svg": [
		2277,
		9,
		1460
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/firstCalfSlide.svg": [
		2278,
		9,
		1461
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/firstCalfThirdSlide.svg": [
		2279,
		9,
		1462
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/partyFlutes/partyFlute_1.svg": [
		2280,
		9,
		1463
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/partyFlutes/partyFlute_2.svg": [
		2281,
		9,
		1464
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/partyFlutes/partyFlute_3.svg": [
		2282,
		9,
		1465
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/partyHats/partyHat_1.svg": [
		2283,
		9,
		1466
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/partyHats/partyHat_2.svg": [
		2284,
		9,
		1467
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/partyHats/partyHat_3.svg": [
		2285,
		9,
		1468
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/pole.svg": [
		2286,
		9,
		1469
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/presentBox.svg": [
		2287,
		9,
		1470
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/rightPartOfTheTree.svg": [
		2288,
		9,
		1471
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/secondSlideCalm.svg": [
		2289,
		9,
		1472
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/secondSlideCalmVersion.svg": [
		2290,
		9,
		1473
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/smallPartyFlag.svg": [
		2291,
		9,
		1474
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/stork.svg": [
		2292,
		9,
		1475
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/thermometer.svg": [
		2293,
		9,
		1476
	],
	"./lely/16x9/stories/cowhistory/background-layers/firstYear/trees-1.svg": [
		2294,
		9,
		1477
	],
	"./lely/16x9/stories/cowhistory/background-layers/forrest/forrest1.svg": [
		2295,
		9,
		1478
	],
	"./lely/16x9/stories/cowhistory/background-layers/forrest/forrest2.svg": [
		2296,
		9,
		1479
	],
	"./lely/16x9/stories/cowhistory/background-layers/forrest/forrest3.svg": [
		2297,
		9,
		1480
	],
	"./lely/16x9/stories/cowhistory/background-layers/forrest/forrest4.svg": [
		2298,
		9,
		1481
	],
	"./lely/16x9/stories/cowhistory/background-layers/forrest/forrest5.svg": [
		2299,
		9,
		1482
	],
	"./lely/16x9/stories/cowhistory/background-layers/forrest2/forrest1.svg": [
		2300,
		9,
		1483
	],
	"./lely/16x9/stories/cowhistory/background-layers/forrest2/forrest2.svg": [
		2301,
		9,
		1484
	],
	"./lely/16x9/stories/cowhistory/background-layers/forrest2/forrest3.svg": [
		2302,
		9,
		1485
	],
	"./lely/16x9/stories/cowhistory/background-layers/forrest2/forrest4.svg": [
		2303,
		9,
		1486
	],
	"./lely/16x9/stories/cowhistory/background-layers/forrest2/forrest5.svg": [
		2304,
		9,
		1487
	],
	"./lely/16x9/stories/cowhistory/background-layers/grass/grass1.svg": [
		2305,
		9,
		1488
	],
	"./lely/16x9/stories/cowhistory/background-layers/grass/grass2.svg": [
		2306,
		7,
		1489
	],
	"./lely/16x9/stories/cowhistory/background-layers/grass/grass3.svg": [
		2307,
		9,
		1490
	],
	"./lely/16x9/stories/cowhistory/background-layers/grass/grass4.svg": [
		2308,
		9,
		1491
	],
	"./lely/16x9/stories/cowhistory/background-layers/grass/grass5.svg": [
		2309,
		9,
		1492
	],
	"./lely/16x9/stories/cowhistory/background-layers/grass/grass6.svg": [
		2310,
		9,
		1493
	],
	"./lely/16x9/stories/cowhistory/background-layers/hills1/hills11.svg": [
		2311,
		9,
		1494
	],
	"./lely/16x9/stories/cowhistory/background-layers/hills1/hills12.svg": [
		2312,
		9,
		1495
	],
	"./lely/16x9/stories/cowhistory/background-layers/hills1/hills13.svg": [
		2313,
		9,
		1496
	],
	"./lely/16x9/stories/cowhistory/background-layers/hills1/hills14.svg": [
		2314,
		9,
		1497
	],
	"./lely/16x9/stories/cowhistory/background-layers/hills1/hills15.svg": [
		2315,
		9,
		1498
	],
	"./lely/16x9/stories/cowhistory/background-layers/hills1/test.svg": [
		2316,
		9,
		1499
	],
	"./lely/16x9/stories/cowhistory/background-layers/hills2/hills21.svg": [
		2317,
		9,
		1500
	],
	"./lely/16x9/stories/cowhistory/background-layers/hills2/hills22.svg": [
		2318,
		9,
		1501
	],
	"./lely/16x9/stories/cowhistory/background-layers/hills2/hills23.svg": [
		2319,
		9,
		1502
	],
	"./lely/16x9/stories/cowhistory/background-layers/hills2/hills24.svg": [
		2320,
		9,
		1503
	],
	"./lely/16x9/stories/cowhistory/background-layers/hills2/hills25.svg": [
		2321,
		9,
		1504
	],
	"./lely/16x9/stories/cowhistory/background-layers/mountains/mountain1.svg": [
		2322,
		9,
		1505
	],
	"./lely/16x9/stories/cowhistory/background-layers/mountains/mountain2.svg": [
		2323,
		9,
		1506
	],
	"./lely/16x9/stories/cowhistory/background-layers/mountains/mountain3.svg": [
		2324,
		9,
		1507
	],
	"./lely/16x9/stories/cowhistory/background-layers/mountains/mountain4.svg": [
		2325,
		9,
		1508
	],
	"./lely/16x9/stories/cowhistory/background-layers/mountains/mountain5.svg": [
		2326,
		9,
		1509
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/elements/fenceOutroSlide.svg": [
		2327,
		9,
		1510
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/elements/house.svg": [
		2328,
		9,
		1511
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/elements/houseStyle2.svg": [
		2329,
		9,
		1512
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/elements/houseStyle3.svg": [
		2330,
		9,
		1513
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/elements/smallCowAndBush.svg": [
		2331,
		9,
		1514
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/elements/treeAndBushSecondSlide.svg": [
		2332,
		9,
		1515
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/barnFirstSlide.svg": [
		2333,
		9,
		1516
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/barnSecondSlideAdult.svg": [
		2334,
		9,
		1517
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/bigPartyFlag.svg": [
		2335,
		9,
		1518
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/bigPresentBox.svg": [
		2336,
		9,
		1519
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/bigTree.svg": [
		2337,
		9,
		1520
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/birthdayCake.svg": [
		2338,
		9,
		1521
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/birthdaySlide.svg": [
		2339,
		9,
		1522
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/cake.svg": [
		2340,
		9,
		1523
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/calendar.svg": [
		2341,
		9,
		1524
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/calfing_pen_transition_back.svg": [
		2342,
		9,
		1525
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/calmRobot.svg": [
		2343,
		9,
		1526
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/candle.svg": [
		2344,
		9,
		1527
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/cowOutroSlideFence.svg": [
		2345,
		9,
		1528
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/firstCalfAdultFirstSlide.svg": [
		2346,
		9,
		1529
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/firstCalfSecondSlide.svg": [
		2347,
		9,
		1530
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/firstCalfSecondSlideAdult.svg": [
		2348,
		9,
		1531
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/firstCalfSlide.svg": [
		2349,
		9,
		1532
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/firstCalfThirdSlide.svg": [
		2350,
		9,
		1533
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/firstCalfThirdSlideAdult.svg": [
		2351,
		9,
		1534
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/partyFlutes/partyFlute_1.svg": [
		2352,
		9,
		1535
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/partyFlutes/partyFlute_2.svg": [
		2353,
		9,
		1536
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/partyFlutes/partyFlute_3.svg": [
		2354,
		9,
		1537
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/partyHats/partyHat_1.svg": [
		2355,
		9,
		1538
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/partyHats/partyHat_2.svg": [
		2356,
		9,
		1539
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/partyHats/partyHat_3.svg": [
		2357,
		9,
		1540
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/pole.svg": [
		2358,
		9,
		1541
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/presentBox.svg": [
		2359,
		9,
		1542
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/rightPartOfTheTree.svg": [
		2360,
		9,
		1543
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/secondSlideCalm.svg": [
		2361,
		9,
		1544
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/secondSlideCalmVersion.svg": [
		2362,
		9,
		1545
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/smallPartyFlag.svg": [
		2363,
		9,
		1546
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/stork.svg": [
		2364,
		9,
		1547
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/thermometer.svg": [
		2365,
		9,
		1548
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/transitionSlideCalm.svg": [
		2366,
		9,
		1549
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/firstYear/trees-1.svg": [
		2367,
		9,
		1550
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/forestLeafage/background_forrest_leafage_01.svg": [
		2368,
		9,
		1551
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/forestLeafage/background_forrest_leafage_02.svg": [
		2369,
		9,
		1552
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/forestLeafage/background_forrest_leafage_03.svg": [
		2370,
		9,
		1553
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/forestLeafage/background_forrest_leafage_04.svg": [
		2371,
		9,
		1554
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/forestLeafage/background_forrest_leafage_05.svg": [
		2372,
		9,
		1555
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/forrest/forrest1.svg": [
		2373,
		9,
		1556
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/forrest/forrest2.svg": [
		2374,
		9,
		1557
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/forrest/forrest3.svg": [
		2375,
		9,
		1558
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/forrest/forrest4.svg": [
		2376,
		9,
		1559
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/forrest/forrest5.svg": [
		2377,
		9,
		1560
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/forrest2/forrest1.svg": [
		2378,
		9,
		1561
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/forrest2/forrest2.svg": [
		2379,
		9,
		1562
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/forrest2/forrest3.svg": [
		2380,
		9,
		1563
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/forrest2/forrest4.svg": [
		2381,
		9,
		1564
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/forrest2/forrest5.svg": [
		2382,
		9,
		1565
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/grass/grass1.svg": [
		2383,
		9,
		1566
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/grass/grass2.svg": [
		2384,
		7,
		1567
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/grass/grass3.svg": [
		2385,
		9,
		1568
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/grass/grass4.svg": [
		2386,
		9,
		1569
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/grass/grass5.svg": [
		2387,
		9,
		1570
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/grass/grass6.svg": [
		2388,
		9,
		1571
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/hills1/hills11.svg": [
		2389,
		9,
		1572
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/hills1/hills12.svg": [
		2390,
		9,
		1573
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/hills1/hills13.svg": [
		2391,
		9,
		1574
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/hills1/hills14.svg": [
		2392,
		9,
		1575
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/hills1/hills15.svg": [
		2393,
		9,
		1576
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/hills2/hills21.svg": [
		2394,
		9,
		1577
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/hills2/hills22.svg": [
		2395,
		9,
		1578
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/hills2/hills23.svg": [
		2396,
		9,
		1579
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/hills2/hills24.svg": [
		2397,
		9,
		1580
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/hills2/hills25.svg": [
		2398,
		9,
		1581
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/hills3/background_hills_01.svg": [
		2399,
		9,
		1582
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/hills3/background_hills_02.svg": [
		2400,
		9,
		1583
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/hills3/background_hills_03.svg": [
		2401,
		9,
		1584
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/hills3/background_hills_04.svg": [
		2402,
		9,
		1585
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/hills3/background_hills_05.svg": [
		2403,
		9,
		1586
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/mountains/dog.svg": [
		2404,
		9,
		1587
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/mountains/mountain1.svg": [
		2405,
		9,
		1588
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/mountains/mountain2.svg": [
		2406,
		9,
		1589
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/mountains/mountain3.svg": [
		2407,
		9,
		1590
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/mountains/mountain4.svg": [
		2408,
		9,
		1591
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/mountains/mountain5.svg": [
		2409,
		9,
		1592
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/mountains/test.svg": [
		2410,
		9,
		1593
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/trees/background_tree_01.svg": [
		2411,
		9,
		1594
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/trees/bigTree.png": [
		2412,
		7,
		1595
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/trees/cowOutroPagetree.svg": [
		2413,
		9,
		1596
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/trees/full_tree (1).png": [
		2414,
		7,
		1597
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/trees/full_tree.png": [
		2415,
		7,
		1598
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/trees/rightHalfOfTheTree.svg": [
		2416,
		9,
		1599
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/trees/tree_on_the_left.png": [
		2417,
		7,
		1600
	],
	"./lely/16x9/stories/cowhistoryForAdult/background-layers/trees/tree_on_the_right.png": [
		2418,
		7,
		1601
	],
	"./lely/16x9/stories/cowhistoryForAdult/backgrounds/background--intro--secondSlide.svg": [
		2419,
		9,
		1602
	],
	"./lely/16x9/stories/cowhistoryForAdult/backgrounds/background--intro--slide.svg": [
		2420,
		9,
		1603
	],
	"./lely/16x9/stories/cowhistoryForAdult/backgrounds/background--intro--transition-tree.svg": [
		2421,
		9,
		1604
	],
	"./lely/16x9/stories/cowhistoryForAdult/backgrounds/background--siblingSlide.svg": [
		2422,
		9,
		1605
	],
	"./lely/16x9/stories/cowhistoryForAdult/backgrounds/background-pcd-firstYear.svg": [
		2423,
		9,
		1606
	],
	"./lely/16x9/stories/cowhistoryForAdult/backgrounds/background-pcd-firstYearSecondSlide.svg": [
		2424,
		9,
		1607
	],
	"./lely/16x9/stories/cowhistoryForAdult/backgrounds/tree.png": [
		2425,
		7,
		1608
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/bigPartyFlag.svg": [
		2426,
		9,
		1609
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/birthdayPartyBigBox.svg": [
		2427,
		9,
		1610
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/birthdayPartyCake.svg": [
		2428,
		9,
		1611
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/birthdayPartyFlute.svg": [
		2429,
		9,
		1612
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/birthdayPartyHat.svg": [
		2430,
		9,
		1613
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/calendar.svg": [
		2431,
		9,
		1614
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/calf.svg": [
		2432,
		9,
		1615
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/calmRobot.svg": [
		2433,
		9,
		1616
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/calmRobotSideButton.svg": [
		2434,
		9,
		1617
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/cow.svg": [
		2435,
		9,
		1618
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/familyMemberAvatar.svg": [
		2436,
		9,
		1619
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/familyTreeAllBranchesForAdult.svg": [
		2437,
		9,
		1620
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/familyTreeBaseBranchesForAdult.svg": [
		2438,
		7,
		1621
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/farmHouseStyle1Front.svg": [
		2439,
		9,
		1622
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/farmHouseStyle2Front.svg": [
		2440,
		9,
		1623
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/farmHouseStyle3Front.svg": [
		2441,
		9,
		1624
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/finalSlideFirstPole.svg": [
		2442,
		9,
		1625
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/finalSlideSharingPole.svg": [
		2443,
		9,
		1626
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/moreInfoPlate.svg": [
		2444,
		9,
		1627
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/paper_texture.jpg": [
		2445,
		7,
		1628
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/presentBox.svg": [
		2446,
		9,
		1629
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/sharingFacebook.svg": [
		2447,
		9,
		1630
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/sharingLinkedIn.svg": [
		2448,
		9,
		1631
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/sharingShare.svg": [
		2449,
		9,
		1632
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/sharingTwitter.svg": [
		2450,
		9,
		1633
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/smallCowIntroPage.svg": [
		2451,
		9,
		1634
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/smallPartyFlag.svg": [
		2452,
		9,
		1635
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/storyEndHouseStyle1.svg": [
		2453,
		9,
		1636
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/storyEndHouseStyle2.svg": [
		2454,
		9,
		1637
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/storyEndHouseStyle3.svg": [
		2455,
		9,
		1638
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/termometer.svg": [
		2456,
		9,
		1639
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/toMijnMelkWebSiteButton.svg": [
		2457,
		9,
		1640
	],
	"./lely/16x9/stories/cowhistoryForAdult/elements/vectorLastSlideSign.svg": [
		2458,
		9,
		1641
	],
	"./lely/16x9/stories/cowhistoryForAdult/textures/texture2.png": [
		2459,
		7,
		1642
	],
	"./lely/16x9/stories/discoverySw/discoverySw.svg": [
		2460,
		9,
		1643
	],
	"./lely/16x9/stories/discoverySw/discoverySwAdult.svg": [
		2461,
		9,
		1644
	],
	"./lely/16x9/stories/discoverystory/about.png": [
		2462,
		7,
		1645
	],
	"./lely/16x9/stories/discoverystory/discoveryAdult.svg": [
		2463,
		9,
		1646
	],
	"./lely/16x9/stories/discoverystory/discoverySw90.jpg": [
		2464,
		7,
		1647
	],
	"./lely/16x9/stories/discoverystory/health.png": [
		2465,
		7,
		1648
	],
	"./lely/16x9/stories/discoverystory/robot.svg": [
		2466,
		9,
		1649
	],
	"./lely/16x9/stories/discoverystory/thirdSlide.png": [
		2467,
		7,
		1650
	],
	"./lely/16x9/stories/farmer/dutchSilo.svg": [
		2468,
		9,
		1651
	],
	"./lely/16x9/stories/farmer/dutchSiloAdult.svg": [
		2469,
		9,
		1652
	],
	"./lely/16x9/stories/farmer/ending-point-background.svg": [
		2470,
		9,
		1653
	],
	"./lely/16x9/stories/farmer/ending-point-button-revert.svg": [
		2471,
		9,
		1654
	],
	"./lely/16x9/stories/farmer/ending-point-button.svg": [
		2472,
		9,
		1655
	],
	"./lely/16x9/stories/farmer/grazingCowAndBush.svg": [
		2473,
		9,
		1656
	],
	"./lely/16x9/stories/farmer/starting-point-background.svg": [
		2474,
		9,
		1657
	],
	"./lely/16x9/stories/junoStory/junoStoryFourthSlide.svg": [
		2475,
		9,
		1658
	],
	"./lely/16x9/stories/junoStory/junoStorySecondSlide.svg": [
		2476,
		9,
		1659
	],
	"./lely/16x9/stories/junoStory/junoStoryThirdSlide.svg": [
		2477,
		9,
		1660
	],
	"./lely/16x9/stories/lelystory/building.svg": [
		2478,
		9,
		1661
	],
	"./lely/16x9/stories/lelystory/lelyFarmThirdSlideStory.jpg": [
		2479,
		7,
		1662
	],
	"./lely/16x9/stories/lelystory/lelyFifthSlideCowjpg.jpg": [
		2480,
		7,
		1663
	],
	"./lely/16x9/stories/lelystory/lelyFourthSlide.jpg": [
		2481,
		7,
		1664
	],
	"./lely/16x9/stories/lelystory/lelyHistory.jpg": [
		2482,
		7,
		1665
	],
	"./lely/16x9/stories/lelystory/lelyRedirectionButton.svg": [
		2483,
		9,
		1666
	],
	"./lely/16x9/stories/lelystory/robotToys.jpg": [
		2484,
		7,
		1667
	],
	"./lely/16x9/stories/lelystory/trees.svg": [
		2485,
		9,
		1668
	],
	"./lely/16x9/stories/lunarobot/lunaRobotAdult.svg": [
		2486,
		9,
		1669
	],
	"./lely/16x9/stories/lunarobot/lunaSecondSlide.png": [
		2487,
		7,
		1670
	],
	"./lely/16x9/stories/lunarobot/lunaThirdSlide.png": [
		2488,
		7,
		1671
	],
	"./lely/16x9/stories/lunarobot/lunarobot.svg": [
		2489,
		9,
		1672
	],
	"./lely/16x9/stories/lunarobot/lunarobotsecondslide.svg": [
		2490,
		9,
		1673
	],
	"./lely/16x9/stories/milk/Poison.png": [
		2491,
		7,
		1674
	],
	"./lely/16x9/stories/milk/americanBarn.svg": [
		2492,
		9,
		1675
	],
	"./lely/16x9/stories/milk/arrow.svg": [
		2493,
		9,
		1676
	],
	"./lely/16x9/stories/milk/background.svg": [
		2494,
		9,
		1677
	],
	"./lely/16x9/stories/milk/batchListAdultVersion.svg": [
		2495,
		9,
		1678
	],
	"./lely/16x9/stories/milk/batchNumber.svg": [
		2496,
		9,
		1679
	],
	"./lely/16x9/stories/milk/batchNumberPlate.svg": [
		2497,
		9,
		1680
	],
	"./lely/16x9/stories/milk/bigBush.svg": [
		2498,
		9,
		1681
	],
	"./lely/16x9/stories/milk/bigGrass.svg": [
		2499,
		9,
		1682
	],
	"./lely/16x9/stories/milk/boerKees.svg": [
		2500,
		9,
		1683
	],
	"./lely/16x9/stories/milk/border.svg": [
		2501,
		9,
		1684
	],
	"./lely/16x9/stories/milk/bottle.svg": [
		2502,
		9,
		1685
	],
	"./lely/16x9/stories/milk/bush.svg": [
		2503,
		9,
		1686
	],
	"./lely/16x9/stories/milk/calendar.svg": [
		2504,
		9,
		1687
	],
	"./lely/16x9/stories/milk/christmas_hat.svg": [
		2505,
		9,
		1688
	],
	"./lely/16x9/stories/milk/christmas_whistle.svg": [
		2506,
		9,
		1689
	],
	"./lely/16x9/stories/milk/deDobbelhoeve.svg": [
		2507,
		9,
		1690
	],
	"./lely/16x9/stories/milk/discoverTheFarm.svg": [
		2508,
		9,
		1691
	],
	"./lely/16x9/stories/milk/dutchBarn.svg": [
		2509,
		9,
		1692
	],
	"./lely/16x9/stories/milk/dutchBarnSecondType.svg": [
		2510,
		9,
		1693
	],
	"./lely/16x9/stories/milk/farmPlate.svg": [
		2511,
		9,
		1694
	],
	"./lely/16x9/stories/milk/grassUnderThePole.svg": [
		2512,
		9,
		1695
	],
	"./lely/16x9/stories/milk/grass_1.svg": [
		2513,
		9,
		1696
	],
	"./lely/16x9/stories/milk/house.svg": [
		2514,
		9,
		1697
	],
	"./lely/16x9/stories/milk/liquidMilk.svg": [
		2515,
		9,
		1698
	],
	"./lely/16x9/stories/milk/map.svg": [
		2516,
		9,
		1699
	],
	"./lely/16x9/stories/milk/map_pin.svg": [
		2517,
		9,
		1700
	],
	"./lely/16x9/stories/milk/mijnMelkBottle2.svg": [
		2518,
		9,
		1701
	],
	"./lely/16x9/stories/milk/mijnMelkBottleOnboarding.svg": [
		2519,
		9,
		1702
	],
	"./lely/16x9/stories/milk/mijnMelkPlate.svg": [
		2520,
		9,
		1703
	],
	"./lely/16x9/stories/milk/milkStorybottle.svg": [
		2521,
		9,
		1704
	],
	"./lely/16x9/stories/milk/milkingBottleInfo.svg": [
		2522,
		9,
		1705
	],
	"./lely/16x9/stories/milk/oostdamImage.svg": [
		2523,
		9,
		1706
	],
	"./lely/16x9/stories/milk/planet.svg": [
		2524,
		9,
		1707
	],
	"./lely/16x9/stories/milk/planet2.svg": [
		2525,
		9,
		1708
	],
	"./lely/16x9/stories/milk/poleFirstSlide.svg": [
		2526,
		9,
		1709
	],
	"./lely/16x9/stories/milk/rotgans.svg": [
		2527,
		9,
		1710
	],
	"./lely/16x9/stories/milk/secondSlideFamilyTree.svg": [
		2528,
		9,
		1711
	],
	"./lely/16x9/stories/milk/sign.svg": [
		2529,
		9,
		1712
	],
	"./lely/16x9/stories/milk/slide1RoadSign.svg": [
		2530,
		9,
		1713
	],
	"./lely/16x9/stories/milk/smallCow.svg": [
		2531,
		9,
		1714
	],
	"./lely/16x9/stories/milk/small_cow.svg": [
		2532,
		9,
		1715
	],
	"./lely/16x9/stories/milk/sunburst.svg": [
		2533,
		9,
		1716
	],
	"./lely/16x9/stories/milk/swipe_symbol.svg": [
		2534,
		9,
		1717
	],
	"./lely/16x9/stories/milk/swipingGesture.svg": [
		2535,
		9,
		1718
	],
	"./lely/16x9/stories/milk/test.svg": [
		2536,
		9,
		1719
	],
	"./lely/16x9/stories/milk/topThreeCowsPlate.svg": [
		2537,
		9,
		1720
	],
	"./lely/16x9/stories/orbiterstory/cowlastslide.svg": [
		2538,
		9,
		1721
	],
	"./lely/16x9/stories/orbiterstory/milkBottles.svg": [
		2539,
		9,
		1722
	],
	"./lely/16x9/stories/orbiterstory/milkbottle_empty.svg": [
		2540,
		9,
		1723
	],
	"./lely/16x9/stories/orbiterstory/orbiterArrowAdult.svg": [
		2541,
		9,
		1724
	],
	"./lely/16x9/stories/orbiterstory/orbiterBusAdult.svg": [
		2542,
		9,
		1725
	],
	"./lely/16x9/stories/orbiterstory/orbiterCoolingSystemAdult.svg": [
		2543,
		9,
		1726
	],
	"./lely/16x9/stories/orbiterstory/orbiterFifthSlidePipe.svg": [
		2544,
		9,
		1727
	],
	"./lely/16x9/stories/orbiterstory/orbiterFifthSlideTemperatureAdult.svg": [
		2545,
		9,
		1728
	],
	"./lely/16x9/stories/orbiterstory/orbiterFourthSlideAdult.svg": [
		2546,
		9,
		1729
	],
	"./lely/16x9/stories/orbiterstory/orbiterFourthSlideRobot.svg": [
		2547,
		9,
		1730
	],
	"./lely/16x9/stories/orbiterstory/orbiterMiddlePipe.svg": [
		2548,
		9,
		1731
	],
	"./lely/16x9/stories/orbiterstory/orbiterMilking.svg": [
		2549,
		9,
		1732
	],
	"./lely/16x9/stories/orbiterstory/orbiterRobotFifthSlide.svg": [
		2550,
		9,
		1733
	],
	"./lely/16x9/stories/orbiterstory/orbiterSecondPipeAdult.svg": [
		2551,
		9,
		1734
	],
	"./lely/16x9/stories/orbiterstory/orbiterSixthSlidePipe.svg": [
		2552,
		9,
		1735
	],
	"./lely/16x9/stories/orbiterstory/orbiterSixthSlideTableAdult.svg": [
		2553,
		9,
		1736
	],
	"./lely/16x9/stories/orbiterstory/orbiterStoryArrowTextAdult.svg": [
		2554,
		9,
		1737
	],
	"./lely/16x9/stories/orbiterstory/orbiterStoryAstronautAdult.svg": [
		2555,
		9,
		1738
	],
	"./lely/16x9/stories/orbiterstory/orbiterStoryFifthSLideRobot.svg": [
		2556,
		9,
		1739
	],
	"./lely/16x9/stories/orbiterstory/orbiterStoryFifthSlideMiddlePipeAdult.svg": [
		2557,
		9,
		1740
	],
	"./lely/16x9/stories/orbiterstory/orbiterStoryFifthSlideMilkBottlesAdult.svg": [
		2558,
		9,
		1741
	],
	"./lely/16x9/stories/orbiterstory/orbiterStoryFifthSlidePipeAdult.svg": [
		2559,
		9,
		1742
	],
	"./lely/16x9/stories/orbiterstory/orbiterStoryFifthSlideTableAdult.svg": [
		2560,
		9,
		1743
	],
	"./lely/16x9/stories/orbiterstory/orbiterStoryFifthSlideTemp.svg": [
		2561,
		9,
		1744
	],
	"./lely/16x9/stories/orbiterstory/orbiterStoryFourthSlidePipe.svg": [
		2562,
		9,
		1745
	],
	"./lely/16x9/stories/orbiterstory/orbiterStoryFourthSlideRobotAdult.svg": [
		2563,
		9,
		1746
	],
	"./lely/16x9/stories/orbiterstory/orbiterStoryFourthSlideTempAfter.svg": [
		2564,
		9,
		1747
	],
	"./lely/16x9/stories/orbiterstory/orbiterStoryFourthSlideTempContainer.svg": [
		2565,
		9,
		1748
	],
	"./lely/16x9/stories/orbiterstory/orbiterStoryPipeFifthSlideAdultTransition.svg": [
		2566,
		9,
		1749
	],
	"./lely/16x9/stories/orbiterstory/orbiterStoryYoghurtSixthSlideTemp.svg": [
		2567,
		9,
		1750
	],
	"./lely/16x9/stories/orbiterstory/orbiterStoryYoghurtTemp.svg": [
		2568,
		9,
		1751
	],
	"./lely/16x9/stories/orbiterstory/orbiterTableFIfthSlide.svg": [
		2569,
		9,
		1752
	],
	"./lely/16x9/stories/orbiterstory/orbiterTableSecondPart.svg": [
		2570,
		9,
		1753
	],
	"./lely/16x9/stories/orbiterstory/orbiterTableSixthSlide.svg": [
		2571,
		9,
		1754
	],
	"./lely/16x9/stories/orbiterstory/orbiterTempAfterCoolingAdult.svg": [
		2572,
		9,
		1755
	],
	"./lely/16x9/stories/orbiterstory/orbiterTemperature.svg": [
		2573,
		9,
		1756
	],
	"./lely/16x9/stories/orbiterstory/orbiterTemperatureAdult.svg": [
		2574,
		9,
		1757
	],
	"./lely/16x9/stories/orbiterstory/orbiterThirdArrowAdult.svg": [
		2575,
		9,
		1758
	],
	"./lely/16x9/stories/orbiterstory/orbiterThirdSlideTempContainer.svg": [
		2576,
		9,
		1759
	],
	"./lely/16x9/stories/orbiterstory/orbiterarrow.svg": [
		2577,
		9,
		1760
	],
	"./lely/16x9/stories/orbiterstory/orbiterbus.svg": [
		2578,
		9,
		1761
	],
	"./lely/16x9/stories/orbiterstory/orbitercoolingsystem.svg": [
		2579,
		9,
		1762
	],
	"./lely/16x9/stories/orbiterstory/orbitermainbackground.svg": [
		2580,
		9,
		1763
	],
	"./lely/16x9/stories/orbiterstory/orbitermilkywaypipe.svg": [
		2581,
		9,
		1764
	],
	"./lely/16x9/stories/orbiterstory/orbiterrightpipe.svg": [
		2582,
		9,
		1765
	],
	"./lely/16x9/stories/orbiterstory/orbitersixthslide.svg": [
		2583,
		9,
		1766
	],
	"./lely/16x9/stories/orbiterstory/orbitertreeleft.svg": [
		2584,
		9,
		1767
	],
	"./lely/16x9/stories/orbiterstory/pipe.svg": [
		2585,
		9,
		1768
	],
	"./lely/16x9/stories/orbiterstory/pipeSecondSlideAdult.svg": [
		2586,
		9,
		1769
	],
	"./lely/16x9/stories/orbiterstory/pipeThirdSlide.svg": [
		2587,
		9,
		1770
	],
	"./lely/16x9/stories/orbiterstory/pipeThirdSlideAdult.svg": [
		2588,
		9,
		1771
	],
	"./lely/16x9/stories/orbiterstory/pipefourthslide.svg": [
		2589,
		9,
		1772
	],
	"./lely/16x9/stories/orbiterstory/pipefourthslideright.svg": [
		2590,
		9,
		1773
	],
	"./lely/16x9/stories/orbiterstory/sharingPole.svg": [
		2591,
		9,
		1774
	],
	"./lely/16x9/stories/orbiterstory/temperatureafterorbiter.svg": [
		2592,
		9,
		1775
	],
	"./lely/16x9/stories/orbiterstory/temperaturebeforeorbiter.svg": [
		2593,
		9,
		1776
	],
	"./lely/16x9/stories/orbiterstory/test.svg": [
		2594,
		9,
		1777
	],
	"./lely/16x9/stories/vectorstory/01_Vector_history.jpg": [
		2595,
		7,
		1778
	],
	"./lely/16x9/stories/vectorstory/02_vector_story.jpg": [
		2596,
		7,
		1779
	],
	"./lely/16x9/stories/vectorstory/03_vector_cows.jpg": [
		2597,
		7,
		1780
	],
	"./lely/16x9/stories/vectorstory/americanBarnEndingImage.svg": [
		2598,
		9,
		1781
	],
	"./lely/16x9/stories/vectorstory/dutchBarnEndingImage.svg": [
		2599,
		9,
		1782
	],
	"./lely/16x9/stories/vectorstory/dutchBarnSecondTypeEndingImage.svg": [
		2600,
		9,
		1783
	],
	"./lely/16x9/stories/vectorstory/facebookPlate.svg": [
		2601,
		9,
		1784
	],
	"./lely/16x9/stories/vectorstory/linkedinPlate.svg": [
		2602,
		9,
		1785
	],
	"./lely/16x9/stories/vectorstory/moreInfoPlate.svg": [
		2603,
		9,
		1786
	],
	"./lely/16x9/stories/vectorstory/robotstoryarrow.svg": [
		2604,
		9,
		1787
	],
	"./lely/16x9/stories/vectorstory/sharePlateImage.svg": [
		2605,
		9,
		1788
	],
	"./lely/16x9/stories/vectorstory/sharePoleImage.svg": [
		2606,
		9,
		1789
	],
	"./lely/16x9/stories/vectorstory/twitterPlate.svg": [
		2607,
		9,
		1790
	],
	"./lely/16x9/stories/vectorstory/vectorimagefourthslide.svg": [
		2608,
		9,
		1791
	],
	"./lely/16x9/stories/vectorstory/vectorimagethirdslide.svg": [
		2609,
		9,
		1792
	],
	"./lely/16x9/stories/vectorstory/vectorlastslidesign.svg": [
		2610,
		9,
		1793
	],
	"./lely/16x9/ui/actor-pointer/actor-pointer-arrow.svg": [
		2611,
		9,
		1794
	],
	"./lely/16x9/ui/arrows/arrow-curve-down.svg": [
		2612,
		9,
		1795
	],
	"./lely/16x9/ui/arrows/arrow-left-curve-down-black.svg": [
		2613,
		9,
		1796
	],
	"./lely/16x9/ui/arrows/arrow-left-curve-down.svg": [
		2614,
		9,
		1797
	],
	"./lely/16x9/ui/arrows/arrow-left-curve.svg": [
		2615,
		9,
		1798
	],
	"./lely/16x9/ui/arrows/arrow-right-curve-down.svg": [
		2616,
		9,
		1799
	],
	"./lely/16x9/ui/arrows/arrow-up-curve.svg": [
		2617,
		9,
		1800
	],
	"./lely/16x9/ui/arrows/arrow-up.svg": [
		2618,
		9,
		1801
	],
	"./lely/16x9/ui/arrows/arrow-upward-left.svg": [
		2619,
		9,
		1802
	],
	"./lely/16x9/ui/birds/bird_flying.svg": [
		2620,
		9,
		1803
	],
	"./lely/16x9/ui/buttons/button-with-arrow-down.svg": [
		2621,
		9,
		1804
	],
	"./lely/16x9/ui/buttons/button-with-arrow-up.svg": [
		2622,
		9,
		1805
	],
	"./lely/16x9/ui/buttons/cow-calm-slide-button.svg": [
		2623,
		9,
		1806
	],
	"./lely/16x9/ui/buttons/cow-gave-birth-button.svg": [
		2624,
		9,
		1807
	],
	"./lely/16x9/ui/buttons/red-button-popup-farmer.svg": [
		2625,
		9,
		1808
	],
	"./lely/16x9/ui/buttons/red-button.svg": [
		2626,
		9,
		1809
	],
	"./lely/16x9/ui/buttons/sign-button-left-background.svg": [
		2627,
		9,
		1810
	],
	"./lely/16x9/ui/buttons/sign-button-right-background.svg": [
		2628,
		9,
		1811
	],
	"./lely/16x9/ui/elements/astronaut.svg": [
		2629,
		9,
		1812
	],
	"./lely/16x9/ui/elements/astronautAdultVersion.svg": [
		2630,
		9,
		1813
	],
	"./lely/16x9/ui/elements/cloud.svg": [
		2631,
		9,
		1814
	],
	"./lely/16x9/ui/elements/cow_resting.svg": [
		2632,
		9,
		1815
	],
	"./lely/16x9/ui/elements/grazeway.svg": [
		2633,
		9,
		1816
	],
	"./lely/16x9/ui/elements/milk_bottle.svg": [
		2634,
		9,
		1817
	],
	"./lely/16x9/ui/elements/snowflake.png": [
		2635,
		7,
		1818
	],
	"./lely/16x9/ui/icons/auto-rotate-icon.svg": [
		2636,
		9,
		1819
	],
	"./lely/16x9/ui/icons/calendar-icon.svg": [
		2637,
		9,
		1820
	],
	"./lely/16x9/ui/icons/card-icon.svg": [
		2638,
		9,
		1821
	],
	"./lely/16x9/ui/icons/cash-icon.svg": [
		2639,
		9,
		1822
	],
	"./lely/16x9/ui/icons/click-cursor.svg": [
		2640,
		9,
		1823
	],
	"./lely/16x9/ui/icons/close-icon.svg": [
		2641,
		9,
		1824
	],
	"./lely/16x9/ui/icons/desktop_click.svg": [
		2642,
		7,
		1825
	],
	"./lely/16x9/ui/icons/desktop_click_and_drag.svg": [
		2643,
		7,
		1826
	],
	"./lely/16x9/ui/icons/desktop_scroll.svg": [
		2644,
		7,
		1827
	],
	"./lely/16x9/ui/icons/info-icon.svg": [
		2645,
		9,
		1828
	],
	"./lely/16x9/ui/icons/login-page-lely-logo.svg": [
		2646,
		9,
		1829
	],
	"./lely/16x9/ui/icons/mailbox-icon.svg": [
		2647,
		9,
		1830
	],
	"./lely/16x9/ui/icons/mobile_drag_and_swipe.svg": [
		2648,
		7,
		1831
	],
	"./lely/16x9/ui/icons/mobile_drag_and_swipe_white.svg": [
		2649,
		7,
		1832
	],
	"./lely/16x9/ui/icons/mobile_pinch.svg": [
		2650,
		7,
		1833
	],
	"./lely/16x9/ui/icons/route-icon.svg": [
		2651,
		9,
		1834
	],
	"./lely/16x9/ui/icons/swipe.svg": [
		2652,
		9,
		1835
	],
	"./lely/16x9/ui/icons/webshop-icon.svg": [
		2653,
		9,
		1836
	],
	"./lely/16x9/ui/icons/zoom-in-icon.svg": [
		2654,
		9,
		1837
	],
	"./lely/16x9/ui/icons/zoom-out-icon.svg": [
		2655,
		9,
		1838
	],
	"./lely/16x9/ui/live-data-indicator/background.svg": [
		2656,
		9,
		1839
	],
	"./lely/16x9/ui/popup/close-popup-button-adult-theme.svg": [
		2657,
		9,
		1840
	],
	"./lely/16x9/ui/popup/close-popup-button.svg": [
		2658,
		9,
		1841
	],
	"./lely/16x9/ui/popup/orange_button_arrows.svg": [
		2659,
		9,
		1842
	],
	"./lely/16x9/ui/reference-value-chart/board.svg": [
		2660,
		9,
		1843
	],
	"./lely/16x9/ui/reference-value-chart/board_base.svg": [
		2661,
		9,
		1844
	],
	"./lely/16x9/ui/reference-value-chart/board_base_children_version.svg": [
		2662,
		9,
		1845
	],
	"./lely/16x9/ui/reference-value-chart/board_children_version.svg": [
		2663,
		9,
		1846
	],
	"./lely/16x9/ui/reference-value-chart/current_arrow.svg": [
		2664,
		9,
		1847
	],
	"./lely/16x9/ui/reference-value-chart/current_arrow_children_version.svg": [
		2665,
		9,
		1848
	],
	"./lely/16x9/ui/reference-value-chart/legend_board_1.svg": [
		2666,
		9,
		1849
	],
	"./lely/16x9/ui/reference-value-chart/legend_board_1_children_version.svg": [
		2667,
		9,
		1850
	],
	"./lely/16x9/ui/reference-value-chart/legend_board_2.svg": [
		2668,
		9,
		1851
	],
	"./lely/16x9/ui/reference-value-chart/legend_board_2_children_version.svg": [
		2669,
		9,
		1852
	],
	"./lely/16x9/ui/reference-value-chart/reference_arrow.svg": [
		2670,
		9,
		1853
	],
	"./lely/16x9/ui/reference-value-chart/reference_arrow_children_version.svg": [
		2671,
		9,
		1854
	],
	"./lely/16x9/ui/ribbon/ribbon.svg": [
		2672,
		9,
		1855
	],
	"./lely/16x9/ui/sidemenu/close-menu-button.svg": [
		2673,
		9,
		1856
	],
	"./lely/16x9/ui/sidemenu/dutchLanguage.svg": [
		2674,
		9,
		1857
	],
	"./lely/16x9/ui/sidemenu/email-icon.svg": [
		2675,
		9,
		1858
	],
	"./lely/16x9/ui/sidemenu/emailAdultVersion.svg": [
		2676,
		9,
		1859
	],
	"./lely/16x9/ui/sidemenu/englishLanguage.svg": [
		2677,
		9,
		1860
	],
	"./lely/16x9/ui/sidemenu/facebook-icon.svg": [
		2678,
		9,
		1861
	],
	"./lely/16x9/ui/sidemenu/instagram-icon.svg": [
		2679,
		9,
		1862
	],
	"./lely/16x9/ui/sidemenu/menu-icon.svg": [
		2680,
		9,
		1863
	],
	"./lely/16x9/ui/sidemenu/twitter-icon.svg": [
		2681,
		9,
		1864
	],
	"./lely/16x9/ui/usermanagement/farm_background.png": [
		2682,
		7,
		1865
	],
	"./lely/16x9/ui/usermanagement/lely_logo.png": [
		2683,
		7,
		1866
	],
	"./lely/16x9/ui/windmill/windmill-body.svg": [
		2684,
		9,
		1867
	],
	"./lely/16x9/ui/windmill/windmill-fin.svg": [
		2685,
		9,
		1868
	],
	"./mijnmelk/16x9/actors/astronautfactory/astronaut-landing-page.svg": [
		2686,
		9,
		1869
	],
	"./mijnmelk/16x9/actors/cheesefactory/cheese-factory.svg": [
		2687,
		9,
		1870
	],
	"./mijnmelk/16x9/actors/cow/popup/heads/cow-list-popup-head-blaarkop-black.svg": [
		2688,
		9,
		1871
	],
	"./mijnmelk/16x9/actors/cow/popup/heads/cow-list-popup-head-blaarkop-brown.svg": [
		2689,
		9,
		1872
	],
	"./mijnmelk/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-black.svg": [
		2690,
		9,
		1873
	],
	"./mijnmelk/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-brown.svg": [
		2691,
		9,
		1874
	],
	"./mijnmelk/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-rainbow.svg": [
		2692,
		9,
		1875
	],
	"./mijnmelk/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-white.svg": [
		2693,
		9,
		1876
	],
	"./mijnmelk/16x9/actors/cow/popup/heads/cow-list-popup-head-jersey-brown.svg": [
		2694,
		9,
		1877
	],
	"./mijnmelk/16x9/actors/cow/popup/heads/cow-list-popup-head-jersey-white.svg": [
		2695,
		9,
		1878
	],
	"./mijnmelk/16x9/actors/cow/popup/heads/cow-list-popup-head-lakenvelder-black.svg": [
		2696,
		9,
		1879
	],
	"./mijnmelk/16x9/actors/cow/popup/heads/cow-list-popup-head-lakenvelder-brown.svg": [
		2697,
		9,
		1880
	],
	"./mijnmelk/16x9/actors/cow/popup/heads/cow-list-popup-head-maasRijn-brown.svg": [
		2698,
		9,
		1881
	],
	"./mijnmelk/16x9/actors/cow/virtualFarmAvatars/cow-maas-rijn.svg": [
		2699,
		9,
		1882
	],
	"./mijnmelk/16x9/actors/cow/virtualFarmAvatars/cowBlaarKop--one.svg": [
		2700,
		9,
		1883
	],
	"./mijnmelk/16x9/actors/cow/virtualFarmAvatars/cowBlaarKop--two.svg": [
		2701,
		9,
		1884
	],
	"./mijnmelk/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--one.svg": [
		2702,
		9,
		1885
	],
	"./mijnmelk/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--three.svg": [
		2703,
		9,
		1886
	],
	"./mijnmelk/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--two.svg": [
		2704,
		9,
		1887
	],
	"./mijnmelk/16x9/actors/cow/virtualFarmAvatars/cowJersey--one.svg": [
		2705,
		9,
		1888
	],
	"./mijnmelk/16x9/actors/cow/virtualFarmAvatars/cowJersey--two.svg": [
		2706,
		9,
		1889
	],
	"./mijnmelk/16x9/actors/cow/virtualFarmAvatars/cowLakenvelder--one.svg": [
		2707,
		9,
		1890
	],
	"./mijnmelk/16x9/actors/cow/virtualFarmAvatars/cowLakenvelder--two.svg": [
		2708,
		9,
		1891
	],
	"./mijnmelk/16x9/actors/cow/virtualFarmAvatars/cowMaasRijn--one.svg": [
		2709,
		9,
		1892
	],
	"./mijnmelk/16x9/actors/cow/virtualFarmAvatars/cowPride--one.svg": [
		2710,
		9,
		1893
	],
	"./mijnmelk/16x9/actors/dairyfactory/dairy-robot-factory.svg": [
		2711,
		9,
		1894
	],
	"./mijnmelk/16x9/actors/discovery/discoveryRobot.svg": [
		2712,
		9,
		1895
	],
	"./mijnmelk/16x9/actors/farmer/farmer-female.svg": [
		2713,
		9,
		1896
	],
	"./mijnmelk/16x9/actors/farmer/farmer-male.svg": [
		2714,
		9,
		1897
	],
	"./mijnmelk/16x9/actors/grazeway/grazeway-door.svg": [
		2715,
		9,
		1898
	],
	"./mijnmelk/16x9/actors/grazeway/grazeway-feature.svg": [
		2716,
		9,
		1899
	],
	"./mijnmelk/16x9/actors/icecreamfactory/ice-cream-factory.svg": [
		2717,
		9,
		1900
	],
	"./mijnmelk/16x9/actors/mijnmelkactor/MMDobbelhoeve.svg": [
		2718,
		9,
		1901
	],
	"./mijnmelk/16x9/actors/mijnmelkactor/MMDobbelhoeveyoghurt.svg": [
		2719,
		9,
		1902
	],
	"./mijnmelk/16x9/actors/mijnmelkactor/MMOostdam.svg": [
		2720,
		9,
		1903
	],
	"./mijnmelk/16x9/actors/mijnmelkactor/MMOostdamyoghurt.svg": [
		2721,
		9,
		1904
	],
	"./mijnmelk/16x9/actors/mijnmelkactor/MMReijer.svg": [
		2722,
		9,
		1905
	],
	"./mijnmelk/16x9/actors/mijnmelkactor/MMVelden.svg": [
		2723,
		9,
		1906
	],
	"./mijnmelk/16x9/actors/mijnmelkactor/MMVeldenyoghurt.svg": [
		2724,
		9,
		1907
	],
	"./mijnmelk/16x9/actors/mijnmelkactor/Mijn_Melk_-_Dobbelhoeve_Yoghurt_37_0073_lowres.width-800.jpg": [
		2725,
		7,
		1908
	],
	"./mijnmelk/16x9/actors/mijnmelkactor/mijnMelkPlate.svg": [
		2726,
		9,
		1909
	],
	"./mijnmelk/16x9/actors/mijnmelkactor/mijnMelkSecondSlide.svg": [
		2727,
		9,
		1910
	],
	"./mijnmelk/16x9/actors/mijnmelkactor/mijnmelkactor.svg": [
		2728,
		9,
		1911
	],
	"./mijnmelk/16x9/actors/mijnmelkactor/mijnmelkdobblehoeve.svg": [
		2729,
		9,
		1912
	],
	"./mijnmelk/16x9/actors/mijnmelkactor/mijnmelkdobblehoeveAdult.svg": [
		2730,
		9,
		1913
	],
	"./mijnmelk/16x9/actors/mijnmelkactor/mijnmelkoostdam.svg": [
		2731,
		9,
		1914
	],
	"./mijnmelk/16x9/actors/mijnmelkactor/mijnmelkoostdamAdult.svg": [
		2732,
		9,
		1915
	],
	"./mijnmelk/16x9/actors/mijnmelkactor/mijnmelkrotgans.svg": [
		2733,
		9,
		1916
	],
	"./mijnmelk/16x9/actors/mijnmelkactor/mijnmelkrotgansAdult.svg": [
		2734,
		9,
		1917
	],
	"./mijnmelk/16x9/actors/mijnmelkactor/mijnmelkschutte.svg": [
		2735,
		9,
		1918
	],
	"./mijnmelk/16x9/actors/mijnmelkactor/mijnmelkschutteAdult.svg": [
		2736,
		9,
		1919
	],
	"./mijnmelk/16x9/actors/mijnmelkactor/mijnmelkthirdslide.svg": [
		2737,
		9,
		1920
	],
	"./mijnmelk/16x9/actors/milkfactory/milk-factory-new.svg": [
		2738,
		9,
		1921
	],
	"./mijnmelk/16x9/actors/milkfactory/milk-factory.svg": [
		2739,
		9,
		1922
	],
	"./mijnmelk/16x9/actors/tractor/green_tractor.svg": [
		2740,
		9,
		1923
	],
	"./mijnmelk/16x9/onboarding/adult/Packshot_MijnMelk_Yoghurt_500ml_Guus_nolabel_small.png": [
		2741,
		7,
		1924
	],
	"./mijnmelk/16x9/onboarding/adult/Packshot_MijnMelk_Yoghurt_500ml_Ineke_nolabel_small.png": [
		2742,
		7,
		1925
	],
	"./mijnmelk/16x9/onboarding/adult/Packshot_MijnMelk_Yoghurt_500ml_Yvonne_nolabel_small.png": [
		2743,
		7,
		1926
	],
	"./mijnmelk/16x9/onboarding/adult/bottle_guus.png": [
		2744,
		7,
		1927
	],
	"./mijnmelk/16x9/onboarding/adult/bottle_ineke.png": [
		2745,
		7,
		1928
	],
	"./mijnmelk/16x9/onboarding/adult/bottle_reijer.png": [
		2746,
		7,
		1929
	],
	"./mijnmelk/16x9/onboarding/adult/bottle_yvonne.png": [
		2747,
		7,
		1930
	],
	"./mijnmelk/16x9/onboarding/adult/grass.png": [
		2748,
		7,
		1931
	],
	"./mijnmelk/16x9/onboarding/adult/landSurface.svg": [
		2749,
		9,
		1932
	],
	"./mijnmelk/16x9/onboarding/adult/slide1/arrowPointingDownLeft.svg": [
		2750,
		9,
		1933
	],
	"./mijnmelk/16x9/onboarding/adult/slide1/arrowPointingDownRight.svg": [
		2751,
		9,
		1934
	],
	"./mijnmelk/16x9/onboarding/adult/slide1/batchLabel.svg": [
		2752,
		9,
		1935
	],
	"./mijnmelk/16x9/onboarding/adult/slide1/batchLabelArrow.svg": [
		2753,
		9,
		1936
	],
	"./mijnmelk/16x9/onboarding/adult/slide1/farmLocationIcon.svg": [
		2754,
		9,
		1937
	],
	"./mijnmelk/16x9/onboarding/adult/slide1/leftSideIconsPinAndClock.svg": [
		2755,
		9,
		1938
	],
	"./mijnmelk/16x9/onboarding/adult/slide1/littleGrass.svg": [
		2756,
		9,
		1939
	],
	"./mijnmelk/16x9/onboarding/adult/slide1/mijnMelkPlate.svg": [
		2757,
		9,
		1940
	],
	"./mijnmelk/16x9/onboarding/adult/slide1/milkingTimeIcon.svg": [
		2758,
		9,
		1941
	],
	"./mijnmelk/16x9/onboarding/adult/slide1/slide1GraphicElements.svg": [
		2759,
		9,
		1942
	],
	"./mijnmelk/16x9/onboarding/adult/slide1/smallBottleIcon.svg": [
		2760,
		9,
		1943
	],
	"./mijnmelk/16x9/onboarding/adult/slide1/temperatureIcon.svg": [
		2761,
		9,
		1944
	],
	"./mijnmelk/16x9/onboarding/adult/slide2/fromCowToBus.svg": [
		2762,
		9,
		1945
	],
	"./mijnmelk/16x9/onboarding/adult/slide2/grain.svg": [
		2763,
		9,
		1946
	],
	"./mijnmelk/16x9/onboarding/adult/slide2/holsteinLying.svg": [
		2764,
		9,
		1947
	],
	"./mijnmelk/16x9/onboarding/adult/slide2/leftCow.svg": [
		2765,
		9,
		1948
	],
	"./mijnmelk/16x9/onboarding/adult/slide2/slide2GraphicElements.svg": [
		2766,
		9,
		1949
	],
	"./mijnmelk/16x9/onboarding/adult/slide3/fromBottleToLips.svg": [
		2767,
		9,
		1950
	],
	"./mijnmelk/16x9/onboarding/adult/slide3/slide3GraphicElements.svg": [
		2768,
		9,
		1951
	],
	"./mijnmelk/16x9/onboarding/adult/slide3/slide3chickens.svg": [
		2769,
		9,
		1952
	],
	"./mijnmelk/16x9/onboarding/adult/slide3/slide3cow.svg": [
		2770,
		9,
		1953
	],
	"./mijnmelk/16x9/onboarding/adult/slide3/slide3grass.svg": [
		2771,
		9,
		1954
	],
	"./mijnmelk/16x9/onboarding/adult/slide4/farmerAndFence.svg": [
		2772,
		9,
		1955
	],
	"./mijnmelk/16x9/onboarding/adult/slide4/fromPinToBottle.svg": [
		2773,
		9,
		1956
	],
	"./mijnmelk/16x9/onboarding/adult/slide4/slide4GraphicElements.svg": [
		2774,
		9,
		1957
	],
	"./mijnmelk/16x9/onboarding/adult/slide4/slide4grass.svg": [
		2775,
		9,
		1958
	],
	"./mijnmelk/16x9/onboarding/adult/slide4/tapHandIcon.svg": [
		2776,
		9,
		1959
	],
	"./mijnmelk/16x9/onboarding/adult/slide4/toTheFarmButton.svg": [
		2777,
		9,
		1960
	],
	"./mijnmelk/16x9/onboarding/adult/swipeGestureIcon.svg": [
		2778,
		9,
		1961
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/temperature_icon.svg": [
		2779,
		9,
		1962
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_cloudy.svg": [
		2780,
		9,
		1963
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_cloudy_heavy.svg": [
		2781,
		9,
		1964
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_cloudy_light.svg": [
		2782,
		9,
		1965
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_cloudy_night.svg": [
		2783,
		9,
		1966
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_cloudy_rain.svg": [
		2784,
		9,
		1967
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_cloudy_rain_heavy.svg": [
		2785,
		9,
		1968
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_cloudy_rain_light.svg": [
		2786,
		9,
		1969
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_cloudy_rain_night.svg": [
		2787,
		9,
		1970
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_cloudy_snow.svg": [
		2788,
		9,
		1971
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_cloudy_snow_heavy.svg": [
		2789,
		9,
		1972
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_cloudy_snow_light.svg": [
		2790,
		9,
		1973
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_cloudy_snow_night.svg": [
		2791,
		9,
		1974
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_cloudy_thunder.svg": [
		2792,
		9,
		1975
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_cloudy_thunder_heavy.svg": [
		2793,
		9,
		1976
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_cloudy_thunder_light.svg": [
		2794,
		9,
		1977
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_cloudy_thunder_night.svg": [
		2795,
		9,
		1978
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_cloudy_thunder_rain.svg": [
		2796,
		9,
		1979
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_cloudy_thunder_rain_heavy.svg": [
		2797,
		9,
		1980
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_cloudy_thunder_rain_light.svg": [
		2798,
		9,
		1981
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_cloudy_thunder_rain_night.svg": [
		2799,
		9,
		1982
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_mist.svg": [
		2800,
		9,
		1983
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_mist_cloudy.svg": [
		2801,
		9,
		1984
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_mist_day.svg": [
		2802,
		9,
		1985
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_mist_night.svg": [
		2803,
		9,
		1986
	],
	"./mijnmelk/16x9/onboarding/adult/weatherIcons/weatherIcon_sunny.svg": [
		2804,
		9,
		1987
	],
	"./mijnmelk/16x9/onboarding/adult/yoghurt_guus.png": [
		2805,
		7,
		1988
	],
	"./mijnmelk/16x9/onboarding/adult/yoghurt_ineke.png": [
		2806,
		7,
		1989
	],
	"./mijnmelk/16x9/onboarding/adult/yoghurt_yvonne.png": [
		2807,
		7,
		1990
	],
	"./mijnmelk/16x9/onboarding/farmerPresentation/arrow-up-curve.svg": [
		2808,
		9,
		1991
	],
	"./mijnmelk/16x9/onboarding/farmerPresentation/farmer.svg": [
		2809,
		9,
		1992
	],
	"./mijnmelk/16x9/onboarding/finalOnboardingSite/background-image.svg": [
		2810,
		9,
		1993
	],
	"./mijnmelk/16x9/onboarding/finalOnboardingSite/bottle.svg": [
		2811,
		9,
		1994
	],
	"./mijnmelk/16x9/onboarding/finalOnboardingSite/cup-milk.svg": [
		2812,
		9,
		1995
	],
	"./mijnmelk/16x9/onboarding/finalOnboardingSite/ending-point-back-button.svg": [
		2813,
		9,
		1996
	],
	"./mijnmelk/16x9/onboarding/finalOnboardingSite/ending-point-button.svg": [
		2814,
		9,
		1997
	],
	"./mijnmelk/16x9/onboarding/finalOnboardingSite/ending-point-revert-button.svg": [
		2815,
		9,
		1998
	],
	"./mijnmelk/16x9/onboarding/finalOnboardingSite/ending-point-screen.svg": [
		2816,
		9,
		1999
	],
	"./mijnmelk/16x9/onboarding/meadowScreen/background-image-organic.svg": [
		2817,
		9,
		2000
	],
	"./mijnmelk/16x9/onboarding/organicFarming/background-image-organic.svg": [
		2818,
		9,
		2001
	],
	"./mijnmelk/16x9/onboarding/organicFarming/big-grass.svg": [
		2819,
		9,
		2002
	],
	"./mijnmelk/16x9/onboarding/organicFarming/cloves.svg": [
		2820,
		9,
		2003
	],
	"./mijnmelk/16x9/onboarding/organicFarming/little-cow.svg": [
		2821,
		9,
		2004
	],
	"./mijnmelk/16x9/onboarding/organicFarming/poison.svg": [
		2822,
		9,
		2005
	],
	"./mijnmelk/16x9/onboarding/organicFarming/small-grass.svg": [
		2823,
		9,
		2006
	],
	"./mijnmelk/16x9/onboarding/robotsOnboarding/barn-background.svg": [
		2824,
		9,
		2007
	],
	"./mijnmelk/16x9/onboarding/welcomeScreen/farmer-image.svg": [
		2825,
		9,
		2008
	],
	"./mijnmelk/16x9/onboarding/welcomeScreen/logo_MijnMelk (2).svg": [
		2826,
		9,
		2009
	],
	"./mijnmelk/16x9/onboarding/welcomeScreen/miniFarm.svg": [
		2827,
		9,
		2010
	],
	"./mijnmelk/16x9/onboarding/welcomeScreen/ribbon-title.svg": [
		2828,
		9,
		2011
	],
	"./mijnmelk/16x9/onboarding/welcomeScreen/swipe-icon.svg": [
		2829,
		9,
		2012
	],
	"./mijnmelk/16x9/onboarding/welcomeScreen/welcome-screen-background.svg": [
		2830,
		9,
		2013
	],
	"./mijnmelk/16x9/onboarding/welcomeScreen/welcome-screen-mijn-melk.svg": [
		2831,
		9,
		2014
	],
	"./mijnmelk/16x9/onboarding/welcomeScreen/welcome-screen.svg": [
		2832,
		9,
		2015
	],
	"./mijnmelk/16x9/screens/virtualFarm/background.svg": [
		2833,
		9,
		2016
	],
	"./mijnmelk/16x9/screens/virtualFarm/background_animal_fence.svg": [
		2834,
		9,
		2017
	],
	"./mijnmelk/16x9/screens/virtualFarm/background_animal_pen_masked.svg": [
		2835,
		9,
		2018
	],
	"./mijnmelk/16x9/screens/virtualFarm/background_barn_floor.svg": [
		2836,
		9,
		2019
	],
	"./mijnmelk/16x9/screens/virtualFarm/background_barn_left_part.svg": [
		2837,
		9,
		2020
	],
	"./mijnmelk/16x9/screens/virtualFarm/background_barn_left_side.svg": [
		2838,
		9,
		2021
	],
	"./mijnmelk/16x9/screens/virtualFarm/background_barn_production.svg": [
		2839,
		9,
		2022
	],
	"./mijnmelk/16x9/screens/virtualFarm/background_barn_right_side.svg": [
		2840,
		9,
		2023
	],
	"./mijnmelk/16x9/screens/virtualFarm/background_bus.svg": [
		2841,
		9,
		2024
	],
	"./mijnmelk/16x9/screens/virtualFarm/background_bus_label_picnic.svg": [
		2842,
		9,
		2025
	],
	"./mijnmelk/16x9/screens/virtualFarm/background_bus_no_label.svg": [
		2843,
		9,
		2026
	],
	"./mijnmelk/16x9/screens/virtualFarm/background_farm_hill.svg": [
		2844,
		9,
		2027
	],
	"./mijnmelk/16x9/screens/virtualFarm/background_farm_house.svg": [
		2845,
		9,
		2028
	],
	"./mijnmelk/16x9/screens/virtualFarm/background_farm_house_style2.svg": [
		2846,
		9,
		2029
	],
	"./mijnmelk/16x9/screens/virtualFarm/background_farm_house_style3.svg": [
		2847,
		9,
		2030
	],
	"./mijnmelk/16x9/screens/virtualFarm/background_farm_overview_812x375.svg": [
		2848,
		9,
		2031
	],
	"./mijnmelk/16x9/screens/virtualFarm/background_farm_right_street.svg": [
		2849,
		9,
		2032
	],
	"./mijnmelk/16x9/screens/virtualFarm/background_new.svg": [
		2850,
		9,
		2033
	],
	"./mijnmelk/16x9/screens/virtualFarm/background_without_picnic.svg": [
		2851,
		9,
		2034
	],
	"./mijnmelk/16x9/screens/virtualFarm/background_without_picnic_new.svg": [
		2852,
		9,
		2035
	],
	"./mijnmelk/16x9/screens/virtualFarm/grassType1.svg": [
		2853,
		9,
		2036
	],
	"./mijnmelk/16x9/ui/icons/mailbox-icon.svg": [
		2854,
		9,
		2037
	],
	"./mijnmelk/16x9/ui/ribbon/adult_ribbon.svg": [
		2855,
		9,
		2038
	],
	"./mijnmelk/16x9/ui/ribbon/ribbon.svg": [
		2856,
		9,
		2039
	],
	"./mijnmelkgeneric/16x9/actors/astronautfactory/astronaut-landing-page.svg": [
		2857,
		9,
		2040
	],
	"./mijnmelkgeneric/16x9/actors/cheesefactory/cheese-factory.svg": [
		2858,
		9,
		2041
	],
	"./mijnmelkgeneric/16x9/actors/cow/heads/cow-list-popup-head-1.svg": [
		2859,
		9,
		2042
	],
	"./mijnmelkgeneric/16x9/actors/cow/heads/cow-list-popup-head-10.svg": [
		2860,
		9,
		2043
	],
	"./mijnmelkgeneric/16x9/actors/cow/heads/cow-list-popup-head-11.svg": [
		2861,
		9,
		2044
	],
	"./mijnmelkgeneric/16x9/actors/cow/heads/cow-list-popup-head-2.svg": [
		2862,
		9,
		2045
	],
	"./mijnmelkgeneric/16x9/actors/cow/heads/cow-list-popup-head-3.svg": [
		2863,
		9,
		2046
	],
	"./mijnmelkgeneric/16x9/actors/cow/heads/cow-list-popup-head-4.svg": [
		2864,
		9,
		2047
	],
	"./mijnmelkgeneric/16x9/actors/cow/heads/cow-list-popup-head-5.svg": [
		2865,
		9,
		2048
	],
	"./mijnmelkgeneric/16x9/actors/cow/heads/cow-list-popup-head-6.svg": [
		2866,
		9,
		2049
	],
	"./mijnmelkgeneric/16x9/actors/cow/heads/cow-list-popup-head-7.svg": [
		2867,
		9,
		2050
	],
	"./mijnmelkgeneric/16x9/actors/cow/heads/cow-list-popup-head-8.svg": [
		2868,
		9,
		2051
	],
	"./mijnmelkgeneric/16x9/actors/cow/heads/cow-list-popup-head-9.svg": [
		2869,
		9,
		2052
	],
	"./mijnmelkgeneric/16x9/actors/cow/popup/heads/cow-list-popup-head-blaarkop-black.svg": [
		2870,
		9,
		2053
	],
	"./mijnmelkgeneric/16x9/actors/cow/popup/heads/cow-list-popup-head-blaarkop-brown.svg": [
		2871,
		9,
		2054
	],
	"./mijnmelkgeneric/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-black.svg": [
		2872,
		9,
		2055
	],
	"./mijnmelkgeneric/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-brown.svg": [
		2873,
		9,
		2056
	],
	"./mijnmelkgeneric/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-rainbow.svg": [
		2874,
		9,
		2057
	],
	"./mijnmelkgeneric/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-white.svg": [
		2875,
		9,
		2058
	],
	"./mijnmelkgeneric/16x9/actors/cow/popup/heads/cow-list-popup-head-jersey-brown.svg": [
		2876,
		9,
		2059
	],
	"./mijnmelkgeneric/16x9/actors/cow/popup/heads/cow-list-popup-head-jersey-white.svg": [
		2877,
		9,
		2060
	],
	"./mijnmelkgeneric/16x9/actors/cow/popup/heads/cow-list-popup-head-lakenvelder-black.svg": [
		2878,
		9,
		2061
	],
	"./mijnmelkgeneric/16x9/actors/cow/popup/heads/cow-list-popup-head-lakenvelder-brown.svg": [
		2879,
		9,
		2062
	],
	"./mijnmelkgeneric/16x9/actors/cow/popup/heads/cow-list-popup-head-maasRijn-brown.svg": [
		2880,
		9,
		2063
	],
	"./mijnmelkgeneric/16x9/actors/cow/virtualFarmAvatars/cow-maas-rijn.svg": [
		2881,
		9,
		2064
	],
	"./mijnmelkgeneric/16x9/actors/cow/virtualFarmAvatars/cowBlaarKop--one.svg": [
		2882,
		9,
		2065
	],
	"./mijnmelkgeneric/16x9/actors/cow/virtualFarmAvatars/cowBlaarKop--two.svg": [
		2883,
		9,
		2066
	],
	"./mijnmelkgeneric/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--one.svg": [
		2884,
		9,
		2067
	],
	"./mijnmelkgeneric/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--three.svg": [
		2885,
		9,
		2068
	],
	"./mijnmelkgeneric/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--two.svg": [
		2886,
		9,
		2069
	],
	"./mijnmelkgeneric/16x9/actors/cow/virtualFarmAvatars/cowJersey--one.svg": [
		2887,
		9,
		2070
	],
	"./mijnmelkgeneric/16x9/actors/cow/virtualFarmAvatars/cowJersey--two.svg": [
		2888,
		9,
		2071
	],
	"./mijnmelkgeneric/16x9/actors/cow/virtualFarmAvatars/cowLakenvelder--one.svg": [
		2889,
		9,
		2072
	],
	"./mijnmelkgeneric/16x9/actors/cow/virtualFarmAvatars/cowLakenvelder--two.svg": [
		2890,
		9,
		2073
	],
	"./mijnmelkgeneric/16x9/actors/cow/virtualFarmAvatars/cowMaasRijn--one.svg": [
		2891,
		9,
		2074
	],
	"./mijnmelkgeneric/16x9/actors/cow/virtualFarmAvatars/cowPride--one.svg": [
		2892,
		9,
		2075
	],
	"./mijnmelkgeneric/16x9/actors/dairyfactory/dairy-robot-factory.svg": [
		2893,
		9,
		2076
	],
	"./mijnmelkgeneric/16x9/actors/discovery/discoveryRobot.svg": [
		2894,
		9,
		2077
	],
	"./mijnmelkgeneric/16x9/actors/farmer/farmer-female.svg": [
		2895,
		9,
		2078
	],
	"./mijnmelkgeneric/16x9/actors/farmer/farmer-male.svg": [
		2896,
		9,
		2079
	],
	"./mijnmelkgeneric/16x9/actors/grazeway/grazeway-door.svg": [
		2897,
		9,
		2080
	],
	"./mijnmelkgeneric/16x9/actors/grazeway/grazeway-feature.svg": [
		2898,
		9,
		2081
	],
	"./mijnmelkgeneric/16x9/actors/icecreamfactory/ice-cream-factory.svg": [
		2899,
		9,
		2082
	],
	"./mijnmelkgeneric/16x9/actors/milkfactory/milk-factory-new.svg": [
		2900,
		9,
		2083
	],
	"./mijnmelkgeneric/16x9/actors/milkfactory/milk-factory.svg": [
		2901,
		9,
		2084
	],
	"./mijnmelkpicnic/16x9/actors/astronautfactory/astronaut-landing-page.svg": [
		2902,
		9,
		2085
	],
	"./mijnmelkpicnic/16x9/actors/cheesefactory/cheese-factory.svg": [
		2903,
		9,
		2086
	],
	"./mijnmelkpicnic/16x9/actors/cow/heads/cow-list-popup-head-1.svg": [
		2904,
		9,
		2087
	],
	"./mijnmelkpicnic/16x9/actors/cow/heads/cow-list-popup-head-10.svg": [
		2905,
		9,
		2088
	],
	"./mijnmelkpicnic/16x9/actors/cow/heads/cow-list-popup-head-11.svg": [
		2906,
		9,
		2089
	],
	"./mijnmelkpicnic/16x9/actors/cow/heads/cow-list-popup-head-2.svg": [
		2907,
		9,
		2090
	],
	"./mijnmelkpicnic/16x9/actors/cow/heads/cow-list-popup-head-3.svg": [
		2908,
		9,
		2091
	],
	"./mijnmelkpicnic/16x9/actors/cow/heads/cow-list-popup-head-4.svg": [
		2909,
		9,
		2092
	],
	"./mijnmelkpicnic/16x9/actors/cow/heads/cow-list-popup-head-5.svg": [
		2910,
		9,
		2093
	],
	"./mijnmelkpicnic/16x9/actors/cow/heads/cow-list-popup-head-6.svg": [
		2911,
		9,
		2094
	],
	"./mijnmelkpicnic/16x9/actors/cow/heads/cow-list-popup-head-7.svg": [
		2912,
		9,
		2095
	],
	"./mijnmelkpicnic/16x9/actors/cow/heads/cow-list-popup-head-8.svg": [
		2913,
		9,
		2096
	],
	"./mijnmelkpicnic/16x9/actors/cow/heads/cow-list-popup-head-9.svg": [
		2914,
		9,
		2097
	],
	"./mijnmelkpicnic/16x9/actors/cow/popup/heads/cow-list-popup-head-blaarkop-black.svg": [
		2915,
		9,
		2098
	],
	"./mijnmelkpicnic/16x9/actors/cow/popup/heads/cow-list-popup-head-blaarkop-brown.svg": [
		2916,
		9,
		2099
	],
	"./mijnmelkpicnic/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-black.svg": [
		2917,
		9,
		2100
	],
	"./mijnmelkpicnic/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-brown.svg": [
		2918,
		9,
		2101
	],
	"./mijnmelkpicnic/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-rainbow.svg": [
		2919,
		9,
		2102
	],
	"./mijnmelkpicnic/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-white.svg": [
		2920,
		9,
		2103
	],
	"./mijnmelkpicnic/16x9/actors/cow/popup/heads/cow-list-popup-head-jersey-brown.svg": [
		2921,
		9,
		2104
	],
	"./mijnmelkpicnic/16x9/actors/cow/popup/heads/cow-list-popup-head-jersey-white.svg": [
		2922,
		9,
		2105
	],
	"./mijnmelkpicnic/16x9/actors/cow/popup/heads/cow-list-popup-head-lakenvelder-black.svg": [
		2923,
		9,
		2106
	],
	"./mijnmelkpicnic/16x9/actors/cow/popup/heads/cow-list-popup-head-lakenvelder-brown.svg": [
		2924,
		9,
		2107
	],
	"./mijnmelkpicnic/16x9/actors/cow/popup/heads/cow-list-popup-head-maasRijn-brown.svg": [
		2925,
		9,
		2108
	],
	"./mijnmelkpicnic/16x9/actors/cow/virtualFarmAvatars/cow-maas-rijn.svg": [
		2926,
		9,
		2109
	],
	"./mijnmelkpicnic/16x9/actors/cow/virtualFarmAvatars/cowBlaarKop--one.svg": [
		2927,
		9,
		2110
	],
	"./mijnmelkpicnic/16x9/actors/cow/virtualFarmAvatars/cowBlaarKop--two.svg": [
		2928,
		9,
		2111
	],
	"./mijnmelkpicnic/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--one.svg": [
		2929,
		9,
		2112
	],
	"./mijnmelkpicnic/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--three.svg": [
		2930,
		9,
		2113
	],
	"./mijnmelkpicnic/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--two.svg": [
		2931,
		9,
		2114
	],
	"./mijnmelkpicnic/16x9/actors/cow/virtualFarmAvatars/cowJersey--one.svg": [
		2932,
		9,
		2115
	],
	"./mijnmelkpicnic/16x9/actors/cow/virtualFarmAvatars/cowJersey--two.svg": [
		2933,
		9,
		2116
	],
	"./mijnmelkpicnic/16x9/actors/cow/virtualFarmAvatars/cowLakenvelder--one.svg": [
		2934,
		9,
		2117
	],
	"./mijnmelkpicnic/16x9/actors/cow/virtualFarmAvatars/cowLakenvelder--two.svg": [
		2935,
		9,
		2118
	],
	"./mijnmelkpicnic/16x9/actors/cow/virtualFarmAvatars/cowMaasRijn--one.svg": [
		2936,
		9,
		2119
	],
	"./mijnmelkpicnic/16x9/actors/cow/virtualFarmAvatars/cowPride--one.svg": [
		2937,
		9,
		2120
	],
	"./mijnmelkpicnic/16x9/actors/dairyfactory/dairy-robot-factory.svg": [
		2938,
		9,
		2121
	],
	"./mijnmelkpicnic/16x9/actors/discovery/discoveryRobot.svg": [
		2939,
		9,
		2122
	],
	"./mijnmelkpicnic/16x9/actors/farmer/farmer-female.svg": [
		2940,
		9,
		2123
	],
	"./mijnmelkpicnic/16x9/actors/farmer/farmer-male.svg": [
		2941,
		9,
		2124
	],
	"./mijnmelkpicnic/16x9/actors/grazeway/grazeway-door.svg": [
		2942,
		9,
		2125
	],
	"./mijnmelkpicnic/16x9/actors/grazeway/grazeway-feature.svg": [
		2943,
		9,
		2126
	],
	"./mijnmelkpicnic/16x9/actors/icecreamfactory/ice-cream-factory.svg": [
		2944,
		9,
		2127
	],
	"./mijnmelkpicnic/16x9/actors/milkfactory/milk-factory-new.svg": [
		2945,
		9,
		2128
	],
	"./mijnmelkpicnic/16x9/actors/milkfactory/milk-factory.svg": [
		2946,
		9,
		2129
	],
	"./milkbottle/16x9/actors/astronautfactory/astronaut-landing-page.svg": [
		2947,
		9,
		2130
	],
	"./milkbottle/16x9/actors/cheesefactory/cheese-factory.svg": [
		2948,
		9,
		2131
	],
	"./milkbottle/16x9/actors/cow/heads/cow-list-popup-head-1.svg": [
		2949,
		9,
		2132
	],
	"./milkbottle/16x9/actors/cow/heads/cow-list-popup-head-10.svg": [
		2950,
		9,
		2133
	],
	"./milkbottle/16x9/actors/cow/heads/cow-list-popup-head-11.svg": [
		2951,
		9,
		2134
	],
	"./milkbottle/16x9/actors/cow/heads/cow-list-popup-head-2.svg": [
		2952,
		9,
		2135
	],
	"./milkbottle/16x9/actors/cow/heads/cow-list-popup-head-3.svg": [
		2953,
		9,
		2136
	],
	"./milkbottle/16x9/actors/cow/heads/cow-list-popup-head-4.svg": [
		2954,
		9,
		2137
	],
	"./milkbottle/16x9/actors/cow/heads/cow-list-popup-head-5.svg": [
		2955,
		9,
		2138
	],
	"./milkbottle/16x9/actors/cow/heads/cow-list-popup-head-6.svg": [
		2956,
		9,
		2139
	],
	"./milkbottle/16x9/actors/cow/heads/cow-list-popup-head-7.svg": [
		2957,
		9,
		2140
	],
	"./milkbottle/16x9/actors/cow/heads/cow-list-popup-head-8.svg": [
		2958,
		9,
		2141
	],
	"./milkbottle/16x9/actors/cow/heads/cow-list-popup-head-9.svg": [
		2959,
		9,
		2142
	],
	"./milkbottle/16x9/actors/cow/popup/heads/cow-list-popup-head-blaarkop-black.svg": [
		2960,
		9,
		2143
	],
	"./milkbottle/16x9/actors/cow/popup/heads/cow-list-popup-head-blaarkop-brown.svg": [
		2961,
		9,
		2144
	],
	"./milkbottle/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-black.svg": [
		2962,
		9,
		2145
	],
	"./milkbottle/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-brown.svg": [
		2963,
		9,
		2146
	],
	"./milkbottle/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-rainbow.svg": [
		2964,
		9,
		2147
	],
	"./milkbottle/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-white.svg": [
		2965,
		9,
		2148
	],
	"./milkbottle/16x9/actors/cow/popup/heads/cow-list-popup-head-jersey-brown.svg": [
		2966,
		9,
		2149
	],
	"./milkbottle/16x9/actors/cow/popup/heads/cow-list-popup-head-jersey-white.svg": [
		2967,
		9,
		2150
	],
	"./milkbottle/16x9/actors/cow/popup/heads/cow-list-popup-head-lakenvelder-black.svg": [
		2968,
		9,
		2151
	],
	"./milkbottle/16x9/actors/cow/popup/heads/cow-list-popup-head-lakenvelder-brown.svg": [
		2969,
		9,
		2152
	],
	"./milkbottle/16x9/actors/cow/popup/heads/cow-list-popup-head-maasRijn-brown.svg": [
		2970,
		9,
		2153
	],
	"./milkbottle/16x9/actors/cow/virtualFarmAvatars/cow-maas-rijn.svg": [
		2971,
		9,
		2154
	],
	"./milkbottle/16x9/actors/cow/virtualFarmAvatars/cowBlaarKop--one.svg": [
		2972,
		9,
		2155
	],
	"./milkbottle/16x9/actors/cow/virtualFarmAvatars/cowBlaarKop--two.svg": [
		2973,
		9,
		2156
	],
	"./milkbottle/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--one.svg": [
		2974,
		9,
		2157
	],
	"./milkbottle/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--three.svg": [
		2975,
		9,
		2158
	],
	"./milkbottle/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--two.svg": [
		2976,
		9,
		2159
	],
	"./milkbottle/16x9/actors/cow/virtualFarmAvatars/cowJersey--one.svg": [
		2977,
		9,
		2160
	],
	"./milkbottle/16x9/actors/cow/virtualFarmAvatars/cowJersey--two.svg": [
		2978,
		9,
		2161
	],
	"./milkbottle/16x9/actors/cow/virtualFarmAvatars/cowLakenvelder--one.svg": [
		2979,
		9,
		2162
	],
	"./milkbottle/16x9/actors/cow/virtualFarmAvatars/cowLakenvelder--two.svg": [
		2980,
		9,
		2163
	],
	"./milkbottle/16x9/actors/cow/virtualFarmAvatars/cowMaasRijn--one.svg": [
		2981,
		9,
		2164
	],
	"./milkbottle/16x9/actors/cow/virtualFarmAvatars/cowPride--one.svg": [
		2982,
		9,
		2165
	],
	"./milkbottle/16x9/actors/dairyfactory/dairy-robot-factory.svg": [
		2983,
		9,
		2166
	],
	"./milkbottle/16x9/actors/discovery/discoveryRobot.svg": [
		2984,
		9,
		2167
	],
	"./milkbottle/16x9/actors/farmer/farmer-female.svg": [
		2985,
		9,
		2168
	],
	"./milkbottle/16x9/actors/farmer/farmer-male.svg": [
		2986,
		9,
		2169
	],
	"./milkbottle/16x9/actors/grazeway/grazeway-door.svg": [
		2987,
		9,
		2170
	],
	"./milkbottle/16x9/actors/grazeway/grazeway-feature.svg": [
		2988,
		9,
		2171
	],
	"./milkbottle/16x9/actors/icecreamfactory/ice-cream-factory.svg": [
		2989,
		9,
		2172
	],
	"./milkbottle/16x9/actors/milkfactory/milk-factory-new-old.svg": [
		2990,
		7,
		2173
	],
	"./milkbottle/16x9/actors/milkfactory/milk-factory-new.svg": [
		2991,
		9,
		2174
	],
	"./milkbottle/16x9/actors/milkfactory/milk-factory.svg": [
		2992,
		9,
		2175
	],
	"./themagroen/16x9/actors/astronautfactory/astronaut-landing-page.svg": [
		2993,
		9,
		2176
	],
	"./themagroen/16x9/actors/cheesefactory/cheese-factory.svg": [
		2994,
		9,
		2177
	],
	"./themagroen/16x9/actors/cow/heads/cow-list-popup-head-1.svg": [
		2995,
		9,
		2178
	],
	"./themagroen/16x9/actors/cow/heads/cow-list-popup-head-10.svg": [
		2996,
		9,
		2179
	],
	"./themagroen/16x9/actors/cow/heads/cow-list-popup-head-11.svg": [
		2997,
		9,
		2180
	],
	"./themagroen/16x9/actors/cow/heads/cow-list-popup-head-2.svg": [
		2998,
		9,
		2181
	],
	"./themagroen/16x9/actors/cow/heads/cow-list-popup-head-3.svg": [
		2999,
		9,
		2182
	],
	"./themagroen/16x9/actors/cow/heads/cow-list-popup-head-4.svg": [
		3000,
		9,
		2183
	],
	"./themagroen/16x9/actors/cow/heads/cow-list-popup-head-5.svg": [
		3001,
		9,
		2184
	],
	"./themagroen/16x9/actors/cow/heads/cow-list-popup-head-6.svg": [
		3002,
		9,
		2185
	],
	"./themagroen/16x9/actors/cow/heads/cow-list-popup-head-7.svg": [
		3003,
		9,
		2186
	],
	"./themagroen/16x9/actors/cow/heads/cow-list-popup-head-8.svg": [
		3004,
		9,
		2187
	],
	"./themagroen/16x9/actors/cow/heads/cow-list-popup-head-9.svg": [
		3005,
		9,
		2188
	],
	"./themagroen/16x9/actors/cow/popup/heads/cow-list-popup-head-blaarkop-black.svg": [
		3006,
		9,
		2189
	],
	"./themagroen/16x9/actors/cow/popup/heads/cow-list-popup-head-blaarkop-brown.svg": [
		3007,
		9,
		2190
	],
	"./themagroen/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-black.svg": [
		3008,
		9,
		2191
	],
	"./themagroen/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-brown.svg": [
		3009,
		9,
		2192
	],
	"./themagroen/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-rainbow.svg": [
		3010,
		9,
		2193
	],
	"./themagroen/16x9/actors/cow/popup/heads/cow-list-popup-head-holstein-white.svg": [
		3011,
		9,
		2194
	],
	"./themagroen/16x9/actors/cow/popup/heads/cow-list-popup-head-jersey-brown.svg": [
		3012,
		9,
		2195
	],
	"./themagroen/16x9/actors/cow/popup/heads/cow-list-popup-head-jersey-white.svg": [
		3013,
		9,
		2196
	],
	"./themagroen/16x9/actors/cow/popup/heads/cow-list-popup-head-lakenvelder-black.svg": [
		3014,
		9,
		2197
	],
	"./themagroen/16x9/actors/cow/popup/heads/cow-list-popup-head-lakenvelder-brown.svg": [
		3015,
		9,
		2198
	],
	"./themagroen/16x9/actors/cow/popup/heads/cow-list-popup-head-maasRijn-brown.svg": [
		3016,
		9,
		2199
	],
	"./themagroen/16x9/actors/cow/virtualFarmAvatars/cow-maas-rijn.svg": [
		3017,
		9,
		2200
	],
	"./themagroen/16x9/actors/cow/virtualFarmAvatars/cowBlaarKop--one.svg": [
		3018,
		9,
		2201
	],
	"./themagroen/16x9/actors/cow/virtualFarmAvatars/cowBlaarKop--two.svg": [
		3019,
		9,
		2202
	],
	"./themagroen/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--one.svg": [
		3020,
		9,
		2203
	],
	"./themagroen/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--three.svg": [
		3021,
		9,
		2204
	],
	"./themagroen/16x9/actors/cow/virtualFarmAvatars/cowHolsteinFriesian--two.svg": [
		3022,
		9,
		2205
	],
	"./themagroen/16x9/actors/cow/virtualFarmAvatars/cowJersey--one.svg": [
		3023,
		9,
		2206
	],
	"./themagroen/16x9/actors/cow/virtualFarmAvatars/cowJersey--two.svg": [
		3024,
		9,
		2207
	],
	"./themagroen/16x9/actors/cow/virtualFarmAvatars/cowLakenvelder--one.svg": [
		3025,
		9,
		2208
	],
	"./themagroen/16x9/actors/cow/virtualFarmAvatars/cowLakenvelder--two.svg": [
		3026,
		9,
		2209
	],
	"./themagroen/16x9/actors/cow/virtualFarmAvatars/cowMaasRijn--one.svg": [
		3027,
		9,
		2210
	],
	"./themagroen/16x9/actors/cow/virtualFarmAvatars/cowPride--one.svg": [
		3028,
		9,
		2211
	],
	"./themagroen/16x9/actors/dairyfactory/dairy-robot-factory.svg": [
		3029,
		9,
		2212
	],
	"./themagroen/16x9/actors/discovery/discoveryRobot.svg": [
		3030,
		9,
		2213
	],
	"./themagroen/16x9/actors/farmer/farmer-female.svg": [
		3031,
		9,
		2214
	],
	"./themagroen/16x9/actors/farmer/farmer-male.svg": [
		3032,
		9,
		2215
	],
	"./themagroen/16x9/actors/grazeway/grazeway-door.svg": [
		3033,
		9,
		2216
	],
	"./themagroen/16x9/actors/grazeway/grazeway-feature.svg": [
		3034,
		9,
		2217
	],
	"./themagroen/16x9/actors/icecreamfactory/ice-cream-factory.svg": [
		3035,
		9,
		2218
	],
	"./themagroen/16x9/actors/milkfactory/milk-factory-new.svg": [
		3036,
		9,
		2219
	],
	"./themagroen/16x9/actors/milkfactory/milk-factory.svg": [
		3037,
		9,
		2220
	],
	"./themagroen/16x9/screens/ageSelection/age-selection-above-10.svg": [
		3038,
		9,
		2221
	],
	"./themagroen/16x9/screens/ageSelection/age-selection-under-10.svg": [
		3039,
		9,
		2222
	],
	"./themagroen/16x9/screens/cowCalmRobot/cow-calm-slide-button.svg": [
		3040,
		9,
		2223
	],
	"./themagroen/16x9/screens/cowOutro/leftButtonCowOutroPage.svg": [
		3041,
		9,
		2224
	],
	"./themagroen/16x9/screens/cowOutro/rightButtonCowOutroPage.svg": [
		3042,
		9,
		2225
	],
	"./themagroen/16x9/screens/cowParent/cow-father-info.svg": [
		3043,
		9,
		2226
	],
	"./themagroen/16x9/screens/cowParent/cow-mother-info.svg": [
		3044,
		9,
		2227
	],
	"./themagroen/16x9/stories/farmer/ending-point-button-revert.svg": [
		3045,
		9,
		2228
	],
	"./themagroen/16x9/stories/farmer/ending-point-button.svg": [
		3046,
		9,
		2229
	],
	"./themagroen/16x9/ui/buttons/button-with-arrow-down.svg": [
		3047,
		9,
		2230
	],
	"./themagroen/16x9/ui/buttons/button-with-arrow-up.svg": [
		3048,
		9,
		2231
	],
	"./themagroen/16x9/ui/buttons/cow-calm-slide-button.svg": [
		3049,
		9,
		2232
	],
	"./themagroen/16x9/ui/buttons/cow-gave-birth-button.svg": [
		3050,
		9,
		2233
	],
	"./themagroen/16x9/ui/buttons/red-button-popup-farmer.svg": [
		3051,
		9,
		2234
	],
	"./themagroen/16x9/ui/buttons/red-button.svg": [
		3052,
		9,
		2235
	],
	"./themagroen/16x9/ui/buttons/sign-button-left-background.svg": [
		3053,
		9,
		2236
	],
	"./themagroen/16x9/ui/buttons/sign-button-right-background.svg": [
		3054,
		9,
		2237
	],
	"./themagroen/16x9/ui/popup/close-popup-button.svg": [
		3055,
		9,
		2238
	],
	"./themagroen/16x9/ui/ribbon/ribbon.svg": [
		3056,
		9,
		2239
	],
	"./themagroen/16x9/ui/sidemenu/close-menu-button.svg": [
		3057,
		9,
		2240
	],
	"./themagroen/16x9/ui/sidemenu/menu-icon.svg": [
		3058,
		9,
		2241
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[2]).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 363;
module.exports = webpackAsyncContext;